(function() {
  window._artIntegrationLoaded = true;

  var SHOP = "everaftersupplies.com";
  var TOKEN = "68ebeb2f8b3657e671b0b2d21350e4c8";
  var API_URL = "https://" + SHOP + "/api/2024-10/graphql.json";

  var TREE = {
    "Flat-Carved Art": {
      artType: "flat",
      subs: {
        Angel: { handle: "flat_angel" },
        Animals: { handle: "flat_animals" },
        Children: { handle: "flat_children" },
        Hands: { handle: "flat_hands" },
        Floral: { handle: "flat_floral" }
      }
    },
    "Shape-Carved Art": {
      artType: "shape",
      subs: {
        Floral: { handle: "shape_floral" },
        Hands: { handle: "shape_hands" }
      }
    },
    "Laser Art": {
      artType: "laser",
      subs: {
        Children: {
          subs: {
            Scene: { handle: "laser_children_scene" },
            Spots: { handle: "laser_children_spots" }
          }
        },
        Marriage: {
          subs: {
            Scene: { handle: "laser_marriage_scene" },
            Spots: { handle: "laser_marriage_spots" }
          }
        },
        Nature: {
          subs: {
            Animals: { handle: "laser_nature_animals" },
            Floral: { handle: "laser_nature_floral" },
            Nautical: { handle: "laser_nature_nautical" },
            Scene: { handle: "laser_nature_scene" }
          }
        },
        "Farm & Western": {
          subs: {
            Scene: { handle: "laser_farmwestern_scene" },
            Spots: { handle: "laser_farmwestern_spots" }
          }
        },
        Patriotic: {
          subs: {
            "Military / Police / Fire": { handle: "laser_patriotic_military" },
            Scene: { handle: "laser_patriotic_scene" },
            Spots: { handle: "laser_patriotic_spots" }
          }
        }
      }
    },
    Bronze: {
      artType: "flat",
      handle: "bronze"
    }
  };

  var CATEGORY_THUMB_HANDLE = {
    "Flat-Carved Art": "flat_angel",
    "Shape-Carved Art": "shape_floral",
    "Laser Art": "laser_children_scene",
    Bronze: "bronze"
  };

  var entryCache = {};
  var allEntriesByHandle = null;
  var allEntriesByNorm = null;
  var allEntriesPromise = null;
  var CHARGE_PRODUCT_HANDLE = "custom-memorial-charge";
  var chargeVariantMapPromise = null;
  var state = {
    path: ["main"],
    uploads: [],
    layers: [],
    layerSeq: 0,
    activeLayerId: null,
    externalUploadKeys: {}
  };
  var initTries = 0;
  var maxInitTries = 80;
  var PRICE_MULTIPLIER = 3;
  var PRICE_INPUTS = {
    text: 150,
    vaseEach: 64.9,
    uploadEach: 380,
    flatArtEach: 80,
    shapeArtEach: 80,
    laserSceneEach: 200,
    laserSpotsEach: 150,
    bronzeNicheEach: 75,
    bronzeMarkerEach: 150
  };
  var PRICE_BOOK = {
    text: roundPrice(PRICE_INPUTS.text * PRICE_MULTIPLIER),
    vaseEach: roundPrice(PRICE_INPUTS.vaseEach * PRICE_MULTIPLIER),
    uploadEach: roundPrice(PRICE_INPUTS.uploadEach * PRICE_MULTIPLIER),
    flatArtEach: roundPrice(PRICE_INPUTS.flatArtEach * PRICE_MULTIPLIER),
    shapeArtEach: roundPrice(PRICE_INPUTS.shapeArtEach * PRICE_MULTIPLIER),
    laserSceneEach: roundPrice(PRICE_INPUTS.laserSceneEach * PRICE_MULTIPLIER),
    laserSpotsEach: roundPrice(PRICE_INPUTS.laserSpotsEach * PRICE_MULTIPLIER),
    bronzeNicheEach: roundPrice(PRICE_INPUTS.bronzeNicheEach * PRICE_MULTIPLIER),
    bronzeMarkerEach: roundPrice(PRICE_INPUTS.bronzeMarkerEach * PRICE_MULTIPLIER)
  };
  var VASE_PRICE_INPUTS = {
    "Bahama Blue": 66,
    "Black Galaxy": 80.3,
    "Blue Pearl": 93.5,
    "Catseye Brown": 78.1,
    "China Grey": 45.6,
    "Coffee Brown": 66,
    "Dark Cloud Grey": 44.1,
    "Impala Black": 62.7,
    "Impala Green": 66,
    "Imperial Rose": 45.6,
    "India Grey": 62.7,
    "India Mist": 62.7,
    "India Red": 78.1,
    "Indian Mahogany": 66,
    "Jet Black": 55,
    "Ocean Wave": 45.6,
    "Paradiso": 66,
    "Red Multicolor": 66,
    "Rustic Brown": 62.7,
    "Tan Brown": 62.65,
    "Tropical Green": 66,
    "New Imperial Grey": 37.8,
    "American Black": 208,
    "Barre Grey": 257,
    "Dakota Mahogany": 235,
    "Georgia Grey": 57,
    "North American Pink": 235
  };
  var BOTTOM_BASE_COLOR_GROUPS = [
    ["New Imperial Grey"],
    ["China Grey", "Ocean Wave", "Imperial Rose"],
    ["Dark Cloud Grey"],
    ["India Grey", "India Mist", "Impala Black", "Rustic Brown"],
    ["Impala Green", "Red Multicolor", "Indian Mahogany", "Tan Brown", "Bahama Blue", "Paradiso", "Coffee Brown", "Tropical Green", "Desert Rose"],
    ["Jet Black"],
    ["China Pink", "Butterfly Blue"],
    ["India Red", "Catseye Brown"],
    ["Aurora Red", "Black Galaxy"],
    ["Blue Pearl"]
  ];
  var BOTTOM_BASE_PRICE_TABLE = {
    "6": {
      option: "6-Inch Bases / 12-inch deep",
      rows: {
        24: ["2-0 x 1-0 x 0-6", [139, 152, 173, 190, 197, 198, 201, 227, 229, 334]],
        28: ["2-4 x 1-0 x 0-6", [163, 177, 202, 221, 229, 230, 234, 265, 267, 389]],
        30: ["2-6 x 1-0 x 0-6", [174, 190, 217, 237, 246, 241, 251, 284, 286, 417]],
        32: ["2-8 x 1-0 x 0-6", [180, 196, 224, 245, 254, 255, 259, 293, 296, 431]],
        34: ["2-10 x 1-0 x 0-6", [197, 215, 245, 269, 278, 273, 285, 321, 324, 473]],
        36: ["3-0 x 1-0 x 0-6", [209, 228, 260, 285, 287, 289, 301, 340, 343, 501]],
        40: ["3-4 x 1-0 x 0-6", [232, 253, 289, 316, 328, 321, 335, 378, 382, 556]],
        42: ["3-6 x 1-0 x 0-6", [244, 266, 303, 332, 344, 337, 351, 397, 401, 584]],
        48: ["4-0 x 1-0 x 0-6", [279, 304, 346, 380, 393, 385, 402, 454, 458, 668]],
        54: ["4-6 x 1-0 x 0-6", [314, 342, 390, 427, 442, 433, 452, 510, 515, 751]],
        60: ["5-0 x 1-0 x 0-6", [348, 379, 433, 475, 491, 481, 502, 567, 572, 834]],
        66: ["5-6 x 1-0 x 0-6", [383, 417, 476, 522, 540, 543, 552, 624, 630, 918]],
        72: ["6-0 x 1-0 x 0-6", [418, 455, 520, 626, 649, 652, 602, 748, 756, 1101]],
        78: ["6-6 x 1-0 x 0-6", [453, 493, 563, 679, 703, 706, 653, 811, 819, 1193]],
        84: ["7-0 x 1-0 x 0-6", [488, 531, 606, 731, 757, 760, 703, 873, 882, 1285]]
      }
    },
    "8": {
      option: "8-Inch Bases / 14-inch deep",
      rows: {
        24: ["2-0 x 1-2 x 0-8", [217, 236, 269, 280, 293, 293, 312, 341, 340, 493]],
        28: ["2-4 x 1-2 x 0-8", [253, 276, 314, 327, 342, 342, 364, 398, 397, 575]],
        30: ["2-6 x 1-2 x 0-8", [271, 295, 337, 350, 366, 367, 391, 427, 426, 616]],
        32: ["2-8 x 1-2 x 0-8", [289, 315, 359, 373, 391, 391, 417, 455, 454, 657]],
        34: ["2-10 x 1-2 x 0-8", [307, 335, 382, 397, 415, 415, 443, 483, 482, 698]],
        36: ["3-0 x 1-2 x 0-8", [325, 354, 404, 420, 440, 440, 469, 512, 511, 740]],
        40: ["3-4 x 1-2 x 0-8", [361, 394, 449, 467, 488, 489, 521, 569, 567, 822]],
        42: ["3-6 x 1-2 x 0-8", [379, 413, 472, 490, 513, 513, 547, 597, 596, 863]],
        44: ["3-8 x 1-2 x 0-8", [398, 433, 494, 513, 537, 538, 573, 626, 624, 904]],
        48: ["4-0 x 1-2 x 0-8", [434, 472, 539, 560, 586, 586, 625, 683, 681, 986]],
        50: ["4-2 x 1-2 x 0-8", [452, 492, 561, 583, 611, 611, 651, 711, 709, 1027]],
        54: ["4-6 x 1-2 x 0-8", [488, 531, 606, 630, 659, 643, 703, 768, 766, 1109]],
        60: ["5-0 x 1-2 x 0-8", [542, 590, 674, 700, 733, 715, 781, 853, 851, 1233]],
        66: ["5-6 x 1-2 x 0-8", [596, 649, 741, 770, 806, 806, 859, 938, 936, 1356]],
        72: ["6-0 x 1-2 x 0-8", [651, 708, 808, 924, 967, 968, 937, 1126, 1210, 1627]],
        78: ["6-6 x 1-2 x 0-8", [705, 767, 876, 1001, 1048, 1048, 1015, 1220, 1311, 1763]],
        84: ["7-0 x 1-2 x 0-8", [759, 827, 943, 1078, 1128, 1129, 1093, 1314, 1411, 1898]],
        90: ["7-6 x 1-2 x 0-8", [813, 886, 1011, 1207, 1264, 1265, 1172, 1472, 1656, 2126]],
        96: ["8-0 x 1-2 x 0-8", [867, 945, 1078, 1288, 1348, 1349, 1250, 1570, 1767, 2268]],
        108: ["9-0 x 1-2 x 0-8", [976, 1063, 1213, 1575, 1583, 1583, 1406, 1843, 2168, 2662]],
        120: ["10-0 x 1-2 x 0-8", [1084, 1181, 1347, 1820, 1905, 1906, 1562, 2218, 2610, 3205]]
      }
    }
  };
  var BOTTOM_BASE_SIZE_CHOICES = [
    { key: "36x6x20", size: "36\" x 6\" x 20\"", width: 36, depthKey: "6" },
    { key: "36x6x24", size: "36\" x 6\" x 24\"", width: 36, depthKey: "6" },
    { key: "36x8x24", size: "36\" x 8\" x 24\"", width: 36, depthKey: "8" },
    { key: "42x6x20", size: "42\" x 6\" x 20\"", width: 42, depthKey: "6" },
    { key: "42x6x24", size: "42\" x 6\" x 24\"", width: 42, depthKey: "6" },
    { key: "42x8x24", size: "42\" x 8\" x 24\"", width: 42, depthKey: "8" },
    { key: "42x8x26", size: "42\" x 8\" x 26\"", width: 42, depthKey: "8" },
    { key: "42x8x30", size: "42\" x 8\" x 30\"", width: 42, depthKey: "8" },
    { key: "44x8x26", size: "44\" x 8\" x 26\"", width: 44, depthKey: "8" },
    { key: "48x6x24", size: "48\" x 6\" x 24\"", width: 48, depthKey: "6" },
    { key: "48x8x30", size: "48\" x 8\" x 30\"", width: 48, depthKey: "8" },
    { key: "20x8x6", size: "20\" x 8\" x 6\"", baseSize: "20 x 8 x 6", baseOption: "Bottom Base", rawPrice: 105.6 },
    { key: "22x8x4", size: "22\" x 8\" x 4\"", baseSize: "22 x 8 x 4", baseOption: "Bottom Base", rawPrice: 90.2 },
    { key: "24x8x6", size: "24\" x 8\" x 6\"", baseSize: "24 x 8 x 6", baseOption: "Bottom Base", rawPrice: 129.8 },
    { key: "24x10x4", size: "24\" x 10\" x 4\"", baseSize: "24 x 10 x 4", baseOption: "Bottom Base", rawPrice: 129.8 },
    { key: "24x12x4", size: "24\" x 12\" x 4\"", baseSize: "24 x 12 x 4", baseOption: "Bottom Base", rawPrice: 165 },
    { key: "24x12x6", size: "24\" x 12\" x 6\"", baseSize: "24 x 12 x 6", baseOption: "Bottom Base", rawPrice: 217.8 },
    { key: "24x12x8", size: "24\" x 12\" x 8\"", baseSize: "24 x 12 x 8", baseOption: "Bottom Base", rawPrice: 276.1 },
    { key: "24x13x8", size: "24\" x 13\" x 8\"", baseSize: "24 x 13 x 8", baseOption: "Bottom Base", rawPrice: 299.2 },
    { key: "60x12x6", size: "60\" x 12\" x 6\"", baseSize: "60 x 12 x 6", baseOption: "Bottom Base", rawPrice: 529.1 },
    { key: "60x14x4", size: "60\" x 14\" x 4\"", baseSize: "60 x 14 x 4", baseOption: "Bottom Base", rawPrice: 447.7 },
    { key: "60x14x6", size: "60\" x 14\" x 6\"", baseSize: "60 x 14 x 6", baseOption: "Bottom Base", rawPrice: 633.6 },
    { key: "60x14x8", size: "60\" x 14\" x 8\"", baseSize: "60 x 14 x 8", baseOption: "Bottom Base", rawPrice: 786.5 },
    { key: "60x16x4", size: "60\" x 16\" x 4\"", baseSize: "60 x 16 x 4", baseOption: "Bottom Base", rawPrice: 488.4 },
    { key: "60x16x6", size: "60\" x 16\" x 6\"", baseSize: "60 x 16 x 6", baseOption: "Bottom Base", rawPrice: 723.8 },
    { key: "62x14x10", size: "62\" x 14\" x 10\"", baseSize: "62 x 14 x 10", baseOption: "Bottom Base", rawPrice: 864.6 },
    { key: "62x16x4", size: "62\" x 16\" x 4\"", baseSize: "62 x 16 x 4", baseOption: "Bottom Base", rawPrice: 623.2 },
    { key: "62x24x4", size: "62\" x 24\" x 4\"", baseSize: "62 x 24 x 4", baseOption: "Bottom Base", rawPrice: 847 },
    { key: "64x10x6", size: "64\" x 10\" x 6\"", baseSize: "64 x 10 x 6", baseOption: "Bottom Base", rawPrice: 349.8 },
    { key: "64x12x6", size: "64\" x 12\" x 6\"", baseSize: "64 x 12 x 6", baseOption: "Bottom Base", rawPrice: 548.9 },
    { key: "64x14x8", size: "64\" x 14\" x 8\"", baseSize: "64 x 14 x 8", baseOption: "Bottom Base", rawPrice: 729.3 },
    { key: "64x24x4", size: "64\" x 24\" x 4\"", baseSize: "64 x 24 x 4", baseOption: "Bottom Base", rawPrice: 676.5 },
    { key: "66x12x6", size: "66\" x 12\" x 6\"", baseSize: "66 x 12 x 6", baseOption: "Bottom Base", rawPrice: 597.3 },
    { key: "72x14x8", size: "72\" x 14\" x 8\"", width: 72, depthKey: "8" },
    { key: "78x14x8", size: "78\" x 14\" x 8\"", width: 78, depthKey: "8" },
    { key: "84x14x8", size: "84\" x 14\" x 8\"", width: 84, depthKey: "8" },
    { key: "90x14x8", size: "90\" x 14\" x 8\"", width: 90, depthKey: "8" },
    { key: "96x14x8", size: "96\" x 14\" x 8\"", width: 96, depthKey: "8" },
    { key: "108x14x8", size: "108\" x 14\" x 8\"", width: 108, depthKey: "8" },
    { key: "120x14x8", size: "120\" x 14\" x 8\"", width: 120, depthKey: "8" }
  ];
  var bottomBaseColorMatchers = null;
  var PRICE_RULES = {
    upload: {
      amount: PRICE_BOOK.uploadEach,
      mode: "per_layer",
      label: "Uploaded Art",
      uiText: "Upload Your Own Art"
    },
    flat_unlimited: {
      amount: PRICE_BOOK.flatArtEach,
      mode: "per_layer",
      label: "Flat-Carved Art",
      uiText: "Flat-Carved Art"
    },
    shape_unlimited: {
      amount: PRICE_BOOK.shapeArtEach,
      mode: "per_layer",
      label: "Shape-Carved Art",
      uiText: "Shape-Carved Art"
    },
    laser_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Laser Art",
      uiText: "Laser Art"
    },
    laser_spots: {
      amount: PRICE_BOOK.laserSpotsEach,
      mode: "per_layer",
      label: "Laser Art Spots",
      uiText: "Laser Art Spots"
    },
    laser_children_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Children Scene",
      uiText: "Children Scene"
    },
    laser_children_spots: {
      amount: PRICE_BOOK.laserSpotsEach,
      mode: "per_layer",
      label: "Children Spots",
      uiText: "Children Spots"
    },
    laser_farmwestern_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Farm & Western Scene",
      uiText: "Farm & Western Scene"
    },
    laser_farmwestern_spots: {
      amount: PRICE_BOOK.laserSpotsEach,
      mode: "per_layer",
      label: "Farm & Western Spots",
      uiText: "Farm & Western Spots"
    },
    laser_marriage_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Marriage Scene",
      uiText: "Marriage Scene"
    },
    laser_marriage_spots: {
      amount: PRICE_BOOK.laserSpotsEach,
      mode: "per_layer",
      label: "Marriage Spots",
      uiText: "Marriage Spots"
    },
    laser_nature_animals: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Nature Animals",
      uiText: "Nature Animals"
    },
    laser_nature_floral: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Nature Floral",
      uiText: "Nature Floral"
    },
    laser_nature_nautical: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Nature Nautical",
      uiText: "Nature Nautical"
    },
    laser_nature_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Nature Scene",
      uiText: "Nature Scene"
    },
    laser_patriotic_military: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Patriotic Military / Police / Fire",
      uiText: "Patriotic Military / Police / Fire"
    },
    laser_patriotic_scene: {
      amount: PRICE_BOOK.laserSceneEach,
      mode: "per_layer",
      label: "Patriotic Scene",
      uiText: "Patriotic Scene"
    },
    laser_patriotic_spots: {
      amount: PRICE_BOOK.laserSpotsEach,
      mode: "per_layer",
      label: "Patriotic Spots",
      uiText: "Patriotic Spots"
    },
    bronze_niche: {
      amount: PRICE_BOOK.bronzeNicheEach,
      mode: "per_layer",
      label: "Bronze Niche",
      uiText: "8 1/2 x 5 1/2 Bronze Niche"
    },
    bronze_marker: {
      amount: PRICE_BOOK.bronzeMarkerEach,
      mode: "per_layer",
      label: "Bronze Marker",
      uiText: "24 x 12 Bronze Marker"
    }
  };
  var HANDLE_PRICE_RULES = {
    laser_children_scene: "laser_children_scene",
    laser_children_spots: "laser_children_spots",
    laser_farmwestern_scene: "laser_farmwestern_scene",
    laser_farmwestern_spots: "laser_farmwestern_spots",
    laser_marriage_scene: "laser_marriage_scene",
    laser_marriage_spots: "laser_marriage_spots",
    laser_nature_animals: "laser_nature_animals",
    laser_nature_floral: "laser_nature_floral",
    laser_nature_nautical: "laser_nature_nautical",
    laser_nature_scene: "laser_nature_scene",
    laser_patriotic_military: "laser_patriotic_military",
    laser_patriotic_scene: "laser_patriotic_scene",
    laser_patriotic_spots: "laser_patriotic_spots"
  };

  function roundPrice(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
  }

  function formatMoney(value) {
    return "$" + roundPrice(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatPlusMoney(value) {
    return "+" + formatMoney(value);
  }

  function moneyKey(value) {
    return roundPrice(value).toFixed(2);
  }

  function numericVariantIdFromGid(gid) {
    var text = String(gid || "");
    var parts = text.split("/");
    return parts[parts.length - 1] || text;
  }

  function sfFetch(query, variables) {
    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    })
      .then(function(res) { return res.json(); })
      .then(function(json) {
        if (json && json.errors && json.errors.length) {
          throw new Error(json.errors[0].message || "Storefront GraphQL error");
        }
        return json && json.data ? json.data : {};
      });
  }

  function unique(values) {
    var seen = {};
    return values.filter(function(v) {
      if (!v || seen[v]) return false;
      seen[v] = true;
      return true;
    });
  }

  function normHandle(v) {
    return String(v || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function addTextFragment(fragments, value) {
    if (value === null || value === undefined) return;
    var text = String(value).replace(/\s+/g, " ").trim();
    if (text) fragments.push(text);
  }

  function getCurrentVariantId() {
    var liveInput = document.querySelector("form[action*=\"/cart/add\"] [name=\"id\"],select[name=\"id\"],input[name=\"id\"]");
    if (liveInput && liveInput.value) return liveInput.value;

    var span = document.getElementById("urnVariantId");
    if (span) return span.getAttribute("data-variant") || "";

    return "";
  }

  function addVariantObjectFragments(fragments, variant) {
    if (!variant) return;
    addTextFragment(fragments, variant.title);
    addTextFragment(fragments, variant.public_title);
    addTextFragment(fragments, variant.name);
    addTextFragment(fragments, variant.option1);
    addTextFragment(fragments, variant.option2);
    addTextFragment(fragments, variant.option3);

    if (variant.options && variant.options.length) {
      for (var i = 0; i < variant.options.length; i++) addTextFragment(fragments, variant.options[i]);
    }
  }

  function collectKnownVariantFragments(fragments) {
    var currentId = String(getCurrentVariantId() || "");
    if (!currentId) return;

    var sources = [];
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants) {
      sources.push(window.ShopifyAnalytics.meta.product.variants);
    }
    if (window.meta && window.meta.product && window.meta.product.variants) {
      sources.push(window.meta.product.variants);
    }
    if (window.product && window.product.variants) {
      sources.push(window.product.variants);
    }

    for (var s = 0; s < sources.length; s++) {
      var variants = sources[s] || [];
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (variant && String(variant.id || variant.variant_id || "") === currentId) {
          addVariantObjectFragments(fragments, variant);
          return;
        }
      }
    }
  }

  function getBottomBaseColorMatchers() {
    if (bottomBaseColorMatchers) return bottomBaseColorMatchers;

    var matchers = [];
    for (var g = 0; g < BOTTOM_BASE_COLOR_GROUPS.length; g++) {
      var names = BOTTOM_BASE_COLOR_GROUPS[g] || [];
      for (var i = 0; i < names.length; i++) {
        matchers.push({
          name: names[i],
          norm: normHandle(names[i]),
          group: "i" + (g + 1),
          groupIndex: g
        });
      }
    }

    matchers.sort(function(a, b) {
      return b.norm.length - a.norm.length;
    });
    bottomBaseColorMatchers = matchers;
    return bottomBaseColorMatchers;
  }

  function matchBottomBaseColor(text) {
    var haystack = normHandle(text);
    if (!haystack) return null;

    var matchers = getBottomBaseColorMatchers();
    for (var i = 0; i < matchers.length; i++) {
      var matcher = matchers[i];
      if (haystack === matcher.norm || haystack.indexOf(matcher.norm) >= 0) return matcher;
    }
    return null;
  }

  function collectBottomBaseColorFragments() {
    var cfg = window.memCustomizerConfig || {};
    var fragments = [];
    addTextFragment(fragments, cfg.selectedColor || cfg.variantColor || cfg.color);
    collectKnownVariantFragments(fragments);

    var selects = document.querySelectorAll("select");
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.id === "vaseColorSelect") continue;
      if (select.options && select.selectedIndex >= 0) {
        addTextFragment(fragments, select.options[select.selectedIndex].text);
        addTextFragment(fragments, select.options[select.selectedIndex].value);
      }
      addTextFragment(fragments, select.value);
    }

    var checked = document.querySelectorAll("input[type=\"radio\"]:checked,input[type=\"checkbox\"]:checked");
    for (var c = 0; c < checked.length; c++) {
      var input = checked[c];
      addTextFragment(fragments, input.value);
      addTextFragment(fragments, input.getAttribute("data-value"));
      addTextFragment(fragments, input.getAttribute("data-option-value"));
      if (input.parentNode) addTextFragment(fragments, input.parentNode.textContent);
    }

    var selected = document.querySelectorAll("[aria-pressed=\"true\"],[aria-selected=\"true\"],.is-selected,.selected,.active");
    for (var a = 0; a < selected.length && a < 80; a++) {
      var el = selected[a];
      addTextFragment(fragments, el.textContent);
      addTextFragment(fragments, el.getAttribute("title"));
      addTextFragment(fragments, el.getAttribute("aria-label"));
      addTextFragment(fragments, el.getAttribute("data-value"));
      addTextFragment(fragments, el.getAttribute("data-option-value"));
      addTextFragment(fragments, el.getAttribute("data-color"));
    }

    var bodyText = document.body ? (document.body.innerText || document.body.textContent || "") : "";
    var bodyMatch = String(bodyText).match(/(?:^|\n|\r)\s*(?:Color|Colour)\s*:\s*([^\n\r]+)/i);
    if (bodyMatch && bodyMatch[1]) addTextFragment(fragments, bodyMatch[1]);

    addTextFragment(fragments, getProductTitleText());
    return fragments;
  }

  function detectSelectedBottomBaseColor() {
    var fragments = collectBottomBaseColorFragments();
    for (var i = 0; i < fragments.length; i++) {
      var match = matchBottomBaseColor(fragments[i]);
      if (match) return match;
    }
    return null;
  }

  function getMemorialColorNames() {
    var names = [];
    var seen = {};
    for (var g = 0; g < BOTTOM_BASE_COLOR_GROUPS.length; g++) {
      var group = BOTTOM_BASE_COLOR_GROUPS[g] || [];
      for (var i = 0; i < group.length; i++) {
        if (!seen[group[i]]) {
          seen[group[i]] = true;
          names.push(group[i]);
        }
      }
    }
    return names;
  }

  function getDefaultVaseColorName() {
    var vaseColor = detectVaseColorFromFileName();
    if (vaseColor) return vaseColor;
    var color = detectSelectedBottomBaseColor();
    if (color && color.name && VASE_PRICE_INPUTS[color.name] !== undefined) return color.name;
    return getVaseColorNames()[0] || "";
  }

  function getSelectedVaseColorName() {
    return getDefaultVaseColorName();
  }

  function getVaseColorNames() {
    return Object.keys(VASE_PRICE_INPUTS);
  }

  function getVaseImageSourceText() {
    var cfg = window.memCustomizerConfig || {};
    var values = [];
    addTextFragment(values, cfg.imgVase);
    if (typeof window.getVaseImageSrc === "function") addTextFragment(values, window.getVaseImageSrc());
    var bridge = document.getElementById("memMetaBridge");
    if (bridge) addTextFragment(values, bridge.getAttribute("data-img-vase"));
    var vaseImg = document.querySelector("#vaseLeft,#vaseRight");
    if (vaseImg) addTextFragment(values, vaseImg.currentSrc || vaseImg.src);
    return values.join(" ");
  }

  function detectVaseColorFromFileName() {
    var text = "";
    try {
      text = decodeURIComponent(getVaseImageSourceText());
    } catch (err) {
      text = getVaseImageSourceText();
    }
    var haystack = normHandle(text);
    if (!haystack) return "";

    var colors = getVaseColorNames().slice().sort(function(a, b) {
      return normHandle(b).length - normHandle(a).length;
    });

    for (var i = 0; i < colors.length; i++) {
      if (haystack.indexOf(normHandle(colors[i])) >= 0) return colors[i];
    }
    return "";
  }

  function formatDimensionNumber(value) {
    var n = Number(value) || 0;
    if (Math.abs(n - Math.round(n)) < 0.01) return String(Math.round(n));
    return String(roundPrice(n)).replace(/\.00$/, "");
  }

  function formatHeadstoneDimensions(dims) {
    if (!dims) return "";
    return formatDimensionNumber(dims.width) + "\" x " + formatDimensionNumber(dims.depth) + "\" x " + formatDimensionNumber(dims.height) + "\"";
  }

  function getHeadstoneFinishType() {
    var match = String(getProductTitleText() || "").match(/(OP5|P[235]\s*\/\s*BRP|P[235])\b/i);
    if (!match) return "";

    var clean = String(match[1] || "").toUpperCase().replace(/\s+/g, "");
    if (clean.indexOf("OP5") >= 0) return "OP5";
    if (clean.indexOf("P5") >= 0) return "P5/BRP";
    if (clean.indexOf("P3") >= 0) return "P3/BRP";
    if (clean.indexOf("P2") >= 0) return "P2/BRP";
    return clean;
  }

  function normalizeBottomBaseSizeKey(sizeText) {
    return String(sizeText || "")
      .toLowerCase()
      .replace(/["\s]/g, "")
      .replace(/inch|in/g, "")
      .replace(/×/g, "x");
  }

  function findBottomBaseChoiceByKey(key) {
    for (var i = 0; i < BOTTOM_BASE_SIZE_CHOICES.length; i++) {
      if (BOTTOM_BASE_SIZE_CHOICES[i].key === key) return BOTTOM_BASE_SIZE_CHOICES[i];
    }
    return null;
  }

  function getDefaultBottomBaseChoice() {
    var dims = getStoneDimensions();
    if (dims && dims.width > 0 && dims.depth > 0 && dims.height > 0) {
      var key = normalizeBottomBaseSizeKey(formatHeadstoneDimensions(dims));
      var choice = findBottomBaseChoiceByKey(key);
      if (choice) return choice;
    }
    return BOTTOM_BASE_SIZE_CHOICES[0] || null;
  }

  function getSelectedBottomBaseChoice() {
    var select = document.getElementById("baseSizeSelect");
    var key = select && select.value ? select.value : "";
    return findBottomBaseChoiceByKey(key) || getDefaultBottomBaseChoice();
  }

  function getBottomBaseChoicePriceRow(choice) {
    if (!choice) return null;
    if (choice.rawPrice !== undefined) return [choice.baseSize || choice.size, [Number(choice.rawPrice) || 0]];
    var table = BOTTOM_BASE_PRICE_TABLE[choice.depthKey];
    return table && table.rows ? table.rows[String(choice.width)] : null;
  }

  function getBottomBaseChoiceLabel(choice, color) {
    if (!choice) return "";
    var row = getBottomBaseChoicePriceRow(choice);
    var baseSize = row && row[0] ? row[0] : "";
    var price = 0;
    if (choice.rawPrice !== undefined) price = roundPrice((Number(choice.rawPrice) || 0) * PRICE_MULTIPLIER);
    else if (row && row[1] && color) price = roundPrice((Number(row[1][color.groupIndex]) || 0) * PRICE_MULTIPLIER);
    return choice.size + (baseSize ? " / Base " + baseSize : "") + (price > 0 ? " - " + formatMoney(price) : "");
  }

  function getBottomBaseQuote() {
    var dims = getStoneDimensions();
    var color = detectSelectedBottomBaseColor();
    var finish = getHeadstoneFinishType();
    var selectedChoice = getSelectedBottomBaseChoice();
    var quote = {
      available: hasBottomBaseOption(),
      selected: false,
      color: color ? color.name : "",
      colorGroup: color ? color.group : "",
      finish: finish,
      headstoneSize: selectedChoice ? selectedChoice.size : (dims ? formatHeadstoneDimensions(dims) : ""),
      baseSize: "",
      baseOption: "",
      rawPrice: 0,
      displayPrice: 0,
      price: 0,
      reason: ""
    };

    if (!quote.available) {
      quote.reason = "No base image";
      return quote;
    }
    if (!selectedChoice && (!dims || !(dims.width > 0))) {
      quote.reason = "Size missing";
      return quote;
    }
    if (!color && !(selectedChoice && selectedChoice.rawPrice !== undefined)) {
      quote.reason = "Color missing";
      return quote;
    }

    var table = selectedChoice ? BOTTOM_BASE_PRICE_TABLE[selectedChoice.depthKey] : null;
    var row = getBottomBaseChoicePriceRow(selectedChoice);
    if (!row) {
      quote.reason = "Size unavailable";
      return quote;
    }

    var rawPrice = selectedChoice && selectedChoice.rawPrice !== undefined
      ? Number(selectedChoice.rawPrice) || 0
      : (row[1] ? Number(row[1][color.groupIndex]) || 0 : 0);
    quote.baseSize = row[0] || "";
    quote.baseOption = (selectedChoice && selectedChoice.baseOption) || (table ? table.option : "") || "";
    quote.rawPrice = rawPrice;
    quote.displayPrice = roundPrice(rawPrice * PRICE_MULTIPLIER);
    return quote;
  }

  function getBottomBasePricing() {
    var quote = getBottomBaseQuote();
    quote.selected = quote.available && isBottomBaseSelected();
    quote.price = quote.selected ? quote.displayPrice : 0;
    return quote;
  }

  function cleanUrl(url) {
    if (!url || typeof url !== "string") return null;
    var u = url.trim();
    if (!u) return null;
    if (u.indexOf("gid://") === 0) return null;
    if (u.indexOf("//") === 0) return "https:" + u;
    if (u.indexOf("http://") === 0) return "https://" + u.slice(7);
    if (u.indexOf("https://") === 0) return u;
    if (/\.(png|jpe?g|webp|gif|svg)$/i.test(u) && u.indexOf("/") === -1) {
      return "https://" + SHOP + "/cdn/shop/files/" + encodeURIComponent(u);
    }
    return null;
  }

  function normalizeFields(fields) {
    var urlByKey = {};
    var gidByKey = {};
    var orderedGids = [];

    (fields || []).forEach(function(f) {
      if (!f || !f.key || f.key.indexOf("img_") !== 0) return;

      if (f.reference && f.reference.image && f.reference.image.url) {
        urlByKey[f.key] = cleanUrl(f.reference.image.url);
      } else if (f.reference && f.reference.url) {
        urlByKey[f.key] = cleanUrl(f.reference.url);
      } else if (f.references && f.references.edges && f.references.edges.length) {
        var n = f.references.edges[0].node;
        if (n && n.image && n.image.url) urlByKey[f.key] = cleanUrl(n.image.url);
        else if (n && n.url) urlByKey[f.key] = cleanUrl(n.url);
      }

      if (!urlByKey[f.key] && f.value) {
        var fromValue = cleanUrl(f.value);
        if (fromValue) urlByKey[f.key] = fromValue;
      }

      if (!urlByKey[f.key] && f.value && String(f.value).indexOf("gid://") === 0) {
        gidByKey[f.key] = f.value;
        orderedGids.push(f.value);
      }
    });

    return {
      direct: urlByKey,
      gidByKey: gidByKey,
      orderedGids: unique(orderedGids)
    };
  }

  function resolveGids(gidByKey, orderedGids, directMap) {
    if (!orderedGids.length) return Promise.resolve(directMap || {});
    var q = "query($ids:[ID!]!){nodes(ids:$ids){... on MediaImage{id image{url}} ... on GenericFile{id url}}}";
    return sfFetch(q, { ids: orderedGids }).then(function(data) {
      var byId = {};
      (data.nodes || []).forEach(function(n) {
        if (!n || !n.id) return;
        if (n.image && n.image.url) byId[n.id] = cleanUrl(n.image.url);
        else if (n.url) byId[n.id] = cleanUrl(n.url);
      });
      var merged = {};
      Object.keys(gidByKey || {}).forEach(function(k) {
        merged[k] = byId[gidByKey[k]] || null;
      });
      var finalMap = {};
      unique(Object.keys(directMap || {}).concat(Object.keys(merged))).forEach(function(k) {
        finalMap[k] = (directMap && directMap[k]) || merged[k] || null;
      });
      return finalMap;
    });
  }

  function loadAllEntries() {
    if (allEntriesByHandle) return Promise.resolve(allEntriesByHandle);
    if (allEntriesPromise) return allEntriesPromise;

    var q =
      "query{" +
      "metaobjects(type:\"art_images\",first:100){" +
      "edges{" +
      "node{" +
      "handle " +
      "fields{" +
      "key value " +
      "reference{... on MediaImage{image{url}} ... on GenericFile{url}} " +
      "references(first:10){edges{node{... on MediaImage{image{url}} ... on GenericFile{url}}}}" +
      "}" +
      "}" +
      "}" +
      "}" +
      "}";

    allEntriesPromise = sfFetch(q)
      .then(function(data) {
        var edges = data.metaobjects && data.metaobjects.edges ? data.metaobjects.edges : [];
        var byHandle = {};
        var byNorm = {};
        var pending = [];

        edges.forEach(function(edge) {
          var node = edge && edge.node ? edge.node : null;
          if (!node || !node.handle) return;
          var normalized = normalizeFields(node.fields || []);
          pending.push(
            resolveGids(normalized.gidByKey, normalized.orderedGids, normalized.direct).then(function(finalMap) {
              byHandle[node.handle] = finalMap || {};
              byNorm[normHandle(node.handle)] = finalMap || {};
            })
          );
        });

        return Promise.all(pending).then(function() {
          allEntriesByHandle = byHandle;
          allEntriesByNorm = byNorm;
          return byHandle;
        });
      }, function(err) {
        console.error("[art_integration] Failed loading entries:", err);
        allEntriesByHandle = {};
        allEntriesByNorm = {};
        return {};
      })
      ;

    return allEntriesPromise;
  }

  function entryFieldsByHandle(handle) {
    if (entryCache[handle]) return Promise.resolve(entryCache[handle]);
    return loadAllEntries().then(function(map) {
      if (map && map[handle]) {
        entryCache[handle] = map[handle];
        return map[handle];
      }
      var nkey = normHandle(handle);
      if (allEntriesByNorm && allEntriesByNorm[nkey]) {
        entryCache[handle] = allEntriesByNorm[nkey];
        return allEntriesByNorm[nkey];
      }
      entryCache[handle] = {};
      return {};
    });
  }

  function firstHandleInNode(node) {
    if (!node) return null;
    if (node.handle) return node.handle;
    if (!node.subs) return null;
    var keys = Object.keys(node.subs);
    if (!keys.length) return null;
    return firstHandleInNode(node.subs[keys[0]]);
  }

  function collectHandles(node, out) {
    if (!node) return out;
    if (node.handle) {
      out.push(node.handle);
      return out;
    }
    if (node.subs) {
      Object.keys(node.subs).forEach(function(k) {
        collectHandles(node.subs[k], out);
      });
    }
    return out;
  }

  function firstImageFromFields(fields) {
    if (!fields) return null;
    for (var i = 1; i <= 5; i++) {
      var v = fields["img_" + i];
      if (v) return v;
    }
    return null;
  }

  function firstImageByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return entryFieldsByHandle(handle).then(function(fields) {
      return firstImageFromFields(fields);
    });
  }

  function firstThumbForNode(node) {
    var handle = firstHandleInNode(node);
    if (!handle) return Promise.resolve(null);
    return firstImageByHandle(handle).then(function(img) {
      if (img) return img;
      var all = collectHandles(node, []);
      if (!all.length) return null;
      var chain = Promise.resolve(null);
      all.forEach(function(h) {
        chain = chain.then(function(found) {
          if (found) return found;
          return firstImageByHandle(h);
        });
      });
      return chain;
    });
  }

  function pathNode(path) {
    if (!path || path[0] !== "main" || path.length === 1) return null;
    var node = TREE[path[1]];
    if (!node) return null;
    for (var i = 2; i < path.length; i++) {
      if (!node.subs) return null;
      node = node.subs[path[i]];
      if (!node) return null;
    }
    return node;
  }

  function currentCrumb(path) {
    if (!path || path.length === 1) return "Art";
    return "Art / " + path.slice(1).join(" / ");
  }

  function getModalState() {
    if (!window.state) window.state = {};
    return window.state;
  }

  function getArtZone() {
    return document.getElementById("engZone");
  }

  function getArtSizePercent() {
    var modalState = getModalState();
    if (modalState && modalState.artSize) return parseFloat(modalState.artSize) || 24;
    var sizeSel = document.getElementById("artSizeSelect");
    if (sizeSel && sizeSel.value) return parseFloat(sizeSel.value) || 24;
    return 24;
  }

  function getInitialLayerWidth(isBronzeLayer, priceKey, fileObj) {
    if (isBronzeLayer) return priceKey === "bronze_marker" ? 42 : 18;

    var pct = getArtSizePercent();
    if (fileObj && fileObj.uploadLift) {
      var layout = getStoneLayoutProfile();
      if (layout.familyKey === "flush_marker" || layout.type === "marker") return Math.min(pct, 14);
      if (layout.type === "low_wide" || layout.type === "wide") return Math.min(pct, 18);
    }

    return pct;
  }

  function getActiveLayer() {
    if (!state.layers.length) return null;
    var activeId = state.activeLayerId || state.layers[state.layers.length - 1].id;
    for (var i = 0; i < state.layers.length; i++) {
      if (state.layers[i].id === activeId) return state.layers[i];
    }
    return state.layers[state.layers.length - 1];
  }

  function getRuleByKey(key) {
    return PRICE_RULES[key] || PRICE_RULES.flat_unlimited;
  }

  function isUploadFile(fileObj) {
    return !!(fileObj && fileObj.type);
  }

  function resolvePricingKey(node, fileObj, label) {
    var handle = node && node.handle ? String(node.handle).toLowerCase() : "";
    var joinedPath = state.path && state.path.length > 1 ? state.path.slice(1).join(" / ").toLowerCase() : "";
    var labelText = String(label || "").toLowerCase();
    var combined = [handle, joinedPath, labelText].join(" ");

    if (isUploadFile(fileObj)) return "upload";
    if (handle && HANDLE_PRICE_RULES[handle]) return HANDLE_PRICE_RULES[handle];
    if (combined.indexOf("bronze") >= 0) {
      if (combined.indexOf("marker") >= 0 || combined.indexOf("24x12") >= 0 || combined.indexOf("24 x 12") >= 0) return "bronze_marker";
      if (combined.indexOf("niche") >= 0 || combined.indexOf("8 1/2") >= 0 || combined.indexOf("5 1/2") >= 0) return "bronze_niche";
      return "bronze_niche";
    }
    if (combined.indexOf("laser") >= 0) {
      if (combined.indexOf("spots") >= 0) return "laser_spots";
      return "laser_scene";
    }
    if ((node && node.artType === "shape") || combined.indexOf("shape") >= 0) return "shape_unlimited";
    return "flat_unlimited";
  }

  function inferBronzeKeyFromImage(imgEl) {
    if (!imgEl || !imgEl.naturalWidth || !imgEl.naturalHeight) return "bronze_niche";
    var aspect = imgEl.naturalWidth / imgEl.naturalHeight;
    return aspect >= 1.75 ? "bronze_marker" : "bronze_niche";
  }

  function buildLayerPricing(node, fileObj, label) {
    var key = resolvePricingKey(node, fileObj, label);
    var rule = getRuleByKey(key);
    return {
      key: key,
      amount: rule.amount,
      mode: rule.mode,
      label: rule.label
    };
  }

  function summarizeArtPricing() {
    var modalState = getModalState();
    var counts = {};
    var lines = [];
    var total = 0;

    if (!state.layers.length) {
      if (modalState && modalState.hasPhoto) {
        var fallbackKey = "flat_unlimited";
        if (modalState.artType === "shape") fallbackKey = "shape_unlimited";
        else if (modalState.artType === "laser") fallbackKey = "laser_scene";
        else if (modalState.artType === "porcelain") fallbackKey = "upload";
        else if (modalState.artType === "bronze") fallbackKey = "bronze_niche";

        var fallbackRule = getRuleByKey(fallbackKey);
        return {
          count: 1,
          total: fallbackRule.amount,
          lines: [{
            key: fallbackKey,
            count: 1,
            amount: fallbackRule.amount,
            total: fallbackRule.amount,
            mode: fallbackRule.mode,
            label: fallbackRule.label
          }]
        };
      }

      return {
        count: 0,
        total: 0,
        lines: []
      };
    }

    state.layers.forEach(function(layer) {
      var key = layer && layer.priceKey ? layer.priceKey : resolvePricingKey(null, layer ? layer.fileObj : null, layer ? layer.label : "");
      counts[key] = (counts[key] || 0) + 1;
    });

    Object.keys(counts).forEach(function(key) {
      var rule = getRuleByKey(key);
      var count = counts[key];
      var lineTotal = rule.mode === "unlimited" ? rule.amount : roundPrice(rule.amount * count);
      total += lineTotal;
      lines.push({
        key: key,
        count: count,
        amount: rule.amount,
        total: lineTotal,
        mode: rule.mode,
        label: rule.label
      });
    });

    lines.sort(function(a, b) {
      return a.label.localeCompare(b.label);
    });

    return {
      count: state.layers.length,
      total: roundPrice(total),
      lines: lines
    };
  }

  function describePricingLine(line) {
    if (!line) return "";
    if (line.mode === "unlimited") return line.label + " (unlimited) " + formatPlusMoney(line.total);
    return line.label + " x" + line.count + " " + formatPlusMoney(line.total);
  }

  function loadChargeVariantMap() {
    if (chargeVariantMapPromise) return chargeVariantMapPromise;

    chargeVariantMapPromise = fetch("/products/" + CHARGE_PRODUCT_HANDLE + ".js")
      .then(function(res) {
        if (!res.ok) throw new Error("Charge product JSON unavailable: " + res.status);
        return res.json();
      })
      .then(function(product) {
        var nodes = product && product.variants ? product.variants : [];
        var map = {};
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i] || {};
          var amount = node.price !== undefined ? (Number(node.price) / 100) : "";
          var key = moneyKey(amount);
          if (key && node.id) {
            if (!map[key]) map[key] = [];
            map[key].push({
              id: String(node.id),
              title: node.title || "",
              sku: node.sku || "",
              price: key
            });
          }
        }
        if (!Object.keys(map).length) {
          throw new Error("Charge product has no variants: " + CHARGE_PRODUCT_HANDLE);
        }
        return map;
      })
      .catch(function(jsonErr) {
        var query = "query ChargeProduct($handle: String!) { productByHandle(handle: $handle) { variants(first: 100) { nodes { id title sku price { amount } } } } }";
        return sfFetch(query, { handle: CHARGE_PRODUCT_HANDLE }).then(function(data) {
          var product = data && data.productByHandle;
          var nodes = product && product.variants && product.variants.nodes ? product.variants.nodes : [];
      var map = {};
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i] || {};
        var amount = node.price && node.price.amount !== undefined ? node.price.amount : "";
        var key = moneyKey(amount);
        if (key && node.id) {
          if (!map[key]) map[key] = [];
          map[key].push({
            id: numericVariantIdFromGid(node.id),
            title: node.title || "",
            sku: node.sku || "",
            price: key
          });
        }
      }
      if (!Object.keys(map).length) {
            throw jsonErr || new Error("Charge product not found or unavailable: " + CHARGE_PRODUCT_HANDLE);
      }
      return map;
        });
      })
      .catch(function(err) {
      chargeVariantMapPromise = null;
      throw err;
    });

    return chargeVariantMapPromise;
  }

  function normalizeChargeLabel(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function getChargeSearchTerms(properties) {
    var label = normalizeChargeLabel(properties && properties.For);
    if (label.indexOf("engraving") >= 0) return ["engraving"];
    if (label.indexOf("vase") >= 0) return ["vase"];
    if (label.indexOf("bottom") >= 0 || label.indexOf("base") >= 0) return ["bottom base", "base stone", "base"];
    if (label.indexOf("upload") >= 0 || label.indexOf("image") >= 0 || label.indexOf("your image") >= 0) return ["your image", "upload", "uploaded art"];
    if (label.indexOf("bronze") >= 0) return ["bronze"];
    if (label.indexOf("laser") >= 0) return ["laser"];
    if (label.indexOf("shape") >= 0) return ["shape"];
    if (label.indexOf("flat") >= 0 || label.indexOf("art") >= 0) return ["flat", "art"];
    return label ? [label] : [];
  }

  function pickChargeVariantId(chargeMap, priceKey, properties) {
    var bucket = chargeMap[priceKey];
    if (!bucket) return "";
    if (typeof bucket === "string") return bucket;
    if (!bucket.length) return "";

    var terms = getChargeSearchTerms(properties);
    for (var t = 0; t < terms.length; t++) {
      var term = normalizeChargeLabel(terms[t]);
      for (var i = 0; i < bucket.length; i++) {
        var candidate = normalizeChargeLabel((bucket[i].title || "") + " " + (bucket[i].sku || ""));
        if (candidate.indexOf(term) >= 0) return bucket[i].id;
      }
    }

    return bucket[0].id;
  }

  function addChargeLine(items, chargeMap, amount, quantity, properties) {
    var price = roundPrice(amount);
    var qty = Math.max(1, Number(quantity) || 1);
    if (!(price > 0)) return;

    var key = moneyKey(price);
    var variantId = pickChargeVariantId(chargeMap, key, properties || {});
    if (!variantId) throw new Error("Missing custom charge variant for $" + key);

    var chargeProperties = {};
    Object.keys(properties || {}).forEach(function(propKey) {
      chargeProperties[propKey] = properties[propKey];
    });
    chargeProperties["_Customization Charge"] = [
      chargeProperties.For || "Add-on",
      key,
      String(items.length + 1)
    ].join(" | ");

    items.push({
      id: variantId,
      quantity: qty,
      properties: chargeProperties
    });
  }

  function buildCartItemsWithCharges(mainVariantId, mainProperties, pricing) {
    return loadChargeVariantMap().then(function(chargeMap) {
      var items = [{
        id: mainVariantId,
        quantity: 1,
        properties: mainProperties
      }];

      if (pricing.text > 0) {
        addChargeLine(items, chargeMap, pricing.text, 1, {
          "For": "Engraving",
          "Main Product": getProductTitleText()
        });
      }

      if (pricing.art && pricing.art.lines && pricing.art.lines.length) {
        for (var i = 0; i < pricing.art.lines.length; i++) {
          var line = pricing.art.lines[i];
          var qty = line.mode === "unlimited" ? 1 : line.count;
          var amount = line.mode === "unlimited" ? line.total : line.amount;
          addChargeLine(items, chargeMap, amount, qty, {
            "For": line.label,
            "Art Selection": getArtSelectionSummary(),
            "Main Product": getProductTitleText()
          });
        }
      }

      if (pricing.vaseCount > 0) {
        addChargeLine(items, chargeMap, pricing.vaseUnitPrice, pricing.vaseCount, {
          "For": "Vase",
          "Vase Color": pricing.vaseColor || "N/A",
          "Main Product": getProductTitleText()
        });
      }

      if (pricing.bottomBase && pricing.bottomBase.price > 0) {
        addChargeLine(items, chargeMap, pricing.bottomBase.price, 1, {
          "For": "Bottom Base",
          "Base Stone Size": pricing.bottomBase.baseSize || "N/A",
          "Base Stone Option": pricing.bottomBase.baseOption || "N/A",
          "Base Stone Color": pricing.bottomBase.color || "N/A",
          "Base Stone For": pricing.bottomBase.headstoneSize || "N/A",
          "Main Product": getProductTitleText()
        });
      }

      return items;
    });
  }

  function getCustomerUploadEndpoint() {
    var cfg = window.memCustomizerConfig || {};
    return cfg.customerUploadEndpoint || cfg.uploadEndpoint || window.MEM_CUSTOMIZER_UPLOAD_ENDPOINT || "";
  }

  function getCustomerUploadPreset() {
    var cfg = window.memCustomizerConfig || {};
    return cfg.customerUploadPreset || cfg.uploadPreset || window.MEM_CUSTOMIZER_UPLOAD_PRESET || "";
  }

  function getUploadedCustomerFiles() {
    var files = [];
    var seen = [];

    state.layers.forEach(function(layer) {
      var file = layer && layer.fileObj;
      if (file && file.externalUploadUrl) {
        if (seen.indexOf(file.externalUploadUrl) >= 0) return;
        seen.push(file.externalUploadUrl);
        files.push({
          name: file.name || layer.label || "Customer upload",
          type: file.type || "",
          size: file.size || 0,
          url: file.externalUploadUrl,
          external: true
        });
        return;
      }

      if (!isUploadFile(file) || seen.indexOf(file) >= 0) return;
      seen.push(file);
      files.push({
        file: file,
        label: layer.label || file.name || "Customer upload"
      });
    });

    return files;
  }

  function extractUploadedFileUrl(json) {
    if (!json) return "";
    return json.secure_url || json.url || json.file_url || json.fileUrl || json.location || json.link || "";
  }

  function uploadCustomerFile(upload) {
    var endpoint = getCustomerUploadEndpoint();
    if (!endpoint || !upload || !upload.file) return Promise.resolve(null);

    var form = new FormData();
    form.append("file", upload.file, upload.file.name || "customer-upload");

    var preset = getCustomerUploadPreset();
    if (preset) form.append("upload_preset", preset);
    form.append("context", "source=memorial_customizer");

    return fetch(endpoint, {
      method: "POST",
      body: form
    })
      .then(function(res) {
        if (!res.ok) throw new Error("Upload failed " + res.status);
        return res.json();
      })
      .then(function(json) {
        return {
          name: upload.file.name || upload.label || "Customer upload",
          type: upload.file.type || "",
          size: upload.file.size || 0,
          url: extractUploadedFileUrl(json)
        };
      });
  }

  function uploadCustomerImagesForOrder() {
    var uploads = getUploadedCustomerFiles();
    if (!uploads.length) return Promise.resolve([]);

    var externalUploads = [];
    var localUploads = [];
    uploads.forEach(function(upload) {
      if (upload && upload.external) externalUploads.push(upload);
      else localUploads.push(upload);
    });

    var endpoint = getCustomerUploadEndpoint();
    if (!localUploads.length) return Promise.resolve(externalUploads);

    if (!endpoint) {
      return Promise.resolve(externalUploads.concat(localUploads.map(function(upload) {
        return {
          name: upload.file.name || upload.label || "Customer upload",
          type: upload.file.type || "",
          size: upload.file.size || 0,
          url: ""
        };
      })));
    }

    return Promise.all(localUploads.map(uploadCustomerFile)).then(function(uploaded) {
      return externalUploads.concat(uploaded);
    });
  }

  function addUploadedImageProperties(props, uploaded) {
    if (!uploaded || !uploaded.length) return props;

    var names = [];
    var urls = [];

    uploaded.forEach(function(item) {
      if (!item) return;
      if (item.name) names.push(item.name);
      if (item.url) urls.push(item.url);
    });

    props["Customer Uploaded Image"] = names.length ? names.join(" | ") : "Yes";
    props["Customer Uploaded Image URL"] = urls.length ? urls.join(" | ") : "Upload storage endpoint not configured";
    return props;
  }

  function mergeExternalLineItemProperties(props) {
    var fields = document.querySelectorAll('form[action*="/cart/add"] [name^="properties["], [data-upload-lift] [name^="properties["], .upload-lift [name^="properties["], .cl-upload [name^="properties["]');
    var foundUploadValue = "";

    fields.forEach(function(field) {
      var name = field.getAttribute("name") || "";
      var match = name.match(/^properties\[(.+)\]$/);
      if (!match || !match[1]) return;
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) return;

      var value = "";
      if (field.tagName === "SELECT" && field.options && field.selectedIndex >= 0) value = field.options[field.selectedIndex].text || field.value;
      else value = field.value || field.getAttribute("data-value") || "";

      value = String(value || "").trim();
      if (!value) return;

      var key = match[1].trim();
      if (!key || props[key] !== undefined) return;

      props[key] = value;
      if (/upload|file|image|photo|art/i.test(key + " " + value)) foundUploadValue = value;
    });

    if (foundUploadValue && (!props["Customer Uploaded Image URL"] || props["Customer Uploaded Image URL"] === "Upload storage endpoint not configured")) {
      props["Customer Uploaded Image URL"] = foundUploadValue;
    }

    return props;
  }

  function normalizeExternalUploadUrl(value) {
    var text = String(value || "").trim();
    if (!text) return "";

    var urlMatch = text.match(/https?:\/\/[^\s"'<>]+/i);
    if (urlMatch && urlMatch[0]) text = urlMatch[0];

    if (text.indexOf("//") === 0) return "https:" + text;
    if (/^https?:\/\//i.test(text) || /^data:image\//i.test(text) || /^blob:/i.test(text)) return text;
    return "";
  }

  function isLikelyExternalUploadContainer(el) {
    if (!el || !el.getAttribute) return false;
    var joined = [
      el.id,
      el.className,
      el.getAttribute("data-upload-lift"),
      el.getAttribute("data-app"),
      el.getAttribute("data-block-handle")
    ].join(" ").toLowerCase();

    if (joined.indexOf("upload-lift") >= 0 || joined.indexOf("uploadlift") >= 0 || joined.indexOf("uplift") >= 0 || joined.indexOf("cl-upload") >= 0) return true;

    var text = String(el.textContent || "").toLowerCase();
    return text.indexOf("upload your image") >= 0 || text.indexOf("upload complete") >= 0 || text.indexOf("drag & drop") >= 0 || text.indexOf("browse") >= 0;
  }

  function findExternalUploadContainers() {
    var selectors = [
      "[data-upload-lift]",
      "[class*='upload-lift']",
      "[id*='upload-lift']",
      "[class*='uploadlift']",
      "[id*='uploadlift']",
      "[class*='uplift']",
      "[id*='uplift']",
      ".cl-upload",
      "[class*='cl-upload']"
    ];
    var found = [];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (found.indexOf(el) < 0) found.push(el);
      });
    });

    if (!found.length) {
      var candidates = document.querySelectorAll("form[action*='/cart/add'] div, form[action*='/cart/add'] section, form[action*='/cart/add'] label");
      candidates.forEach(function(el) {
        if (found.length >= 8) return;
        if (isLikelyExternalUploadContainer(el) && found.indexOf(el) < 0) found.push(el);
      });
    }

    return found;
  }

  function extractExternalUploadProperty() {
    var fields = document.querySelectorAll('form[action*="/cart/add"] [name^="properties["], [data-upload-lift] [name^="properties["], .upload-lift [name^="properties["], .cl-upload [name^="properties["]');
    var best = null;

    fields.forEach(function(field) {
      var name = field.getAttribute("name") || "";
      var keyMatch = name.match(/^properties\[(.+)\]$/);
      var key = keyMatch && keyMatch[1] ? keyMatch[1] : "";
      if (!/upload|file|image|photo|art/i.test(key)) return;
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) return;

      var value = String(field.value || field.getAttribute("data-value") || "").trim();
      if (!value) return;

      var url = normalizeExternalUploadUrl(value);
      best = {
        name: key || "Customer Uploaded Image",
        url: url || value,
        propertyValue: value
      };
    });

    return best;
  }

  function getImageUrlFromBackground(el) {
    if (!el) return "";
    var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
    var bg = style ? style.backgroundImage : (el.style ? el.style.backgroundImage : "");
    var match = String(bg || "").match(/url\(["']?(.+?)["']?\)/i);
    return match && match[1] ? normalizeExternalUploadUrl(match[1]) : "";
  }

  function collectExternalUploadImageCandidates() {
    var containers = findExternalUploadContainers();
    var prop = extractExternalUploadProperty();
    var candidates = [];
    var seen = {};

    function addCandidate(src, name, propertyValue) {
      src = normalizeExternalUploadUrl(src);
      if (!src || seen[src]) return;
      if (/placeholder|spinner|loading|icon|logo/i.test(src)) return;
      seen[src] = true;
      candidates.push({
        src: src,
        name: name || "Customer Uploaded Image",
        propertyValue: propertyValue || (prop ? prop.propertyValue : "")
      });
    }

    containers.forEach(function(container) {
      container.querySelectorAll("img[src]").forEach(function(img) {
        var rect = img.getBoundingClientRect ? img.getBoundingClientRect() : { width: 0, height: 0 };
        var src = img.currentSrc || img.src || "";
        if ((rect.width && rect.width < 24) || (rect.height && rect.height < 24)) return;
        addCandidate(src, prop ? prop.name : (img.alt || "Customer Uploaded Image"), prop ? prop.propertyValue : "");
      });

      container.querySelectorAll("[style*='background']").forEach(function(el) {
        addCandidate(getImageUrlFromBackground(el), prop ? prop.name : "Customer Uploaded Image", prop ? prop.propertyValue : "");
      });
    });

    if (prop && normalizeExternalUploadUrl(prop.url)) addCandidate(prop.url, prop.name, prop.propertyValue);
    return candidates;
  }

  function importExternalUploadedImageIntoModal() {
    var modal = document.getElementById("memModal");
    if (modal && !modal.classList.contains("open")) return false;
    if (!getArtZone()) return false;

    var candidates = collectExternalUploadImageCandidates();
    if (!candidates.length) return false;

    var imported = false;
    candidates.forEach(function(candidate, idx) {
      var key = candidate.src || candidate.propertyValue || candidate.name;
      if (!key || state.externalUploadKeys[key]) return;

      var uploadDisplayName = "Your Image";
      state.externalUploadKeys[key] = true;
      state.uploads.push({
        src: candidate.src,
        name: uploadDisplayName,
        fileObj: {
          name: uploadDisplayName,
          type: "image/upload-lift",
          size: 0,
          externalUploadUrl: normalizeExternalUploadUrl(candidate.propertyValue) || candidate.src,
          uploadLift: true
        }
      });

      applySelection(candidate.src, uploadDisplayName, { artType: "flat" }, state.uploads[state.uploads.length - 1].fileObj);
      imported = true;
    });

    if (imported) renderBrowser();
    return imported;
  }

  function installExternalUploadAutoImport() {
    if (window._memExternalUploadAutoImportInstalled) return true;

    var modal = document.getElementById("memModal");
    if (!modal) return false;
    window._memExternalUploadAutoImportInstalled = true;

    function queueImport() {
      setTimeout(importExternalUploadedImageIntoModal, 120);
      setTimeout(importExternalUploadedImageIntoModal, 650);
    }

    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === "class" && modal.classList.contains("open")) {
            queueImport();
            break;
          }
        }
      });
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    document.addEventListener("click", function(e) {
      var target = e.target;
      if (!target || !target.closest) return;
      if (target.closest("#memModal")) return;
      if (target.closest("[data-open-mem], .mem-customize-btn, .customize-button, button")) queueImport();
    });

    document.addEventListener("change", function(e) {
      if (e.target && e.target.closest && e.target.closest("[data-upload-lift], .upload-lift, .cl-upload, form[action*='/cart/add']")) {
        setTimeout(importExternalUploadedImageIntoModal, 300);
      }
    });

    queueImport();
    return true;
  }

  function updateHtmlFromSection(sectionId, html) {
    if (!html) return;
    var target = document.getElementById("shopify-section-" + sectionId);
    if (target) {
      target.innerHTML = html;
      return;
    }

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var fresh = doc.getElementById("shopify-section-" + sectionId);
    target = document.getElementById(sectionId) || document.querySelector(sectionId);
    if (fresh && target) target.innerHTML = fresh.innerHTML;
  }

  function updateCartDrawerFromHtml(html) {
    if (!html) return false;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var currentDrawer = document.querySelector("cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]");
    var freshDrawer = doc.querySelector("cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]");

    if (currentDrawer && freshDrawer) {
      currentDrawer.innerHTML = freshDrawer.innerHTML;
      currentDrawer.className = freshDrawer.className;
      currentDrawer.classList.remove("is-empty", "empty");
      return true;
    }

    var currentInner = document.querySelector("cart-drawer .drawer__inner,#CartDrawer .drawer__inner,.cart-drawer .drawer__inner,cart-drawer .cart-drawer__inner,#CartDrawer .cart-drawer__inner,.cart-drawer__inner,[data-cart-drawer-content]");
    var freshInner = doc.querySelector("cart-drawer .drawer__inner,#CartDrawer .drawer__inner,.cart-drawer .drawer__inner,cart-drawer .cart-drawer__inner,#CartDrawer .cart-drawer__inner,.cart-drawer__inner,[data-cart-drawer-content]");
    if (currentInner && freshInner) {
      currentInner.innerHTML = freshInner.innerHTML;
      currentInner.className = freshInner.className;
      currentInner.classList.remove("is-empty", "empty");
      if (currentDrawer) currentDrawer.classList.remove("is-empty", "empty");
      return true;
    }

    var currentItems = document.querySelector("cart-drawer-items,#CartDrawer-CartItems,.cart-drawer__items,.drawer__contents,[data-cart-drawer-items]");
    var freshItems = doc.querySelector("cart-drawer-items,#CartDrawer-CartItems,.cart-drawer__items,.drawer__contents,[data-cart-drawer-items]");
    if (currentItems && freshItems) {
      currentItems.innerHTML = freshItems.innerHTML;
      if (currentDrawer) currentDrawer.classList.remove("is-empty", "empty");
      return true;
    }

    return false;
  }

  function getCartSectionsForRender() {
    var sections = ["cart-drawer", "cart-icon-bubble"];
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.getSectionsToRender === "function") {
      try {
        var themeSections = drawer.getSectionsToRender().map(function(section) {
          return section && section.id;
        }).filter(Boolean);
        sections = unique(sections.concat(themeSections));
      } catch (err) {}
    }
    return sections;
  }

  function buildSectionsQuery(sections) {
    return (sections || []).map(function(section) {
      return encodeURIComponent(section);
    }).join(",");
  }

  function updateCartSectionsFromMap(sections) {
    if (!sections) return false;
    var updatedDrawer = false;
    Object.keys(sections).forEach(function(sectionId) {
      var html = sections[sectionId];
      updateHtmlFromSection(sectionId, html);
      if (sectionId === "cart-drawer" || /cart/i.test(sectionId)) {
        updatedDrawer = updateCartDrawerFromHtml(html) || updatedDrawer;
      } else if (!updatedDrawer) {
        updatedDrawer = updateCartDrawerFromHtml(html) || updatedDrawer;
      }
    });
    return updatedDrawer;
  }

  function openCartDrawerAfterModalAdd() {
    var drawers = [
      document.querySelector("cart-drawer"),
      document.querySelector("#CartDrawer"),
      document.querySelector(".cart-drawer"),
      document.querySelector("[data-cart-drawer]")
    ].filter(Boolean);

    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];
      if (typeof drawer.open === "function") {
        drawer.open();
        return true;
      }
      drawer.classList.add("active", "animate", "is-open", "open");
      drawer.setAttribute("open", "");
      drawer.setAttribute("aria-hidden", "false");
    }

    var toggles = document.querySelectorAll('[aria-controls*="Cart"],[aria-controls*="cart"],a[href="/cart"],a[href$="/cart"],button[name="cart"],.header__icon--cart,.cart-link');
    for (var t = 0; t < toggles.length; t++) {
      var toggle = toggles[t];
      if (toggle.tagName === "A" && /\/cart\/?$/.test(toggle.getAttribute("href") || "") && !document.querySelector("cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]")) continue;
      toggle.click();
      return true;
    }

    return false;
  }

  function cartDrawerLooksEmpty() {
    var drawer = document.querySelector("cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]");
    if (!drawer) return false;
    var text = (drawer.innerText || drawer.textContent || "").replace(/\s+/g, " ").toLowerCase();
    return text.indexOf("you have no items") >= 0 || text.indexOf("shopping cart is empty") >= 0 || drawer.classList.contains("is-empty");
  }

  function recoverCartDisplayAfterModalAdd(cart) {
    if (!cart || !cart.item_count) return;
    if (!cartDrawerLooksEmpty()) return;

    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
    openCartDrawerAfterModalAdd();

    setTimeout(function() {
      if (!cartDrawerLooksEmpty()) return;
      window.location.href = "/cart";
    }, 700);
  }

  function markModalCartAddCompleted() {
    window._memModalCartAddCompletedAt = Date.now ? Date.now() : new Date().getTime();
  }

  function isRecentModalCartAdd() {
    var last = Number(window._memModalCartAddCompletedAt || 0);
    if (!last) return false;
    var now = Date.now ? Date.now() : new Date().getTime();
    return (now - last) < 30000;
  }

  function installRecentModalAddDuplicateGuard() {
    if (window._memRecentModalAddDuplicateGuardInstalled) return true;
    window._memRecentModalAddDuplicateGuardInstalled = true;

    function blockNativeAdd(e) {
      if (!isRecentModalCartAdd()) return;
      var target = e.target;
      if (!target || !target.closest) return;
      if (target.closest("#memModal")) return;

      var form = target.closest("form[action*='/cart/add']");
      var addButton = target.closest("button[type='submit'],button[name='add'],.product-form__submit,.add-to-cart");
      if (!form && !addButton) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
          openCartDrawerAfterModalAdd();
          recoverCartDisplayAfterModalAdd(cart);
        });
      return false;
    }

    document.addEventListener("click", blockNativeAdd, true);
    document.addEventListener("submit", blockNativeAdd, true);
    return true;
  }

  function renderNativeCartAfterModalAdd(addResponse) {
    if (!addResponse || !addResponse.sections) return false;

    var targets = [
      document.querySelector("cart-drawer"),
      document.querySelector("cart-notification"),
      document.querySelector("#CartDrawer"),
      document.querySelector(".cart-drawer")
    ].filter(Boolean);

    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      if (target && typeof target.renderContents === "function") {
        try {
          target.renderContents(addResponse);
          return true;
        } catch (err) {
          if (window.console && console.warn) console.warn("[art_integration] Native cart render failed:", err);
        }
      }
    }

    return false;
  }

  function refreshCartAfterModalAdd(addResponse) {
    var nativeRendered = renderNativeCartAfterModalAdd(addResponse);

    if (addResponse && addResponse.sections) updateCartSectionsFromMap(addResponse.sections);

    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { cart: cart } }));
        window.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));

        if (cart && typeof cart.item_count === "number") {
          var countEls = document.querySelectorAll(".cart-count-bubble span,.cart-count-bubble,[data-cart-count],.cart-count");
          countEls.forEach(function(el) {
            el.textContent = String(cart.item_count);
            el.classList.remove("hidden");
          });
        }
        return fetch("/cart?sections=" + buildSectionsQuery(getCartSectionsForRender()), { headers: { "Accept": "application/json" } });
      })
      .then(function(res) { return res && res.ok ? res.json() : null; })
      .then(function(sections) {
        if (sections) {
          var refreshedResponse = {
            id: addResponse && addResponse.id,
            sections: sections
          };
          updateCartSectionsFromMap(sections);
          nativeRendered = renderNativeCartAfterModalAdd(refreshedResponse) || nativeRendered;
        }
        setTimeout(openCartDrawerAfterModalAdd, 120);
        setTimeout(openCartDrawerAfterModalAdd, 450);
        setTimeout(function() {
          fetch("/cart.js", { headers: { "Accept": "application/json" } })
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(recoverCartDisplayAfterModalAdd);
        }, 900);
      }, function() {
        setTimeout(openCartDrawerAfterModalAdd, 120);
      });
  }

  function getPreviewPriceInfo() {
    var activeLayer = getActiveLayer();
    if (activeLayer) {
      var activeRule = getRuleByKey(activeLayer.priceKey);
      return {
        text: formatPlusMoney(activeRule.amount) + (activeRule.mode === "unlimited" ? " unlimited" : " per art"),
        helper: activeRule.uiText + (activeRule.mode === "unlimited" ? " price includes unlimited preset images" : " price applies per selected art"),
        key: activeLayer.priceKey
      };
    }

    if (!state.path || state.path.length <= 1) {
      return {
        text: "Varies",
        helper: "Upload your own art " + formatPlusMoney(PRICE_BOOK.uploadEach) + " per art"
      };
    }

    var node = pathNode(state.path);
    var key = resolvePricingKey(node, null, state.path.slice(1).join(" / "));
    var rule = getRuleByKey(key);

    if (state.path.length === 2 && state.path[1] === "Laser Art") {
      return {
        text: formatPlusMoney(PRICE_BOOK.laserSpotsEach) + " - " + formatPlusMoney(PRICE_BOOK.laserSceneEach) + " per art",
        helper: "Laser spots are lower than scenes"
      };
    }

    if (state.path.length === 2 && state.path[1] === "Bronze") {
      return {
        text: formatPlusMoney(PRICE_BOOK.bronzeNicheEach) + " - " + formatPlusMoney(PRICE_BOOK.bronzeMarkerEach) + " per art",
        helper: "Bronze niche and marker pricing vary by selected bronze image"
      };
    }

    if (node && node.subs && state.path[1] === "Laser Art") {
      var childKeys = Object.keys(node.subs);
      if (childKeys.indexOf("Spots") >= 0 && childKeys.indexOf("Scene") >= 0) {
        return {
          text: formatPlusMoney(PRICE_BOOK.laserSpotsEach) + " - " + formatPlusMoney(PRICE_BOOK.laserSceneEach) + " per art",
          helper: "Laser spots are lower than scenes"
        };
      }
    }

    return {
      text: formatPlusMoney(rule.amount) + (rule.mode === "unlimited" ? " unlimited" : " per art"),
      helper: rule.uiText + (rule.mode === "unlimited" ? " price includes unlimited preset images" : " price applies per selected art"),
      key: key
    };
  }

  function ensureBottomBasePriceRow() {
    var existing = document.getElementById("priceRowBottomBase");
    if (existing) return existing;

    var breakdown = document.querySelector(".price-breakdown");
    if (!breakdown) return null;

    var row = document.createElement("div");
    row.className = "price-item";
    row.id = "priceRowBottomBase";
    row.style.display = "none";
    row.innerHTML = '<span class="price-item-label">Base Stone</span><span class="price-item-value active" id="priceRowBottomBaseAmt"></span>';

    var vaseRow = document.getElementById("priceRowVase");
    if (vaseRow && vaseRow.parentNode === breakdown && vaseRow.nextSibling) breakdown.insertBefore(row, vaseRow.nextSibling);
    else if (vaseRow && vaseRow.parentNode === breakdown) breakdown.appendChild(row);
    else breakdown.appendChild(row);

    return row;
  }

  function refreshPricingUi() {
    var modalState = getModalState();
    var textRowValue = document.querySelector("#priceRowText .price-item-value");
    var artRow = document.getElementById("priceRowPhoto");
    var artRowLabel = artRow ? artRow.querySelector(".price-item-label") : null;
    var artRowAmt = document.getElementById("priceRowPhotoAmt");
    var artHeadline = document.getElementById("photoPrice");
    var uploadSub = document.getElementById("imgUploadSub");
    var vasePrice = document.getElementById("vaseTogglePrice");
    var vaseSub = document.getElementById("vaseToggleSub");
    var vaseUnitPrice = getVaseUnitPrice();

    if (textRowValue) textRowValue.textContent = formatPlusMoney(PRICE_BOOK.text);
    if (artRowLabel) artRowLabel.textContent = "Art";
    if (artRowAmt && (!state.layers.length || !modalState.hasPhoto)) artRowAmt.textContent = formatPlusMoney(0);
    if (vasePrice) vasePrice.textContent = formatPlusMoney(vaseUnitPrice) + " each";
    if (vaseSub && (!modalState || !modalState.vase)) vaseSub.textContent = "Click to add - click again for 2nd vase";

    var info = getPreviewPriceInfo();
    if (artHeadline) artHeadline.textContent = info.text;
    if (uploadSub) uploadSub.textContent = "Upload your own art " + formatPlusMoney(PRICE_BOOK.uploadEach) + " per art";
    syncBottomBaseToggleUi();
  }

  function getBasePrice() {
    var cfg = window.memCustomizerConfig || {};
    return roundPrice(cfg.productPrice || 0);
  }

  function getVaseUnitPrice() {
    var color = getSelectedVaseColorName();
    var rawPrice = VASE_PRICE_INPUTS[color];
    if (rawPrice === undefined) rawPrice = PRICE_INPUTS.vaseEach;
    return roundPrice((Number(rawPrice) || 0) * PRICE_MULTIPLIER);
  }

  function getVaseTotal(vaseCount) {
    return roundPrice((Number(vaseCount) || 0) * getVaseUnitPrice());
  }

  function buildOrderPricing() {
    var modalState = getModalState();
    var artSummary = summarizeArtPricing();
    var textTotal = modalState && modalState.hasText ? PRICE_BOOK.text : 0;
    var vaseCount = modalState && modalState.vase ? Number(modalState.vase) : 0;
    var vaseUnitPrice = getVaseUnitPrice();
    var vaseTotal = getVaseTotal(vaseCount);
    var bottomBase = getBottomBasePricing();
    var bottomBaseTotal = bottomBase ? bottomBase.price : 0;
    var baseTotal = getBasePrice();
    var addonTotal = roundPrice(textTotal + artSummary.total + vaseTotal + bottomBaseTotal);

    return {
      base: baseTotal,
      text: roundPrice(textTotal),
      art: artSummary,
      vaseCount: vaseCount,
      vaseColor: getSelectedVaseColorName(),
      vaseUnitPrice: vaseUnitPrice,
      vase: vaseTotal,
      bottomBase: bottomBase,
      addonTotal: addonTotal,
      grandTotal: roundPrice(baseTotal + addonTotal)
    };
  }

  function getArtSelectionSummary() {
    var modalState = getModalState();
    if (state.layers.length) {
      return state.layers.map(function(layer) {
        return layer.label;
      }).join(" | ");
    }
    return modalState && modalState.artLabel ? modalState.artLabel : "N/A";
  }

  function getArtLayoutSummary() {
    if (!state.layers.length) return "N/A";
    return state.layers.map(function(layer) {
      return layer.label + ": " + Math.round(layer.left) + "% left, " + Math.round(layer.top) + "% top, " + Math.round(layer.width) + "% width";
    }).join(" | ");
  }

  function getArtTypeSummary(summary) {
    if (!summary || !summary.lines || !summary.lines.length) return "N/A";
    return summary.lines.map(function(line) {
      return line.label;
    }).join(" | ");
  }

  function getArtPricingSummary(summary) {
    if (!summary || !summary.lines || !summary.lines.length) return "None";
    return summary.lines.map(function(line) {
      return describePricingLine(line);
    }).join(" | ");
  }

  function syncLayerPricingFromImage(layerObj, imgEl) {
    if (!layerObj || !imgEl) return;
    if (layerObj.priceKey !== "bronze_niche" && layerObj.priceKey !== "bronze_marker") return;

    var nextKey = inferBronzeKeyFromImage(imgEl);
    var rule = getRuleByKey(nextKey);
    layerObj.priceKey = nextKey;
    layerObj.priceAmount = rule.amount;
    layerObj.priceMode = rule.mode;
    layerObj.priceLabel = rule.label;
  }

  function applyBronzeLayerPreview(layerObj, layerEl, imgEl) {
    if (!layerObj || !layerEl || !imgEl || !layerObj.bronzeMode || layerObj._bronzePreviewSized) return;

    var key = layerObj.priceKey || inferBronzeKeyFromImage(imgEl);
    var isMarker = key === "bronze_marker";
    layerObj.width = isMarker ? 42 : 18;
    layerObj.left = isMarker ? 31 : 12;
    layerObj.top = isMarker ? 12 : 16;
    layerObj._bronzePreviewSized = true;

    layerEl.style.width = layerObj.width + "%";
    layerEl.style.left = layerObj.left + "%";
    layerEl.style.top = layerObj.top + "%";
    layerEl.style.height = "auto";
    syncSelectionBox();
  }

  function ensureLayerCss() {
    if (document.getElementById("memArtLayerCss")) return;
    var style = document.createElement("style");
    style.id = "memArtLayerCss";
    style.textContent = ".hs-engrave-zone{top:0!important;left:0!important;width:100%!important;height:100%!important;overflow:visible!important}.hs-portrait-layer{z-index:5}.hs-portrait-layer.active{outline:1px solid #79d1ff;outline-offset:0}.hs-portrait-layer.art-light img{filter:brightness(0) invert(.86) contrast(1.2) drop-shadow(0 0 1px rgba(255,255,255,.75));mix-blend-mode:screen;opacity:.96}.hs-portrait-layer.art-laser{background:transparent;border-color:rgba(255,255,255,.16)}.hs-portrait-layer.art-laser img{filter:grayscale(1) contrast(1.55) brightness(.9);mix-blend-mode:multiply;opacity:.92}.hs-portrait-layer.art-bronze{background:transparent!important;border-radius:0!important;border-color:rgba(121,209,255,.65);box-shadow:none;overflow:visible}.hs-portrait-layer.art-bronze img{filter:none!important;mix-blend-mode:normal!important;opacity:1!important;object-fit:contain!important;background:transparent!important}.mem-layer-box{position:absolute;border:1px solid #79d1ff;pointer-events:none;z-index:30;display:none}.mem-layer-box.show{display:block}.mem-layer-h{position:absolute;width:10px;height:10px;background:#fff;border-radius:50%;border:1px solid #79d1ff;pointer-events:auto}.mem-layer-h.nw{left:-6px;top:-6px;cursor:nwse-resize}.mem-layer-h.n{left:50%;top:-6px;transform:translateX(-50%);cursor:ns-resize}.mem-layer-h.ne{right:-6px;top:-6px;cursor:nesw-resize}.mem-layer-h.e{right:-6px;top:50%;transform:translateY(-50%);cursor:ew-resize}.mem-layer-h.se{right:-6px;bottom:-6px;cursor:nwse-resize}.mem-layer-h.s{left:50%;bottom:-6px;transform:translateX(-50%);cursor:ns-resize}.mem-layer-h.sw{left:-6px;bottom:-6px;cursor:nesw-resize}.mem-layer-h.w{left:-6px;top:50%;transform:translateY(-50%);cursor:ew-resize}";
    document.head.appendChild(style);
  }

  function ensureLandscapeModalCss() {
    if (document.getElementById("memLandscapeModalCss")) return;
    var style = document.createElement("style");
    style.id = "memLandscapeModalCss";
    style.textContent = "#memModal.open{padding:16px!important;align-items:center!important;justify-content:center!important}.mem-panel{width:min(1180px,94vw)!important;height:min(88vh,760px)!important;max-height:88vh!important;overflow:hidden!important;display:grid!important;grid-template-rows:auto auto minmax(0,1fr) auto auto!important}.mem-hdr{padding:10px 18px!important}.mem-hdr-left h2{font-size:12px!important;margin:0!important}.mem-hdr-left p{font-size:11px!important}.mem-controls{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:8px 10px!important;padding:10px 18px!important}.ctrl-group{gap:3px!important}.ctrl-label{font-size:8px!important}.ctrl-group select,.tcolor-dropdown{padding-top:6px!important;padding-bottom:6px!important;font-size:10px!important}.mem-body{min-height:0!important;display:grid!important;grid-template-columns:minmax(0,1fr) 430px!important}.mem-preview-col{min-height:0!important;overflow:hidden!important;padding:18px!important;align-items:center!important;justify-content:center!important}.preview-scene{width:100%!important;max-width:620px!important;min-height:0!important}.hs-wrap{width:100%!important;max-width:560px!important;min-height:0!important}.hs-wrap img.hs-base{max-height:42vh!important;min-height:0!important;object-fit:contain!important}.mem-panel.mem-preview-upright .mem-preview-col{padding-top:12px!important;padding-bottom:12px!important}.mem-panel.mem-preview-upright .preview-scene{max-width:100%!important;align-items:flex-end!important}.mem-panel.mem-preview-upright .hs-wrap{min-height:0!important}.mem-panel.mem-preview-upright .hs-wrap img.hs-base{min-height:0!important;object-fit:contain!important}.mem-form-col{min-height:0!important;overflow:auto!important;padding:14px 16px!important;gap:10px!important;border-left:1px solid #c5bfe8!important}.art-browser{padding:8px!important}.art-browser-top{margin-bottom:6px!important}.art-browser-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px!important;max-height:220px!important;overflow:auto!important}.art-card-thumb{aspect-ratio:16/10!important}.art-card-name{padding:6px!important;font-size:8px!important}.img-upload-area{padding:10px!important}.img-upload-icon{font-size:18px!important;margin-bottom:3px!important}.mem-ta{min-height:72px!important;padding:9px 11px!important;font-size:14px!important;line-height:1.45!important}.form-lbl,.swatch-label,.art-type-label{margin-bottom:5px!important}.form-divider{margin:0!important}.vase-options{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important}.vase-opt{min-width:0!important;padding:9px 10px!important}.mem-price-bar{padding:8px 18px!important;min-height:42px!important}.price-breakdown{gap:5px 12px!important}.price-total-value{font-size:17px!important}.mem-footer{padding:10px 18px!important}.btn-cancel,.btn-atc{padding:10px 12px!important}@media(max-width:900px){.mem-panel{height:auto!important;max-height:96vh!important;display:flex!important;overflow-y:auto!important}.mem-controls{grid-template-columns:repeat(2,minmax(0,1fr))!important}.mem-body{display:flex!important;flex-direction:column!important}.mem-preview-col{border-right:none!important;border-bottom:1px solid #c5bfe8!important}.mem-form-col{overflow:visible!important;border-left:0!important}.hs-wrap{max-width:520px!important}.hs-wrap img.hs-base{max-height:48vh!important}.art-browser-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;max-height:none!important}.vase-options{grid-template-columns:1fr!important}.mem-price-bar{flex-direction:column!important;align-items:flex-start!important}.price-total-wrap{align-items:flex-start!important}}";
    document.head.appendChild(style);
  }

  function ensureSelectionBox() {
    var zone = getArtZone();
    if (!zone) return null;
    var box = document.getElementById("memLayerBox");
    if (box) return box;
    box = document.createElement("div");
    box.id = "memLayerBox";
    box.className = "mem-layer-box";
    var handles = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];
    handles.forEach(function(h) {
      var el = document.createElement("span");
      el.className = "mem-layer-h " + h;
      el.setAttribute("data-h", h);
      box.appendChild(el);
    });
    zone.appendChild(box);
    return box;
  }

  function getLayerElById(id) {
    return document.querySelector('.hs-portrait-layer[data-layer-id="' + id + '"]');
  }

  function setLayerActive(id) {
    state.activeLayerId = id || null;
    var layers = document.querySelectorAll(".hs-portrait-layer");
    layers.forEach(function(el) {
      if (el.getAttribute("data-layer-id") === id) el.classList.add("active");
      else el.classList.remove("active");
    });
  }

  function syncSelectionBox() {
    var zone = getArtZone();
    var box = ensureSelectionBox();
    if (!zone || !box) return;
    var activeId = state.activeLayerId;
    var activeEl = activeId ? getLayerElById(activeId) : null;
    if (!activeEl) {
      box.classList.remove("show");
      return;
    }
    box.style.left = activeEl.style.left || "0%";
    box.style.top = activeEl.style.top || "0%";
    box.style.width = (activeEl.offsetWidth || 0) + "px";
    box.style.height = (activeEl.offsetHeight || 0) + "px";
    box.classList.add("show");
  }

  function clampPercent(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getObstacleRectPercent(el, zone) {
    if (!el || !zone || el.style.display === "none") return null;
    var zoneRect = zone.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    if (!zoneRect.width || !zoneRect.height || !rect.width || !rect.height) return null;

    var left = ((rect.left - zoneRect.left) / zoneRect.width) * 100;
    var top = ((rect.top - zoneRect.top) / zoneRect.height) * 100;
    var width = (rect.width / zoneRect.width) * 100;
    var height = (rect.height / zoneRect.height) * 100;
    return {
      left: clampPercent(left, 0, 100),
      top: clampPercent(top, 0, 100),
      right: clampPercent(left + width, 0, 100),
      bottom: clampPercent(top + height, 0, 100),
      width: width,
      height: height
    };
  }

  function getTextAvoidanceRect(zone) {
    var nodes = zone.querySelectorAll("#hsPortrait.visible,.hs-portrait-layer.visible");
    var rect = null;

    nodes.forEach(function(el) {
      var r = getObstacleRectPercent(el, zone);
      if (!r) return;
      if (!rect) {
        rect = {
          left: r.left,
          top: r.top,
          right: r.right,
          bottom: r.bottom
        };
      } else {
        rect.left = Math.min(rect.left, r.left);
        rect.top = Math.min(rect.top, r.top);
        rect.right = Math.max(rect.right, r.right);
        rect.bottom = Math.max(rect.bottom, r.bottom);
      }
    });

    if (!rect) return null;
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.centerX = rect.left + rect.width / 2;
    rect.centerY = rect.top + rect.height / 2;
    return rect;
  }

  function setTextBoxPosition(txt, left, top, width) {
    var modalState = getModalState();
    left = clampPercent(left, 2, 92);
    top = clampPercent(top, 2, 86);
    width = clampPercent(width, 18, 94);
    if (left + width > 98) width = 98 - left;

    txt.style.left = left + "%";
    txt.style.top = top + "%";
    txt.style.width = width + "%";

    if (!modalState.textPos) modalState.textPos = {};
    modalState.textPos.x = left;
    modalState.textPos.y = top;

    if (typeof window.fitText === "function") window.fitText();
  }

  function fitTextInsideCurrentBox() {
    var txt = document.getElementById("engText");
    var zone = getArtZone();
    var modalState = getModalState();
    if (!txt || txt.style.display === "none" || !zone) return;

    var zoneW = zone.clientWidth;
    var zoneH = zone.clientHeight;
    var boxW = txt.clientWidth || txt.getBoundingClientRect().width || zoneW;
    if (!zoneW || !zoneH || !boxW) return;

    txt.style.overflowWrap = "anywhere";
    txt.style.wordBreak = "break-word";
    txt.style.whiteSpace = "pre-wrap";

    var sizeFactor = modalState && modalState.size ? Number(modalState.size) || 1 : 1;
    var baseSize = Math.max(10, Math.round(zoneH * 0.12 * sizeFactor));
    var size = baseSize;
    txt.style.fontSize = size + "px";

    var safety = 0;
    while (safety < 90) {
      var boxH = txt.clientHeight || txt.getBoundingClientRect().height || 0;
      var fitsWidth = txt.scrollWidth <= boxW + 2;
      var fitsHeight = (txt.offsetTop || 0) + boxH <= zoneH * 0.96;
      if (fitsWidth && fitsHeight) break;
      size -= 1;
      if (size < 7) {
        size = 7;
        txt.style.fontSize = size + "px";
        break;
      }
      txt.style.fontSize = size + "px";
      safety++;
    }
  }

  function adjustTextAroundArtLayers() {
    var zone = getArtZone();
    var txt = document.getElementById("engText");
    if (!zone || !txt || txt.style.display === "none") return;

    var modalState = getModalState();
    var avoid = getTextAvoidanceRect(zone);
    if (!avoid) {
      setTextBoxPosition(txt, 5, modalState && modalState.textPos ? modalState.textPos.y || 55 : 55, 90);
      return;
    }

    var gap = 5;
    var leftSpace = Math.max(0, avoid.left - gap - 4);
    var rightStart = avoid.right + gap;
    var rightSpace = Math.max(0, 96 - rightStart);
    var top = clampPercent(avoid.top + Math.min(10, avoid.height * 0.2), 4, 82);

    if (rightSpace >= 24 || leftSpace >= 24) {
      if (rightSpace >= leftSpace) setTextBoxPosition(txt, rightStart, top, rightSpace);
      else setTextBoxPosition(txt, 4, top, leftSpace);
      return;
    }

    var belowTop = avoid.bottom + gap;
    if (belowTop <= 82) {
      setTextBoxPosition(txt, 6, belowTop, 88);
      return;
    }

    setTextBoxPosition(txt, 6, 4, 88);
  }

  function normalizeTextValue(value) {
    return String(value || "").replace(/\s+$/g, "");
  }

  function getVerseValue() {
    var input = document.getElementById("verseInput");
    return input ? normalizeTextValue(input.value) : "";
  }

  function buildEngravingPreviewText(mainText, verseText) {
    var main = normalizeTextValue(mainText);
    var verse = normalizeTextValue(verseText);
    if (main && verse) return main + "\n\n" + verse;
    return main || verse;
  }

  function syncVerseOrSayingPreview() {
    var modalState = getModalState();
    var mainInput = document.getElementById("engInput");
    var txt = document.getElementById("engText");
    var hint = document.getElementById("engHint");
    var verse = getVerseValue();
    var main = mainInput ? normalizeTextValue(mainInput.value) : normalizeTextValue(modalState.text);
    var combined = buildEngravingPreviewText(main, verse);

    modalState.verseOrSaying = verse;
    if (!txt) return;

    if (combined) {
      txt.textContent = combined;
      txt.style.display = "block";
      if (hint) hint.style.display = "none";
      if (typeof window.fitText === "function") window.fitText();
      if (typeof window.adjustTextAroundPortrait === "function") window.adjustTextAroundPortrait();
    } else if (!main) {
      txt.textContent = "";
    }
  }

  function ensureVerseOrSayingField() {
    if (document.getElementById("verseInput")) return true;

    var engravingInput = document.getElementById("engInput");
    if (!engravingInput || !engravingInput.parentNode) return false;

    var wrap = document.createElement("div");
    wrap.className = "verse-field";
    wrap.innerHTML = '<label class="form-lbl" for="verseInput">Verse or Saying</label><textarea id="verseInput" class="mem-ta" maxlength="240" placeholder="e.g. Forever in our hearts"></textarea><div class="char-ct" id="verseCharCt">0 / 240</div>';

    var parent = engravingInput.parentNode;
    var charCount = document.getElementById("charCt");
    if (charCount && charCount.parentNode === parent) parent.insertBefore(wrap, charCount.nextSibling);
    else parent.insertBefore(wrap, engravingInput.nextSibling);

    var verseInput = document.getElementById("verseInput");
    var verseCt = document.getElementById("verseCharCt");
    if (verseInput) {
      verseInput.addEventListener("input", function() {
        if (verseCt) {
          var len = verseInput.value.length;
          verseCt.textContent = len + " / 240";
          verseCt.className = "char-ct" + (len >= 240 ? " over" : len >= 192 ? " warn" : "");
        }
        syncVerseOrSayingPreview();
      });
    }

    engravingInput.addEventListener("input", function() {
      setTimeout(syncVerseOrSayingPreview, 0);
    });

    return true;
  }

  function installVerseOrSayingField() {
    if (window._memVerseOrSayingInstalled) return true;
    if (!ensureVerseOrSayingField()) return false;

    window._memVerseOrSayingInstalled = true;
    var originalOnType = window.onType;
    if (typeof originalOnType === "function") {
      window.onType = function() {
        var result = originalOnType.apply(this, arguments);
        syncVerseOrSayingPreview();
        return result;
      };
    }

    setTimeout(syncVerseOrSayingPreview, 0);
    return true;
  }

  function ensureStructuredEngravingCss() {
    if (document.getElementById("memStructuredEngravingCss")) return;
    var style = document.createElement("style");
    style.id = "memStructuredEngravingCss";
    style.textContent = ".hs-engrave-zone{top:0!important;left:0!important;width:100%!important;height:100%!important;overflow:visible!important}.structured-engraving-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin-bottom:10px}.structured-engraving-grid .structured-field--full{grid-column:1/-1}.structured-engraving-grid input,.structured-engraving-grid textarea{width:100%;box-sizing:border-box;background:#f5f4fb;border:1px solid #a89fd4;color:#2a1f5a;font-family:'IM Fell English',serif;font-size:14px;padding:8px 10px;outline:none}.structured-engraving-grid textarea{min-height:70px;resize:vertical}.structured-engraving-grid input:focus,.structured-engraving-grid textarea:focus{border-color:#c8860a}.structured-engraving-grid label{display:block;margin-bottom:4px;font-family:'Cinzel',serif;font-size:8px;letter-spacing:.14em;text-transform:uppercase;color:#7a6baa}.mem-structured-hidden{opacity:0!important;pointer-events:none!important}.mem-structured-preview{position:absolute;left:0;top:0;width:100%;height:100%;z-index:18;pointer-events:none;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.9),0 -1px 1px rgba(255,255,255,.08);overflow:hidden;box-sizing:border-box}.mem-structured-line{position:absolute;left:10%;width:80%;white-space:nowrap;overflow:hidden;text-overflow:clip;line-height:1.05;letter-spacing:.06em}.mem-structured-line.empty{opacity:.72}.mem-structured-name{top:13%;font-size:34px}.mem-structured-last{top:28%;font-size:30px}.mem-structured-birth{top:43%;left:30%;width:40%;font-size:19px}.mem-structured-death{top:53%;left:30%;width:40%;font-size:19px}.mem-structured-verse{top:72%;left:9%;width:82%;font-size:25px}@media(max-width:900px){.structured-engraving-grid{grid-template-columns:1fr}.mem-structured-name{font-size:28px}.mem-structured-last{font-size:24px}.mem-structured-verse{font-size:20px}}";
    style.textContent += ".structured-engraving-grid .companion-only{display:none}.structured-engraving-grid.mem-companion .companion-only{display:block}.mem-structured-name2,.mem-structured-last2,.mem-structured-birth2,.mem-structured-death2{display:none}.mem-structured-preview.companion .mem-structured-line{width:38%;left:6%}.mem-structured-preview.companion .mem-structured-name{top:16%;font-size:24px}.mem-structured-preview.companion .mem-structured-last{top:28%;font-size:22px}.mem-structured-preview.companion .mem-structured-birth{top:42%;left:12%;width:26%;font-size:15px}.mem-structured-preview.companion .mem-structured-death{top:51%;left:12%;width:26%;font-size:15px}.mem-structured-preview.companion .mem-structured-name2,.mem-structured-preview.companion .mem-structured-last2,.mem-structured-preview.companion .mem-structured-birth2,.mem-structured-preview.companion .mem-structured-death2{display:block}.mem-structured-preview.companion .mem-structured-name2{top:16%;left:56%;font-size:24px}.mem-structured-preview.companion .mem-structured-last2{top:28%;left:56%;font-size:22px}.mem-structured-preview.companion .mem-structured-birth2{top:42%;left:62%;width:26%;font-size:15px}.mem-structured-preview.companion .mem-structured-death2{top:51%;left:62%;width:26%;font-size:15px}.mem-structured-preview.companion .mem-structured-verse{top:72%;left:10%;width:80%;font-size:21px}";
    style.textContent += ".mem-structured-preview.special-design{pointer-events:auto;cursor:move;outline:1px solid rgba(121,209,255,.82);outline-offset:0;overflow:visible}.mem-structured-preview.special-design .mem-structured-line{pointer-events:none}.mem-special-text-h{display:none;position:absolute;width:10px;height:10px;background:#fff;border:1px solid #79d1ff;border-radius:50%;z-index:35;box-sizing:border-box}.mem-structured-preview.special-design .mem-special-text-h{display:block}.mem-special-text-h.nw{left:-6px;top:-6px;cursor:nwse-resize}.mem-special-text-h.n{left:50%;top:-6px;transform:translateX(-50%);cursor:ns-resize}.mem-special-text-h.ne{right:-6px;top:-6px;cursor:nesw-resize}.mem-special-text-h.e{right:-6px;top:50%;transform:translateY(-50%);cursor:ew-resize}.mem-special-text-h.se{right:-6px;bottom:-6px;cursor:nwse-resize}.mem-special-text-h.s{left:50%;bottom:-6px;transform:translateX(-50%);cursor:ns-resize}.mem-special-text-h.sw{left:-6px;bottom:-6px;cursor:nesw-resize}.mem-special-text-h.w{left:-6px;top:50%;transform:translateY(-50%);cursor:ew-resize}";
    document.head.appendChild(style);
  }

  function ensureStructuredPreviewLayer() {
    var zone = getArtZone();
    if (!zone) return null;

    var layer = document.getElementById("memStructuredPreview");
    if (layer) return layer;

    layer = document.createElement("div");
    layer.id = "memStructuredPreview";
    layer.className = "mem-structured-preview";
    layer.innerHTML = '<div class="mem-structured-line mem-structured-name" data-field="firstName">NAME</div><div class="mem-structured-line mem-structured-last" data-field="lastName">LAST NAME</div><div class="mem-structured-line mem-structured-birth" data-field="birthDate">DATE</div><div class="mem-structured-line mem-structured-death" data-field="deathDate">DATE</div><div class="mem-structured-line mem-structured-name2" data-field="firstName2">NAME</div><div class="mem-structured-line mem-structured-last2" data-field="lastName2">LAST NAME</div><div class="mem-structured-line mem-structured-birth2" data-field="birthDate2">DATE</div><div class="mem-structured-line mem-structured-death2" data-field="deathDate2">DATE</div><div class="mem-structured-line mem-structured-verse" data-field="verse">VERSE OR SAYING</div>';
    zone.appendChild(layer);
    return layer;
  }

  function getStructuredTextControlSettings() {
    var fontSelect = document.getElementById("fontSelect");
    var sizeSelect = document.getElementById("sizeSelect");
    var spacingSelect = document.getElementById("spacingSelect");
    var alignSelect = document.getElementById("alignSelect");
    var styleSelect = document.getElementById("styleSelect");
    var activeColor = document.querySelector(".tcolor-opt.active");
    var modalState = getModalState();

    var sizeValue = sizeSelect ? parseFloat(sizeSelect.value) : 1;
    var spacingValue = spacingSelect ? parseFloat(spacingSelect.value) : 1.5;
    var selectedFontLabel = fontSelect && fontSelect.options && fontSelect.selectedIndex >= 0
      ? fontSelect.options[fontSelect.selectedIndex].text
      : "";

    return {
      fontFamily: fontSelect && fontSelect.value ? fontSelect.value : "'Modern Roman', serif",
      fontStyle: /italic/i.test(selectedFontLabel) ? "italic" : "normal",
      sizeScale: Math.max(0.75, Math.min(2.45, Math.sqrt(Math.max(0.4, sizeValue || 1)))),
      lineHeight: Math.max(0.92, Math.min(1.55, 0.9 + ((spacingValue || 1.5) / 18) * 0.65)),
      align: alignSelect && alignSelect.value ? alignSelect.value : "center",
      color: activeColor && activeColor.getAttribute("data-color")
        ? activeColor.getAttribute("data-color")
        : (modalState.textColor || "#ffffff"),
      style: styleSelect && styleSelect.value ? styleSelect.value : "U-Sunk"
    };
  }

  function getStructuredTextShadow(settings) {
    var color = settings && settings.color ? settings.color : "#ffffff";
    var style = settings && settings.style ? String(settings.style).toLowerCase() : "";

    if (style.indexOf("outline") >= 0) {
      return "0 0 1px " + color + ",1px 0 1px rgba(0,0,0,.9),-1px 0 1px rgba(0,0,0,.9),0 1px 1px rgba(0,0,0,.9),0 -1px 1px rgba(0,0,0,.9)";
    }
    if (style.indexOf("raised") >= 0 || style.indexOf("polished") >= 0) {
      return "0 1px 1px rgba(255,255,255,.55),0 2px 2px rgba(0,0,0,.9),0 -1px 1px rgba(255,255,255,.25)";
    }
    if (style.indexOf("frosted") >= 0) {
      return "0 0 1px rgba(255,255,255,.7),0 1px 2px rgba(0,0,0,.65)";
    }
    return "0 1px 2px rgba(0,0,0,.9),0 -1px 1px rgba(255,255,255,.08)";
  }

  function applyStructuredTextControls(layer) {
    if (!layer) return;

    var settings = getStructuredTextControlSettings();
    var displayColor = settings.color === "transparent" ? "transparent" : settings.color;
    layer.style.fontFamily = settings.fontFamily;
    layer.style.color = displayColor;

    layer.querySelectorAll(".mem-structured-line").forEach(function(el) {
      el.style.fontFamily = settings.fontFamily;
      el.style.fontStyle = settings.fontStyle;
      el.style.color = displayColor;
      el.style.textAlign = settings.align;
      el.style.lineHeight = settings.lineHeight;
      el.style.textShadow = getStructuredTextShadow(settings);
      fitStructuredPreviewLine(el);
    });
  }

  function resizeStructuredPreviewText(layer) {
    if (!layer) return;

    var w = layer.clientWidth || 0;
    var h = layer.clientHeight || 0;
    if (!w || !h) return;

    var controls = getStructuredTextControlSettings();
    var sizeScale = controls.sizeScale || 1;
    var nameSize = Math.max(12, Math.min(34, Math.round(Math.min(w / 9, h * 0.16))));
    var lastSize = Math.max(11, Math.min(30, Math.round(Math.min(w / 11, h * 0.14))));
    var dateSize = Math.max(8, Math.min(19, Math.round(Math.min(w / 18, h * 0.09))));
    var verseSize = Math.max(10, Math.min(25, Math.round(Math.min(w / 18, h * 0.12))));
    if (layer.classList.contains("companion")) {
      nameSize = Math.max(10, Math.min(24, Math.round(Math.min(w / 18, h * 0.12))));
      lastSize = Math.max(10, Math.min(22, Math.round(Math.min(w / 20, h * 0.11))));
      dateSize = Math.max(8, Math.min(15, Math.round(Math.min(w / 28, h * 0.07))));
      verseSize = Math.max(9, Math.min(21, Math.round(Math.min(w / 20, h * 0.1))));
    }
    nameSize = Math.max(8, Math.min(54, Math.round(nameSize * sizeScale)));
    lastSize = Math.max(8, Math.min(50, Math.round(lastSize * sizeScale)));
    dateSize = Math.max(7, Math.min(34, Math.round(dateSize * sizeScale)));
    verseSize = Math.max(8, Math.min(42, Math.round(verseSize * sizeScale)));

    var rules = {
      firstName: nameSize,
      lastName: lastSize,
      birthDate: dateSize,
      deathDate: dateSize,
      firstName2: nameSize,
      lastName2: lastSize,
      birthDate2: dateSize,
      deathDate2: dateSize,
      verse: verseSize
    };

    Object.keys(rules).forEach(function(key) {
      var el = layer.querySelector('[data-field="' + key + '"]');
      if (!el) return;
      el.setAttribute("data-base-size", String(rules[key]));
      el.style.fontSize = rules[key] + "px";
      fitStructuredPreviewLine(el);
    });
    applyStructuredTextControls(layer);
  }

  function applyStructuredLayerRect(layer, rect) {
    if (!layer || !rect) return;

    var safeLeft = Math.max(0, Math.round(rect.left));
    var safeTop = Math.max(0, Math.round(rect.top));
    var safeWidth = Math.max(1, Math.round(rect.width));
    var safeHeight = Math.max(1, Math.round(rect.height));

    layer.style.left = safeLeft + "px";
    layer.style.top = safeTop + "px";
    layer.style.width = safeWidth + "px";
    layer.style.height = safeHeight + "px";
    resizeStructuredPreviewText(layer);
  }

  function getSpecialDesignMatcherText() {
    var cfg = window.memCustomizerConfig || {};
    var parts = [
      getProductTitleText(),
      cfg.productTitle,
      cfg.productName,
      cfg.productHandle,
      cfg.productType,
      cfg.productCategory,
      cfg.template,
      cfg.tags,
      cfg.productTags,
      window.location ? window.location.pathname : ""
    ];
    if (document.body) parts.push(document.body.className || "");
    return parts.join(" ");
  }

  function isSpecialDesignProduct() {
    var text = String(getSpecialDesignMatcherText() || "").toLowerCase();
    var compact = text.replace(/[^a-z0-9]/g, "");
    return /special[\s_-]*design/i.test(text) || compact.indexOf("specialdesign") >= 0;
  }

  function getHeadstoneVisualBoundsPx(zone) {
    var baseImg = document.getElementById("hsBaseImg");
    var zoneRect = zone ? zone.getBoundingClientRect() : null;
    if (!zone || !zoneRect || !zoneRect.width || !zoneRect.height || !baseImg) {
      return {
        left: 0,
        top: 0,
        right: zone ? zone.clientWidth || 0 : 0,
        bottom: zone ? zone.clientHeight || 0 : 0
      };
    }

    var imgRect = baseImg.getBoundingClientRect();
    if (!imgRect.width || !imgRect.height) {
      return {
        left: 0,
        top: 0,
        right: zoneRect.width,
        bottom: zoneRect.height
      };
    }

    return {
      left: Math.max(0, imgRect.left - zoneRect.left),
      top: Math.max(0, imgRect.top - zoneRect.top),
      right: Math.min(zoneRect.width, imgRect.right - zoneRect.left),
      bottom: Math.min(zoneRect.height, imgRect.bottom - zoneRect.top)
    };
  }

  function saveSpecialDesignTextBoxRect(layer) {
    var zone = getArtZone();
    var modalState = getModalState();
    if (!zone || !layer) return;

    var zoneW = zone.clientWidth || 1;
    var zoneH = zone.clientHeight || 1;
    modalState.specialDesignTextBox = {
      left: (parseFloat(layer.style.left) || 0) / zoneW,
      top: (parseFloat(layer.style.top) || 0) / zoneH,
      width: (layer.offsetWidth || parseFloat(layer.style.width) || 1) / zoneW,
      height: (layer.offsetHeight || parseFloat(layer.style.height) || 1) / zoneH
    };
  }

  function applySavedSpecialDesignTextBoxRect(layer) {
    var zone = getArtZone();
    var modalState = getModalState();
    var rect = modalState.specialDesignTextBox;
    if (!zone || !layer || !rect) return false;

    var zoneW = zone.clientWidth || 1;
    var zoneH = zone.clientHeight || 1;
    var width = Math.max(80, rect.width * zoneW);
    var height = Math.max(50, rect.height * zoneH);
    var left = rect.left * zoneW;
    var top = rect.top * zoneH;
    var bounds = getHeadstoneVisualBoundsPx(zone);

    width = Math.min(width, Math.max(80, bounds.right - bounds.left));
    height = Math.min(height, Math.max(50, bounds.bottom - bounds.top));
    left = Math.max(bounds.left, Math.min(left, bounds.right - width));
    top = Math.max(bounds.top, Math.min(top, bounds.bottom - height));

    applyStructuredLayerRect(layer, {
      left: left,
      top: top,
      width: width,
      height: height
    });
    return true;
  }

  function ensureSpecialDesignTextBoxHandles(layer) {
    if (!layer || layer.querySelector(".mem-special-text-h")) return;
    ["nw", "n", "ne", "e", "se", "s", "sw", "w"].forEach(function(handle) {
      var el = document.createElement("span");
      el.className = "mem-special-text-h " + handle;
      el.setAttribute("data-text-h", handle);
      layer.appendChild(el);
    });
  }

  function installSpecialDesignTextBoxDrag(layer) {
    if (!layer || layer._memSpecialTextDragInstalled) return;
    layer._memSpecialTextDragInstalled = true;

    function clamp(v, min, max) {
      return Math.min(Math.max(v, min), max);
    }

    function begin(clientX, clientY, handle, attachMouseListeners) {
      if (!isSpecialDesignProduct()) return;
      var zone = getArtZone();
      if (!zone) return;

      var startX = clientX;
      var startY = clientY;
      var startLeft = parseFloat(layer.style.left) || 0;
      var startTop = parseFloat(layer.style.top) || 0;
      var startW = layer.offsetWidth || parseFloat(layer.style.width) || 120;
      var startH = layer.offsetHeight || parseFloat(layer.style.height) || 90;

      function move(nextX, nextY) {
        var dx = nextX - startX;
        var dy = nextY - startY;
        var bounds = getHeadstoneVisualBoundsPx(zone);
        var minW = Math.max(80, (bounds.right - bounds.left) * 0.18);
        var minH = Math.max(50, (bounds.bottom - bounds.top) * 0.14);
        var left = startLeft;
        var top = startTop;
        var width = startW;
        var height = startH;

        if (handle) {
          if (handle.indexOf("e") >= 0) width = startW + dx;
          if (handle.indexOf("s") >= 0) height = startH + dy;
          if (handle.indexOf("w") >= 0) {
            width = startW - dx;
            left = startLeft + dx;
          }
          if (handle.indexOf("n") >= 0) {
            height = startH - dy;
            top = startTop + dy;
          }

          width = clamp(width, minW, Math.max(minW, bounds.right - bounds.left));
          height = clamp(height, minH, Math.max(minH, bounds.bottom - bounds.top));
          left = clamp(left, bounds.left, bounds.right - width);
          top = clamp(top, bounds.top, bounds.bottom - height);
        } else {
          left = clamp(startLeft + dx, bounds.left, bounds.right - startW);
          top = clamp(startTop + dy, bounds.top, bounds.bottom - startH);
        }

        layer.style.left = left + "px";
        layer.style.top = top + "px";
        layer.style.width = width + "px";
        layer.style.height = height + "px";
        resizeStructuredPreviewText(layer);
        saveSpecialDesignTextBoxRect(layer);
      }

      function onMouseMove(ev) {
        move(ev.clientX, ev.clientY);
      }

      function onMouseUp() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      }

      if (attachMouseListeners !== false) {
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      }

      return {
        move: move,
        end: function() {}
      };
    }

    layer.addEventListener("mousedown", function(e) {
      if (!layer.classList.contains("special-design")) return;
      var handle = e.target && e.target.getAttribute ? e.target.getAttribute("data-text-h") : "";
      e.preventDefault();
      e.stopPropagation();
      begin(e.clientX, e.clientY, handle || "", true);
    });

    layer.addEventListener("touchstart", function(e) {
      if (!layer.classList.contains("special-design") || !e.touches || !e.touches[0]) return;
      var handle = e.target && e.target.getAttribute ? e.target.getAttribute("data-text-h") : "";
      var session = begin(e.touches[0].clientX, e.touches[0].clientY, handle || "", false);
      if (!session) return;

      function onTouchMove(ev) {
        if (!ev.touches || !ev.touches[0]) return;
        ev.preventDefault();
        session.move(ev.touches[0].clientX, ev.touches[0].clientY);
      }

      function onTouchEnd() {
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
      }

      document.addEventListener("touchmove", onTouchMove, { passive: false });
      document.addEventListener("touchend", onTouchEnd);
    }, { passive: true });
  }

  function positionStructuredPreviewLayer() {
    var zone = getArtZone();
    var layer = document.getElementById("memStructuredPreview");
    var baseImg = document.getElementById("hsBaseImg");
    if (!zone || !layer || !baseImg) return;

    var specialDesign = isSpecialDesignProduct();
    layer.classList.toggle("special-design", specialDesign);
    if (specialDesign) {
      ensureSpecialDesignTextBoxHandles(layer);
      installSpecialDesignTextBoxDrag(layer);
      if (applySavedSpecialDesignTextBoxRect(layer)) return;
    }

    var zoneRect = zone.getBoundingClientRect();
    var imgRect = baseImg.getBoundingClientRect();
    if (!zoneRect.width || !zoneRect.height || !imgRect.width || !imgRect.height) {
      applyStructuredLayerRect(layer, { left: 0, top: 0, width: zone.clientWidth || 1, height: zone.clientHeight || 1 });
      return;
    }

    function applyFromProfile(profile) {
      var visibleLeft = profile && typeof profile.left === "number" ? profile.left : 0;
      var visibleTop = profile && typeof profile.top === "number" ? profile.top : 0;
      var visibleRight = profile && typeof profile.right === "number" ? profile.right : 1;
      var visibleBottom = profile && typeof profile.bottom === "number" ? profile.bottom : 1;

      var left = (imgRect.left + (visibleLeft * imgRect.width)) - zoneRect.left;
      var top = (imgRect.top + (visibleTop * imgRect.height)) - zoneRect.top;
      var right = (imgRect.left + (visibleRight * imgRect.width)) - zoneRect.left;
      var bottom = (imgRect.top + (visibleBottom * imgRect.height)) - zoneRect.top;

      left = Math.max(0, left);
      top = Math.max(0, top);
      right = Math.min(zoneRect.width, right);
      bottom = Math.min(zoneRect.height, bottom);

      var width = Math.max(1, right - left);
      var height = Math.max(1, bottom - top);
      var insetX = Math.min(34, Math.max(8, width * 0.06));
      var insetY = Math.min(24, Math.max(6, height * 0.06));

      applyStructuredLayerRect(layer, {
        left: left + insetX,
        top: top + insetY,
        width: Math.max(1, width - (insetX * 2)),
        height: Math.max(1, height - (insetY * 2))
      });
      if (specialDesign) saveSpecialDesignTextBoxRect(layer);
    }

    if (baseImg.complete && baseImg.naturalWidth && typeof getAlphaProfile === "function") {
      getAlphaProfile(baseImg).then(applyFromProfile, function() {
        applyFromProfile(null);
      });
      return;
    }

    applyFromProfile(null);
  }

  function isCompanionProduct() {
    return /\bcompanion\b/i.test(String(getProductTitleText() || ""));
  }

  function getStructuredEngravingValues() {
    var firstName = document.getElementById("engravingFirstName");
    var lastName = document.getElementById("engravingLastName");
    var birthDate = document.getElementById("engravingBirthDate");
    var deathDate = document.getElementById("engravingDeathDate");
    var firstName2 = document.getElementById("engravingFirstName2");
    var lastName2 = document.getElementById("engravingLastName2");
    var birthDate2 = document.getElementById("engravingBirthDate2");
    var deathDate2 = document.getElementById("engravingDeathDate2");
    var verse = document.getElementById("verseInput");

    return {
      firstName: firstName ? normalizeTextValue(firstName.value) : "",
      lastName: lastName ? normalizeTextValue(lastName.value) : "",
      birthDate: birthDate ? normalizeTextValue(birthDate.value) : "",
      deathDate: deathDate ? normalizeTextValue(deathDate.value) : "",
      firstName2: firstName2 ? normalizeTextValue(firstName2.value) : "",
      lastName2: lastName2 ? normalizeTextValue(lastName2.value) : "",
      birthDate2: birthDate2 ? normalizeTextValue(birthDate2.value) : "",
      deathDate2: deathDate2 ? normalizeTextValue(deathDate2.value) : "",
      verse: verse ? normalizeTextValue(verse.value) : ""
    };
  }

  function buildStructuredEngravingText(values) {
    var parts = [];
    if (values.firstName) parts.push(values.firstName);
    if (values.lastName) parts.push(values.lastName);
    if (values.birthDate || values.deathDate) parts.push([values.birthDate, values.deathDate].filter(Boolean).join(" - "));
    if (isCompanionProduct()) {
      if (values.firstName2) parts.push(values.firstName2);
      if (values.lastName2) parts.push(values.lastName2);
      if (values.birthDate2 || values.deathDate2) parts.push([values.birthDate2, values.deathDate2].filter(Boolean).join(" - "));
    }
    if (values.verse) parts.push(values.verse);
    return parts.join("\n");
  }

  function fitStructuredPreviewLine(el) {
    if (!el) return;
    var original = parseFloat(el.getAttribute("data-base-size") || el.style.fontSize || 18) || 18;
    var size = original;
    el.style.fontSize = size + "px";
    var safety = 0;
    while (safety < 50 && el.scrollWidth > el.clientWidth + 2) {
      size -= 1;
      if (size < 8) break;
      el.style.fontSize = size + "px";
      safety += 1;
    }
  }

  function renderStructuredEngravingPreview() {
    ensureStructuredEngravingCss();
    var layer = ensureStructuredPreviewLayer();
    if (!layer) return;

    var modalState = getModalState();
    var values = getStructuredEngravingValues();
    var companion = isCompanionProduct();
    layer.classList.toggle("companion", companion);
    var placeholders = {
      firstName: "NAME",
      lastName: "LAST NAME",
      birthDate: "DATE",
      deathDate: "DATE",
      firstName2: "NAME",
      lastName2: "LAST NAME",
      birthDate2: "DATE",
      deathDate2: "DATE",
      verse: "VERSE OR SAYING"
    };

    Object.keys(placeholders).forEach(function(key) {
      var el = layer.querySelector('[data-field="' + key + '"]');
      if (!el) return;
      if (!companion && /2$/.test(key)) {
        el.textContent = "";
        el.classList.add("empty");
        return;
      }
      var value = values[key] || placeholders[key];
      el.textContent = value;
      el.classList.toggle("empty", !values[key]);
      if (!el.getAttribute("data-base-size")) el.setAttribute("data-base-size", String(parseFloat(window.getComputedStyle(el).fontSize) || 18));
      fitStructuredPreviewLine(el);
    });
    applyStructuredTextControls(layer);

    positionStructuredPreviewLayer();

    var txt = document.getElementById("engText");
    if (txt) {
      txt.classList.add("mem-structured-hidden");
      txt.style.display = "block";
    }

    var hint = document.getElementById("engHint");
    if (hint) hint.style.display = "none";

    var combined = buildStructuredEngravingText(values);
    var engInput = document.getElementById("engInput");
    if (engInput && engInput.value !== combined) engInput.value = combined;

    modalState.structuredEngraving = values;
    modalState.verseOrSaying = values.verse;
    modalState.text = combined;
    modalState.hasText = !!combined;

    var charCt = document.getElementById("charCt");
    if (charCt) charCt.textContent = combined.length + " / 120";

    var verseCt = document.getElementById("verseCharCt");
    if (verseCt) verseCt.textContent = values.verse.length + " / 240";

    if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
    else if (typeof window.updatePrice === "function") window.updatePrice();
  }

  function ensureStructuredEngravingFields() {
    if (document.getElementById("structuredEngravingFields")) return true;

    var engravingInput = document.getElementById("engInput");
    if (!engravingInput || !engravingInput.parentNode) return false;

    ensureStructuredEngravingCss();

    var wrap = document.createElement("div");
    var companion = isCompanionProduct();
    wrap.id = "structuredEngravingFields";
    wrap.className = "structured-engraving-grid" + (companion ? " mem-companion" : "");
    wrap.innerHTML = companion
      ? '<div><label for="engravingFirstName">Person 1 Name</label><input id="engravingFirstName" type="text" maxlength="40" placeholder="Name"></div><div><label for="engravingLastName">Person 1 Last Name</label><input id="engravingLastName" type="text" maxlength="60" placeholder="Last Name"></div><div><label for="engravingBirthDate">Person 1 Date</label><input id="engravingBirthDate" type="text" maxlength="24" placeholder="Date"></div><div><label for="engravingDeathDate">Person 1 Date</label><input id="engravingDeathDate" type="text" maxlength="24" placeholder="Date"></div><div class="companion-only"><label for="engravingFirstName2">Person 2 Name</label><input id="engravingFirstName2" type="text" maxlength="40" placeholder="Name"></div><div class="companion-only"><label for="engravingLastName2">Person 2 Last Name</label><input id="engravingLastName2" type="text" maxlength="60" placeholder="Last Name"></div><div class="companion-only"><label for="engravingBirthDate2">Person 2 Date</label><input id="engravingBirthDate2" type="text" maxlength="24" placeholder="Date"></div><div class="companion-only"><label for="engravingDeathDate2">Person 2 Date</label><input id="engravingDeathDate2" type="text" maxlength="24" placeholder="Date"></div>'
      : '<div><label for="engravingFirstName">Name</label><input id="engravingFirstName" type="text" maxlength="40" placeholder="Name"></div><div><label for="engravingLastName">Last Name</label><input id="engravingLastName" type="text" maxlength="60" placeholder="Last Name"></div><div><label for="engravingBirthDate">Date</label><input id="engravingBirthDate" type="text" maxlength="24" placeholder="Date"></div><div><label for="engravingDeathDate">Date</label><input id="engravingDeathDate" type="text" maxlength="24" placeholder="Date"></div>';

    engravingInput.parentNode.insertBefore(wrap, engravingInput);
    engravingInput.style.display = "none";

    var charCt = document.getElementById("charCt");
    if (charCt) charCt.style.display = "none";

    var verseInput = document.getElementById("verseInput");
    var verseField = verseInput ? verseInput.closest(".verse-field") : null;
    if (verseField) {
      verseField.classList.add("structured-field--full");
      wrap.appendChild(verseField);
    }

    ["engravingFirstName", "engravingLastName", "engravingBirthDate", "engravingDeathDate", "engravingFirstName2", "engravingLastName2", "engravingBirthDate2", "engravingDeathDate2", "verseInput"].forEach(function(id) {
      var input = document.getElementById(id);
      if (input) input.addEventListener("input", renderStructuredEngravingPreview);
    });

    var baseImg = document.getElementById("hsBaseImg");
    if (baseImg && !baseImg._memStructuredPreviewLoadHook) {
      baseImg._memStructuredPreviewLoadHook = true;
      baseImg.addEventListener("load", function() {
        setTimeout(renderStructuredEngravingPreview, 0);
      });
    }

    renderStructuredEngravingPreview();
    return true;
  }

  function installStructuredEngravingFields() {
    if (window._memStructuredEngravingInstalled) return true;
    if (!ensureStructuredEngravingFields()) return false;
    window._memStructuredEngravingInstalled = true;

    var originalApplyControls = window.applyControls;
    if (typeof originalApplyControls === "function") {
      window.applyControls = function() {
        var result = originalApplyControls.apply(this, arguments);
        renderStructuredEngravingPreview();
        return result;
      };
    }

    var originalStc = window.stc || window.selectTextColor;
    if (typeof originalStc === "function") {
      window.stc = function() {
        var result = originalStc.apply(this, arguments);
        setTimeout(renderStructuredEngravingPreview, 0);
        return result;
      };
      window.selectTextColor = window.stc;
    }

    ["fontSelect", "sizeSelect", "spacingSelect", "alignSelect", "styleSelect"].forEach(function(id) {
      var control = document.getElementById(id);
      if (!control || control._memStructuredControlHooked) return;
      control._memStructuredControlHooked = true;
      control.addEventListener("change", function() {
        setTimeout(renderStructuredEngravingPreview, 0);
      });
      control.addEventListener("input", function() {
        setTimeout(renderStructuredEngravingPreview, 0);
      });
    });

    document.querySelectorAll(".tcolor-opt").forEach(function(option) {
      if (option._memStructuredColorHooked) return;
      option._memStructuredColorHooked = true;
      option.addEventListener("click", function() {
        setTimeout(renderStructuredEngravingPreview, 0);
      });
    });

    setTimeout(renderStructuredEngravingPreview, 0);
    setTimeout(renderStructuredEngravingPreview, 250);
    window.addEventListener("resize", function() {
      setTimeout(renderStructuredEngravingPreview, 0);
    });
    document.addEventListener("variant:changed", function() {
      setTimeout(renderStructuredEngravingPreview, 0);
    });
    document.addEventListener("theme:variant:change", function() {
      setTimeout(renderStructuredEngravingPreview, 0);
    });
    return true;
  }

  function ensureProofApprovalField() {
    if (document.getElementById("proofApproval")) return true;

    var footer = document.getElementById("memFooter");
    if (!footer || !footer.parentNode) return false;

    var wrap = document.createElement("label");
    wrap.className = "proof-approval-field";
    wrap.setAttribute("for", "proofApproval");
    wrap.innerHTML = '<input type="checkbox" id="proofApproval"><span>I understand that a design proof will be sent to the email provided at checkout within 24-48 hours of placing my order. Production will not begin until I review and approve the final proof.</span>';

    var style = document.createElement("style");
    style.textContent = ".proof-approval-field{display:flex;align-items:flex-start;gap:8px;padding:9px 22px;background:#f5f4fb;border-top:1px solid #c5bfe8;font-family:'IM Fell English',serif;font-size:11px;font-style:italic;color:#7a6baa;line-height:1.35;cursor:pointer}.proof-approval-field input{margin-top:2px;accent-color:#c8860a;flex:0 0 auto}.proof-approval-field.proof-error{color:#8a2020;background:#fff7f7}.proof-approval-field.proof-error input{outline:1px solid #8a2020;outline-offset:2px}";
    document.head.appendChild(style);

    footer.parentNode.insertBefore(wrap, footer);
    return true;
  }

  function isProofApprovalAccepted() {
    var input = document.getElementById("proofApproval");
    return !!(input && input.checked);
  }

  function showProofApprovalError() {
    var input = document.getElementById("proofApproval");
    var wrap = input ? input.closest(".proof-approval-field") : null;
    if (wrap) {
      wrap.classList.add("proof-error");
      setTimeout(function() { wrap.classList.remove("proof-error"); }, 1800);
    }
    if (input) input.focus();
  }

  function installProofApprovalField() {
    if (window._memProofApprovalInstalled) return true;
    if (!ensureProofApprovalField()) return false;
    window._memProofApprovalInstalled = true;
    return true;
  }

  function ensureLiftgateField() {
    if (document.getElementById("liftgateField")) return true;

    var footer = document.getElementById("memFooter");
    if (!footer || !footer.parentNode) return false;

    var wrap = document.createElement("div");
    wrap.className = "liftgate-field";
    wrap.id = "liftgateField";
    wrap.innerHTML = '<div class="liftgate-label">Do you need a lift gate for delivery?</div><div class="liftgate-options"><label><input type="radio" name="liftgateDelivery" value="Yes"> Yes, I need a liftgate</label><label><input type="radio" name="liftgateDelivery" value="No"> No, I do not need a liftgate</label></div>';

    var style = document.createElement("style");
    style.textContent = ".liftgate-field{padding:10px 22px;background:#f5f4fb;border-top:1px solid #c5bfe8;color:#7a6baa}.liftgate-label{font-family:'Cinzel',serif;font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:#7a6baa;margin-bottom:7px}.liftgate-options{display:flex;flex-wrap:wrap;gap:8px 16px}.liftgate-options label{display:flex;align-items:center;gap:6px;font-family:'IM Fell English',serif;font-size:11px;font-style:italic;line-height:1.3;cursor:pointer}.liftgate-options input{accent-color:#c8860a}.liftgate-field.liftgate-error{background:#fff7f7}.liftgate-field.liftgate-error .liftgate-label,.liftgate-field.liftgate-error label{color:#8a2020}.liftgate-field.liftgate-error input{outline:1px solid #8a2020;outline-offset:2px}";
    document.head.appendChild(style);

    var proof = document.getElementById("proofApproval");
    var proofWrap = proof ? proof.closest(".proof-approval-field") : null;
    if (proofWrap && proofWrap.parentNode === footer.parentNode) footer.parentNode.insertBefore(wrap, proofWrap);
    else footer.parentNode.insertBefore(wrap, footer);
    return true;
  }

  function getLiftgateDeliveryValue() {
    var selected = document.querySelector("input[name=\"liftgateDelivery\"]:checked");
    return selected ? selected.value : "";
  }

  function showLiftgateError() {
    var field = document.getElementById("liftgateField");
    var first = document.querySelector("input[name=\"liftgateDelivery\"]");
    if (field) {
      field.classList.add("liftgate-error");
      setTimeout(function() { field.classList.remove("liftgate-error"); }, 1800);
    }
    if (first) first.focus();
  }

  function installLiftgateField() {
    if (window._memLiftgateInstalled) return true;
    if (!ensureLiftgateField()) return false;
    window._memLiftgateInstalled = true;
    return true;
  }

  function keepTextLayoutStable() {
    var txt = document.getElementById("engText");
    var modalState = getModalState();
    if (!txt || txt.style.display === "none") return;

    if (!modalState.textPos) modalState.textPos = {};
    if (modalState.textPos.x === undefined || modalState.textPos.x === null) modalState.textPos.x = 5;
    if (modalState.textPos.y === undefined || modalState.textPos.y === null) modalState.textPos.y = 55;

    txt.style.left = modalState.textPos.x + "%";
    txt.style.top = modalState.textPos.y + "%";
    txt.style.width = "90%";

    if (typeof window.fitText === "function") window.fitText();
  }

  function installTextAutoFlow() {
    if (window._memTextAutoFlowInstalled) return true;
    window._memTextAutoFlowInstalled = true;
    window._memOriginalAdjustTextAroundPortrait = window.adjustTextAroundPortrait;
    window._memOriginalFitText = window.fitText;
    window.adjustTextAroundPortrait = keepTextLayoutStable;
    window.fitText = fitTextInsideCurrentBox;
    return true;
  }

  function installResizeHandles() {
    if (window._memResizeHandlesInstalled) return;
    window._memResizeHandlesInstalled = true;
    var box = ensureSelectionBox();
    if (!box) return;

    function clamp(v, min, max) {
      return Math.min(Math.max(v, min), max);
    }

    box.addEventListener("mousedown", function(e) {
      var handle = e.target && e.target.getAttribute ? e.target.getAttribute("data-h") : null;
      if (!handle) return;
      e.preventDefault();
      e.stopPropagation();
      var zone = getArtZone();
      var activeId = state.activeLayerId;
      var layerEl = activeId ? getLayerElById(activeId) : null;
      if (!zone || !layerEl) return;
      var layerObj = null;
      for (var i = 0; i < state.layers.length; i++) {
        if (state.layers[i].id === activeId) { layerObj = state.layers[i]; break; }
      }
      if (!layerObj) return;

      var z = zone.getBoundingClientRect();
      var startX = e.clientX;
      var startY = e.clientY;
      var startLeft = (parseFloat(layerEl.style.left) / 100) * z.width;
      var startTop = (parseFloat(layerEl.style.top) / 100) * z.height;
      var startW = layerEl.offsetWidth;

      function mm(ev) {
        var dx = ev.clientX - startX;
        var dy = ev.clientY - startY;
        var nextW = startW;
        var nextLeft = startLeft;
        if (handle.indexOf("w") >= 0) {
          nextW = startW - dx;
          nextLeft = startLeft + dx;
        } else if (handle.indexOf("e") >= 0) {
          nextW = startW + dx;
        } else if (handle === "n") {
          nextW = startW - dy;
          nextLeft = startLeft + (dy / 2);
        } else if (handle === "s") {
          nextW = startW + dy;
          nextLeft = startLeft - (dy / 2);
        }

        var minW = Math.max(32, z.width * 0.06);
        var maxW = Math.max(minW, z.width * 0.92);
        nextW = clamp(nextW, minW, maxW);
        nextLeft = clamp(nextLeft, 0, z.width - nextW);

        var lp = (nextLeft / z.width) * 100;
        var wp = (nextW / z.width) * 100;
        layerEl.style.left = lp + "%";
        layerEl.style.width = wp + "%";
        layerObj.left = lp;
        layerObj.width = wp;
        syncSelectionBox();
        if (typeof window.adjustTextAroundPortrait === "function") window.adjustTextAroundPortrait();
      }

      function mu() {
        document.removeEventListener("mousemove", mm);
        document.removeEventListener("mouseup", mu);
        syncLayerUi();
      }

      document.addEventListener("mousemove", mm);
      document.addEventListener("mouseup", mu);
    });
  }

  function syncLayerUi() {
    var modalState = getModalState();
    var imgThumb = document.getElementById("imgThumb");
    var imgName = document.getElementById("imgPreviewName");
    var uploadArea = document.getElementById("imgUploadArea");
    var previewRow = document.getElementById("imgPreviewRow");
    var hint = document.getElementById("engHint");
    var dragTip = document.getElementById("imgDragTip");

    if (!state.layers.length) {
      modalState.hasPhoto = false;
      modalState.imageDataUrl = null;
      modalState.imageFile = null;
      modalState.artLabel = "";
      modalState.artPricingSummary = null;
      if (imgThumb) imgThumb.src = "";
      if (imgName) imgName.textContent = "";
      if (previewRow) previewRow.classList.remove("visible");
      if (uploadArea) uploadArea.style.display = "block";
      if (dragTip) dragTip.style.display = "none";
      if (hint && !(document.getElementById("engInput") || {}).value) hint.style.display = "block";
    } else {
      var active = getActiveLayer();
      setLayerActive(active.id);

      modalState.hasPhoto = true;
      modalState.imageDataUrl = active.src;
      modalState.imageFile = active.fileObj || { name: active.label };
      modalState.artLabel = state.layers.map(function(l) { return l.label; }).join(" | ");
      modalState.artType = active.artType || modalState.artType || "flat";
      modalState.artPricingSummary = summarizeArtPricing();

      if (imgThumb) imgThumb.src = active.src;
      if (imgName) imgName.textContent = active.label;
      if (uploadArea) uploadArea.style.display = "none";
      if (previewRow) previewRow.classList.add("visible");
      if (dragTip) dragTip.style.display = "block";
      if (hint) hint.style.display = "none";
    }

    refreshPricingUi();
    if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
    else if (typeof window.updatePrice === "function") window.updatePrice();
    if (typeof queueBottomBaseLayout === "function") queueBottomBaseLayout();
    if (typeof applyAdaptivePreviewSizing === "function") applyAdaptivePreviewSizing();
    if (typeof window.adjustTextAroundPortrait === "function") window.adjustTextAroundPortrait();
    syncSelectionBox();
  }

  function getHeadstoneLayerBoundsPx(zone, layerEl) {
    if (!zone) return null;

    var baseImg = document.getElementById("hsBaseImg");
    var zoneRect = zone.getBoundingClientRect();
    if (!baseImg || !zoneRect.width || !zoneRect.height) {
      return {
        left: 0,
        top: 0,
        right: zone ? zone.clientWidth || zoneRect.width : 0,
        bottom: zone ? zone.clientHeight || zoneRect.height : 0
      };
    }

    var imgRect = baseImg.getBoundingClientRect();
    if (!imgRect.width || !imgRect.height) {
      return {
        left: 0,
        top: 0,
        right: zoneRect.width,
        bottom: zoneRect.height
      };
    }

    var left = imgRect.left - zoneRect.left;
    var top = imgRect.top - zoneRect.top;
    var right = left + imgRect.width;
    var bottom = top + imgRect.height;

    left = Math.max(0, left);
    top = Math.max(0, top);
    right = Math.min(zoneRect.width, right);
    bottom = Math.min(zoneRect.height, bottom);

    if (right <= left || bottom <= top) {
      return {
        left: 0,
        top: 0,
        right: zoneRect.width,
        bottom: zoneRect.height
      };
    }

    return {
      left: left,
      top: top,
      right: Math.max(left, right - (layerEl ? layerEl.offsetWidth || 0 : 0)),
      bottom: Math.max(top, bottom - (layerEl ? layerEl.offsetHeight || 0 : 0))
    };
  }

  function makeLayerDraggable(layerEl, layerObj) {
    var startX = 0;
    var startY = 0;
    var startLeftPx = 0;
    var startTopPx = 0;

    function clamp(v, min, max) {
      return Math.min(Math.max(v, min), max);
    }

    function startDrag(cx, cy) {
      var zone = getArtZone();
      if (!zone) return;
      var z = zone.getBoundingClientRect();
      startX = cx;
      startY = cy;
      startLeftPx = (parseFloat(layerEl.style.left) / 100) * z.width;
      startTopPx = (parseFloat(layerEl.style.top) / 100) * z.height;
      layerEl.classList.add("dragging");
      setLayerActive(layerObj.id);
      syncLayerUi();
    }

    function moveDrag(cx, cy) {
      var zone = getArtZone();
      if (!zone) return;
      var z = zone.getBoundingClientRect();
      var nextLeft = startLeftPx + (cx - startX);
      var nextTop = startTopPx + (cy - startY);
      var bounds = getHeadstoneLayerBoundsPx(zone, layerEl);
      nextLeft = bounds ? clamp(nextLeft, bounds.left, bounds.right) : clamp(nextLeft, 0, z.width - layerEl.offsetWidth);
      nextTop = bounds ? clamp(nextTop, bounds.top, bounds.bottom) : clamp(nextTop, 0, z.height - layerEl.offsetHeight);
      var lp = (nextLeft / z.width) * 100;
      var tp = (nextTop / z.height) * 100;
      layerEl.style.left = lp + "%";
      layerEl.style.top = tp + "%";
      layerObj.left = lp;
      layerObj.top = tp;
      syncSelectionBox();
      if (typeof window.adjustTextAroundPortrait === "function") window.adjustTextAroundPortrait();
    }

    function endDrag() {
      layerEl.classList.remove("dragging");
    }

    layerEl.addEventListener("mousedown", function(e) {
      e.preventDefault();
      startDrag(e.clientX, e.clientY);
      function mm(ev) { moveDrag(ev.clientX, ev.clientY); }
      function mu() {
        endDrag();
        document.removeEventListener("mousemove", mm);
        document.removeEventListener("mouseup", mu);
      }
      document.addEventListener("mousemove", mm);
      document.addEventListener("mouseup", mu);
    });

    layerEl.addEventListener("touchstart", function(e) {
      if (!e.touches || !e.touches[0]) return;
      startDrag(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    layerEl.addEventListener("touchmove", function(e) {
      if (!e.touches || !e.touches[0]) return;
      e.preventDefault();
      moveDrag(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });

    layerEl.addEventListener("touchend", endDrag);
    layerEl.addEventListener("click", function() {
      setLayerActive(layerObj.id);
      syncLayerUi();
    });
  }

  function addLayer(src, label, artType, fileObj, pricingMeta) {
    var zone = getArtZone();
    if (!zone || !src) return;
    ensureLayerCss();

    var basePortrait = document.getElementById("hsPortrait");
    if (basePortrait) basePortrait.classList.remove("visible");

    var layerId = "l" + (++state.layerSeq);
    var priceKey = pricingMeta && pricingMeta.key ? pricingMeta.key : "flat_unlimited";
    var isLaserLayer = artType === "laser" || String(priceKey || "").indexOf("laser") === 0;
    var isBronzeLayer = artType === "bronze" || String(priceKey || "").indexOf("bronze") === 0;
    var layerObj = {
      id: layerId,
      src: src,
      label: label,
      fileObj: fileObj || { name: label },
      artType: artType || "flat",
      lightMode: !(fileObj && fileObj.type) && !isLaserLayer && !isBronzeLayer,
      laserMode: isLaserLayer,
      bronzeMode: isBronzeLayer,
      priceKey: priceKey,
      priceAmount: pricingMeta && pricingMeta.amount ? pricingMeta.amount : PRICE_BOOK.flatArtEach,
      priceMode: pricingMeta && pricingMeta.mode ? pricingMeta.mode : "per_layer",
      priceLabel: pricingMeta && pricingMeta.label ? pricingMeta.label : "Flat-Carved Art",
      left: 31,
      top: 4,
      width: getInitialLayerWidth(isBronzeLayer, priceKey, fileObj)
    };

    var offset = (state.layers.length % 6) * 5;
    layerObj.left = Math.min(70, layerObj.left + offset);
    layerObj.top = Math.min(70, layerObj.top + offset);

    var layerEl = document.createElement("div");
    layerEl.className = "hs-portrait hs-portrait-layer shape-natural visible";
    if (layerObj.lightMode) layerEl.classList.add("art-light");
    if (layerObj.laserMode) layerEl.classList.add("art-laser");
    if (layerObj.bronzeMode) layerEl.classList.add("art-bronze");
    layerEl.setAttribute("data-layer-id", layerId);
    layerEl.style.left = layerObj.left + "%";
    layerEl.style.top = layerObj.top + "%";
    layerEl.style.width = layerObj.width + "%";
    layerEl.style.height = "auto";

    var img = document.createElement("img");
    img.src = src;
    img.alt = label;
    img.addEventListener("load", function() {
      syncLayerPricingFromImage(layerObj, img);
      applyBronzeLayerPreview(layerObj, layerEl, img);
      if (typeof window.adjustTextAroundPortrait === "function") window.adjustTextAroundPortrait();
      refreshPricingUi();
      if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
      else if (typeof window.updatePrice === "function") window.updatePrice();
    });
    layerEl.appendChild(img);
    zone.appendChild(layerEl);

    state.layers.push(layerObj);
    makeLayerDraggable(layerEl, layerObj);
    setLayerActive(layerId);
    syncLayerUi();
  }

  function removeActiveLayer() {
    if (!state.layers.length) return false;
    var removeId = state.activeLayerId || state.layers[state.layers.length - 1].id;
    var idx = -1;
    for (var i = 0; i < state.layers.length; i++) {
      if (state.layers[i].id === removeId) {
        idx = i;
        break;
      }
    }
    if (idx < 0) idx = state.layers.length - 1;
    var layer = state.layers[idx];
    var el = getLayerElById(layer.id);
    if (el && el.parentNode) el.parentNode.removeChild(el);
    state.layers.splice(idx, 1);
    state.activeLayerId = state.layers.length ? state.layers[state.layers.length - 1].id : null;
    syncLayerUi();
    return true;
  }

  function resizeActiveLayer() {
    var pct = getArtSizePercent();
    var activeId = state.activeLayerId || (state.layers.length ? state.layers[state.layers.length - 1].id : null);
    if (!activeId) return;
    for (var i = 0; i < state.layers.length; i++) {
      if (state.layers[i].id === activeId) {
        state.layers[i].width = pct;
        break;
      }
    }
    var el = getLayerElById(activeId);
    if (el) el.style.width = pct + "%";
    syncLayerUi();
  }

  function applySelection(src, label, node, fileObj) {
    var artType = (node && node.artType) || "flat";
    if (typeof window.selectArtType === "function") window.selectArtType(artType);
    addLayer(src, label, artType, fileObj, buildLayerPricing(node, fileObj, label));
  }

  function makeCard(name, imgUrl, onClick) {
    var card = document.createElement("div");
    card.className = "art-card";
    card.addEventListener("click", onClick);

    var thumb = document.createElement("div");
    thumb.className = "art-card-thumb";
    if (imgUrl) {
      var img = document.createElement("img");
      img.src = imgUrl;
      img.alt = name;
      thumb.appendChild(img);
    }

    var label = document.createElement("div");
    label.className = "art-card-name";
    label.textContent = name;

    card.appendChild(thumb);
    card.appendChild(label);
    return card;
  }

  function uploadCard() {
    return makeCard("Upload Your Own Art", null, function() {
      var input = document.getElementById("imgFileInput");
      if (input) input.click();
    });
  }

  function renderUploadCards(grid, node) {
    if (!state.uploads.length) return;
    state.uploads.forEach(function(u, idx) {
      grid.appendChild(
        makeCard("My Upload " + (idx + 1), u.src, function() {
          applySelection(u.src, u.name || ("My Upload " + (idx + 1)), node || { artType: "flat" }, u.fileObj || null);
        })
      );
    });
  }

  function renderBrowser() {
    var grid = document.getElementById("artBrowserGrid");
    var backBtn = document.getElementById("artBackBtn");
    var crumb = document.getElementById("artCrumb");
    if (!grid || !backBtn || !crumb) return;

    crumb.textContent = currentCrumb(state.path);
    backBtn.style.display = state.path.length > 1 ? "" : "none";
    grid.innerHTML = "";
    refreshPricingUi();

    if (state.path.length === 1) {
      Object.keys(TREE).forEach(function(catName) {
        var node = TREE[catName];
        var card = makeCard(catName, null, function() {
          state.path = ["main", catName];
          renderBrowser();
        });
        grid.appendChild(card);

        var forcedHandle = CATEGORY_THUMB_HANDLE[catName];
        var thumbPromise = forcedHandle
          ? firstImageByHandle(forcedHandle).then(function(url) { return url || firstThumbForNode(node); })
          : firstThumbForNode(node);

        thumbPromise.then(function(url) {
          if (!url) return;
          var thumb = card.querySelector(".art-card-thumb");
          if (!thumb) return;
          thumb.innerHTML = '<img src="' + url + '" alt="' + catName + '">';
        });
      });

      renderUploadCards(grid, null);
      grid.appendChild(uploadCard());
      return;
    }

    var node = pathNode(state.path);
    if (!node) {
      renderUploadCards(grid, null);
      grid.appendChild(makeCard("No items found", null, function() {}));
      grid.appendChild(uploadCard());
      return;
    }

    if (node.subs) {
      Object.keys(node.subs).forEach(function(subName) {
        var subNode = node.subs[subName];
        var card = makeCard(subName, null, function() {
          state.path.push(subName);
          renderBrowser();
        });
        grid.appendChild(card);
        firstThumbForNode(subNode).then(function(url) {
          if (!url) return;
          var thumb = card.querySelector(".art-card-thumb");
          if (!thumb) return;
          thumb.innerHTML = '<img src="' + url + '" alt="' + subName + '">';
        });
      });

      renderUploadCards(grid, node);
      grid.appendChild(uploadCard());
      return;
    }

    if (!node.handle) {
      renderUploadCards(grid, node);
      grid.appendChild(makeCard("No images found", null, function() {}));
      grid.appendChild(uploadCard());
      return;
    }

    entryFieldsByHandle(node.handle).then(function(fields) {
      grid.innerHTML = "";

      var count = 0;
      for (var i = 1; i <= 5; i++) {
        var key = "img_" + i;
        if (!fields[key]) continue;
        (function(url, idx) {
          grid.appendChild(makeCard("Image " + idx, url, function() {
            applySelection(url, state.path.slice(1).join(" / ") + " / Image " + idx, node, { name: "Image " + idx });
          }));
          count++;
        })(fields[key], i);
      }

      renderUploadCards(grid, node);

      if (!count && !state.uploads.length) {
        grid.appendChild(makeCard("No images found", null, function() {}));
      }

      grid.appendChild(uploadCard());
    });
  }

  function handleUpload(event) {
    var file = event && event.target && event.target.files ? event.target.files[0] : null;
    if (!file) return;

    var reader = new FileReader();
    reader.onload = function(e) {
      var dataUrl = e && e.target ? e.target.result : null;
      if (!dataUrl) return;

      state.uploads.push({
        src: dataUrl,
        name: file.name,
        fileObj: file
      });

      applySelection(dataUrl, file.name, pathNode(state.path) || { artType: "flat" }, file);
      renderBrowser();

      if (event && event.target) {
        event.target.value = "";
      }
    };
    reader.readAsDataURL(file);
  }

  function installOverrides() {
    window.onImageUpload = handleUpload;

    var originalRemove = window.removeImage;
    window.removeImage = function() {
      var removed = removeActiveLayer();
      if (!removed && typeof originalRemove === "function") originalRemove();
      renderBrowser();
    };

    var originalApplyArtSize = window.applyArtSize;
    window.applyArtSize = function() {
      if (typeof originalApplyArtSize === "function") originalApplyArtSize();
      resizeActiveLayer();
    };
  }

  function installModalAddToCartGuard() {
    var btn = document.getElementById("atcBtn");
    if (!btn) return false;

    btn.setAttribute("type", "button");

    if (btn._memModalAddToCartGuardInstalled) return true;
    btn._memModalAddToCartGuardInstalled = true;

    btn.onclick = null;
    btn.removeAttribute("onclick");

    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (typeof window.doAddToCart === "function") window.doAddToCart();
      return false;
    }, true);

    var form = btn.closest ? btn.closest("form") : null;
    if (form && !form._memModalAddToCartSubmitGuardInstalled) {
      form._memModalAddToCartSubmitGuardInstalled = true;
      form.addEventListener("submit", function(e) {
        var modal = document.getElementById("memModal");
        if (!modal || !modal.classList.contains("open") || !modal.contains(btn)) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        return false;
      }, true);
    }

    return true;
  }

  function installPricingOverrides() {
    if (window._memPricingOverridesInstalled) return true;
    if (typeof window.updatePrice !== "function" || typeof window.selectArtType !== "function" || typeof window.doAddToCart !== "function") return false;

    window._memPricingOverridesInstalled = true;

    var originalSelectArtType = window.selectArtType;

    window.selectArtType = function(type) {
      var result = originalSelectArtType.apply(this, arguments);
      var modalState = getModalState();
      if (modalState) modalState.artType = type || modalState.artType || "flat";
      refreshPricingUi();
      if (typeof window.updatePrice === "function") window.updatePrice();
      return result;
    };

    window.updatePrice = function() {
      var modalState = getModalState();
      var pricing = buildOrderPricing();
      var rowText = document.getElementById("priceRowText");
      var rowArt = document.getElementById("priceRowPhoto");
      var rowArtAmt = document.getElementById("priceRowPhotoAmt");
      var rowVase = document.getElementById("priceRowVase");
      var rowVaseAmt = document.getElementById("priceRowVaseAmt");
      var rowBottomBase = ensureBottomBasePriceRow();
      var rowBottomBaseAmt = document.getElementById("priceRowBottomBaseAmt");
      var totalEl = document.getElementById("priceTotalValue");
      var baseEl = document.getElementById("priceBaseDisplay");
      var atcLabel = document.getElementById("atcLabel");

      refreshPricingUi();

      if (baseEl) baseEl.textContent = formatMoney(pricing.base);

      if (rowText) rowText.style.display = pricing.text > 0 ? "flex" : "none";

      if (rowArt) rowArt.style.display = pricing.art.total > 0 ? "flex" : "none";
      if (rowArtAmt) rowArtAmt.textContent = formatPlusMoney(pricing.art.total);

      if (rowVase && rowVaseAmt) {
        if (pricing.vaseCount > 0) {
          rowVase.style.display = "flex";
          rowVaseAmt.textContent = formatPlusMoney(pricing.vase);
        } else {
          rowVase.style.display = "none";
          rowVaseAmt.textContent = "";
        }
      }

      if (rowBottomBase && rowBottomBaseAmt) {
        if (pricing.bottomBase && pricing.bottomBase.price > 0) {
          rowBottomBase.style.display = "flex";
          rowBottomBaseAmt.textContent = formatPlusMoney(pricing.bottomBase.price);
        } else {
          rowBottomBase.style.display = "none";
          rowBottomBaseAmt.textContent = "";
        }
      }

      if (totalEl) totalEl.textContent = formatMoney(pricing.grandTotal);
      if (atcLabel && atcLabel.textContent !== "Adding…") atcLabel.textContent = "Add to Cart — " + formatMoney(pricing.grandTotal);

      if (modalState) modalState.artPricingSummary = pricing.art;
      return pricing.grandTotal;
    };

    window._memUpdatePrice = window.updatePrice;

    window.doAddToCart = function() {
      var modalState = getModalState();
      var textValue = modalState && modalState.text ? modalState.text.trim() : "";
      var textArea = document.getElementById("engInput");
      var btn = document.getElementById("atcBtn");
      var lbl = document.getElementById("atcLabel");
      var pricing = buildOrderPricing();

      if (!textValue) {
        if (textArea) {
          textArea.style.borderColor = "#8a2020";
          textArea.focus();
          setTimeout(function() { textArea.style.borderColor = ""; }, 1600);
        }
        return;
      }

      if (!isProofApprovalAccepted()) {
        showProofApprovalError();
        return;
      }

      var liftgateDelivery = getLiftgateDeliveryValue();
      if (!liftgateDelivery) {
        showLiftgateError();
        return;
      }

      if (btn) btn.disabled = true;
      if (lbl) lbl.textContent = "Adding…";

      var variantId = getCurrentVariantId();

      if (!variantId) {
        if (lbl) lbl.textContent = "Variant missing";
        if (btn) btn.style.background = "#3a1010";
        setTimeout(function() {
          if (lbl) lbl.textContent = "Add to Cart";
          if (btn) {
            btn.style.background = "";
            btn.disabled = false;
          }
        }, 2500);
        return;
      }

      if (window._memModalAddToCartInFlight) return;
      window._memModalAddToCartInFlight = true;

      var bottomBase = pricing.bottomBase || {};
      var bottomBaseSelected = !!(bottomBase.selected && bottomBase.available);
      var verseOrSaying = getVerseValue();
      var structuredEngraving = modalState && modalState.structuredEngraving ? modalState.structuredEngraving : getStructuredEngravingValues();
      var props = {
        "Engraving": textValue,
        "Name": structuredEngraving.firstName || "N/A",
        "Last Name": structuredEngraving.lastName || "N/A",
        "Birth Date": structuredEngraving.birthDate || "N/A",
        "Death Date": structuredEngraving.deathDate || "N/A",
        "Verse or Saying": verseOrSaying || "None",
        "Proof Approval": "Accepted",
        "Liftgate Delivery": liftgateDelivery,
        "Font": (document.getElementById("fontSelect") || {}).options ? document.getElementById("fontSelect").options[document.getElementById("fontSelect").selectedIndex].text : "",
        "Size": (document.getElementById("sizeSelect") || {}).options ? document.getElementById("sizeSelect").options[document.getElementById("sizeSelect").selectedIndex].text : "",
        "Line Spacing": (document.getElementById("spacingSelect") || {}).options ? document.getElementById("spacingSelect").options[document.getElementById("spacingSelect").selectedIndex].text : "",
        "Align": (document.getElementById("alignSelect") || {}).options ? document.getElementById("alignSelect").options[document.getElementById("alignSelect").selectedIndex].text : "",
        "Style": (document.getElementById("styleSelect") || {}).options ? document.getElementById("styleSelect").options[document.getElementById("styleSelect").selectedIndex].text : "",
        "Color": document.getElementById("tcolorValLabel") ? document.getElementById("tcolorValLabel").textContent : "White",
        "Vase": pricing.vaseCount === 0 ? "N" : pricing.vaseCount + " Vase(s) " + formatPlusMoney(pricing.vase),
        "Vase Color": pricing.vaseCount === 0 ? "N/A" : (pricing.vaseColor || "N/A"),
        "Base Stone": bottomBaseSelected ? "Yes" : "No",
        "Base Stone Price": bottomBaseSelected ? (bottomBase.price > 0 ? formatPlusMoney(bottomBase.price) : "Price unavailable") : "None",
        "Base Stone Color": bottomBaseSelected ? (bottomBase.color || "N/A") : "N/A",
        "Base Stone Size": bottomBaseSelected ? (bottomBase.baseSize || "N/A") : "N/A",
        "Base Stone Option": bottomBaseSelected ? (bottomBase.baseOption || "N/A") : "N/A",
        "Base Stone Finish": bottomBaseSelected ? (bottomBase.finish || "N/A") : "N/A",
        "Base Stone For": bottomBaseSelected ? (bottomBase.headstoneSize || "N/A") : "N/A",
        "Art": pricing.art.count ? getArtSelectionSummary() : "None",
        "Art Type": getArtTypeSummary(pricing.art),
        "Art Selection": pricing.art.count ? getArtSelectionSummary() : "N/A",
        "Art Pricing": getArtPricingSummary(pricing.art),
        "Art Layout": getArtLayoutSummary(),
        "Art Layers": String(pricing.art.count || 0),
        "Engraving Price": pricing.text > 0 ? formatPlusMoney(pricing.text) : "None",
        "Art Price": pricing.art.total > 0 ? formatPlusMoney(pricing.art.total) : "None",
        "Vase Price": pricing.vase > 0 ? formatPlusMoney(pricing.vase) : "None",
        "Add-on Total": formatMoney(pricing.addonTotal),
        "Order Total": formatMoney(pricing.grandTotal)
      };
      if (isCompanionProduct()) {
        props["Second Name"] = structuredEngraving.firstName2 || "N/A";
        props["Second Last Name"] = structuredEngraving.lastName2 || "N/A";
        props["Second Birth Date"] = structuredEngraving.birthDate2 || "N/A";
        props["Second Death Date"] = structuredEngraving.deathDate2 || "N/A";
      }
      if (isSpecialDesignProduct() && modalState && modalState.specialDesignTextBox) {
        props["Text Layout"] = "Special Design group: " +
          Math.round(modalState.specialDesignTextBox.left * 100) + "% left, " +
          Math.round(modalState.specialDesignTextBox.top * 100) + "% top, " +
          Math.round(modalState.specialDesignTextBox.width * 100) + "% width, " +
          Math.round(modalState.specialDesignTextBox.height * 100) + "% height";
      }
      mergeExternalLineItemProperties(props);

      uploadCustomerImagesForOrder()
        .then(function(uploaded) {
          addUploadedImageProperties(props, uploaded);
          mergeExternalLineItemProperties(props);
          return buildCartItemsWithCharges(variantId, props, pricing);
        })
        .then(function(items) {
          var cartSections = getCartSectionsForRender();
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: items,
              sections: cartSections,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function(res) {
          if (!res.ok) throw new Error("Cart err " + res.status);
          return res.json();
        })
        .then(function(addResponse) {
          var footer = document.getElementById("memFooter");
          var success = document.getElementById("memSuccess");
          if (footer) footer.style.display = "none";
          if (success) success.style.display = "block";
          markModalCartAddCompleted();
          refreshCartAfterModalAdd(addResponse);
          setTimeout(function() {
            if (typeof window.closeMem === "function") window.closeMem();
            setTimeout(function() {
              if (footer) footer.style.display = "flex";
              if (success) success.style.display = "none";
              if (btn) btn.disabled = false;
              if (btn) btn.style.background = "";
              window._memModalAddToCartInFlight = false;
              if (typeof window.updatePrice === "function") window.updatePrice();
            }, 400);
          }, 2200);
        }, function(err) {
          if (lbl) lbl.textContent = err && err.message && err.message.indexOf("Missing custom charge variant") >= 0 ? "Missing charge variant" : "Error — try again";
          if (window.console && console.warn) console.warn("[art_integration] Add to cart failed:", err);
          setTimeout(function() {
            if (lbl) lbl.textContent = "Add to Cart";
            if (btn) btn.disabled = false;
            if (btn) btn.style.background = "";
            window._memModalAddToCartInFlight = false;
            if (typeof window.updatePrice === "function") window.updatePrice();
          }, 2500);
        });
    };

    installModalAddToCartGuard();
    installRecentModalAddDuplicateGuard();
    refreshPricingUi();
    window.updatePrice();
    return true;
  }

  function hookBrowser() {
    var grid = document.getElementById("artBrowserGrid");
    var backBtn = document.getElementById("artBackBtn");
    if (!grid || !backBtn) return false;
    if (window._artIntegrationReady) return true;

    installOverrides();
    installResizeHandles();

    window.renderArtBrowser = renderBrowser;
    window.artBack = function() {
      if (state.path.length > 1) {
        state.path.pop();
        renderBrowser();
      }
    };

    renderBrowser();
    window._artIntegrationReady = true;
    return true;
  }

  var alphaProfileCache = {};
  var alphaProfilePending = {};
  var scanImagePending = {};
  var bottomBaseRenderCache = {};
  var bottomBaseRenderPending = {};
  var bottomBaseLayoutToken = 0;
  var visibleVaseSnapToken = 0;

  function limit(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function getImageSrc(imgEl) {
    if (!imgEl) return "";
    return imgEl.currentSrc || imgEl.src || "";
  }

  function waitForImageReady(imgEl) {
    return new Promise(function(resolve) {
      if (!imgEl) {
        resolve(false);
        return;
      }
      if (imgEl.complete && imgEl.naturalWidth && imgEl.naturalHeight) {
        resolve(true);
        return;
      }

      function done(ok) {
        imgEl.removeEventListener("load", onLoad);
        imgEl.removeEventListener("error", onError);
        resolve(ok);
      }
      function onLoad() { done(true); }
      function onError() { done(false); }

      imgEl.addEventListener("load", onLoad);
      imgEl.addEventListener("error", onError);
    });
  }

  function loadScanImage(src, fallbackEl) {
    if (!src) return Promise.resolve(fallbackEl || null);
    if (scanImagePending[src]) return scanImagePending[src];

    scanImagePending[src] = new Promise(function(resolve) {
      var probe = new Image();
      var settled = false;

      function finish(img) {
        if (settled) return;
        settled = true;
        resolve(img || fallbackEl || null);
      }

      if (!/^data:/i.test(src)) probe.crossOrigin = "anonymous";
      probe.onload = function() { finish(probe); };
      probe.onerror = function() { finish(fallbackEl || null); };
      probe.src = src;
      if (probe.complete && probe.naturalWidth && probe.naturalHeight) finish(probe);
    }).then(function(img) {
      delete scanImagePending[src];
      return img;
    });

    return scanImagePending[src];
  }

  function buildAlphaProfile(imgLike) {
    if (!imgLike || !imgLike.naturalWidth || !imgLike.naturalHeight) return null;

    var maxDim = 512;
    var scale = Math.min(1, maxDim / Math.max(imgLike.naturalWidth, imgLike.naturalHeight));
    var w = Math.max(1, Math.round(imgLike.naturalWidth * scale));
    var h = Math.max(1, Math.round(imgLike.naturalHeight * scale));
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    var ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return null;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(imgLike, 0, 0, w, h);

    var data = ctx.getImageData(0, 0, w, h).data;
    var rows = new Array(h);
    var alphaThreshold = 16;
    var top = h;
    var bottom = -1;
    var left = w;
    var right = -1;

    for (var y = 0; y < h; y++) {
      var rowOffset = y * w * 4;
      var rowLeft = -1;
      var rowRight = -1;

      for (var x = 0; x < w; x++) {
        if (data[rowOffset + (x * 4) + 3] >= alphaThreshold) {
          rowLeft = x;
          break;
        }
      }

      if (rowLeft < 0) continue;

      for (var xr = w - 1; xr >= rowLeft; xr--) {
        if (data[rowOffset + (xr * 4) + 3] >= alphaThreshold) {
          rowRight = xr;
          break;
        }
      }

      if (rowRight < 0) continue;

      rows[y] = {
        left: rowLeft / w,
        right: (rowRight + 1) / w
      };
      if (y < top) top = y;
      if (y > bottom) bottom = y;
      if (rowLeft < left) left = rowLeft;
      if (rowRight > right) right = rowRight;
    }

    if (bottom < 0 || right < 0) return null;

    return {
      width: w,
      height: h,
      rows: rows,
      top: top / h,
      bottom: (bottom + 1) / h,
      left: left / w,
      right: (right + 1) / w
    };
  }

  function buildBottomBaseVisibleProfileLegacy(imgLike) {
    if (!imgLike || !imgLike.naturalWidth || !imgLike.naturalHeight) return null;

    var maxDim = 512;
    var scale = Math.min(1, maxDim / Math.max(imgLike.naturalWidth, imgLike.naturalHeight));
    var w = Math.max(1, Math.round(imgLike.naturalWidth * scale));
    var h = Math.max(1, Math.round(imgLike.naturalHeight * scale));
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    var ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return null;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(imgLike, 0, 0, w, h);

    var data = ctx.getImageData(0, 0, w, h).data;
    var rows = new Array(h);
    var alphaThreshold = 16;
    var sampleSize = Math.max(4, Math.round(Math.min(w, h) * 0.06));
    var bg = { r: 0, g: 0, b: 0, l: 0, count: 0 };

    function sampleRect(x0, y0, x1, y1) {
      for (var sy = y0; sy < y1; sy++) {
        for (var sx = x0; sx < x1; sx++) {
          var idx = ((sy * w) + sx) * 4;
          var a = data[idx + 3];
          if (a < alphaThreshold) continue;
          var r = data[idx];
          var g = data[idx + 1];
          var b = data[idx + 2];
          bg.r += r;
          bg.g += g;
          bg.b += b;
          bg.l += ((0.2126 * r) + (0.7152 * g) + (0.0722 * b));
          bg.count += 1;
        }
      }
    }

    sampleRect(0, 0, sampleSize, sampleSize);
    sampleRect(Math.max(0, w - sampleSize), 0, w, sampleSize);
    sampleRect(0, Math.max(0, h - sampleSize), sampleSize, h);
    sampleRect(Math.max(0, w - sampleSize), Math.max(0, h - sampleSize), w, h);

    if (!bg.count) return buildAlphaProfile(imgLike);

    var bgR = bg.r / bg.count;
    var bgG = bg.g / bg.count;
    var bgB = bg.b / bg.count;
    var bgL = bg.l / bg.count;

    var top = h;
    var bottom = -1;
    var left = w;
    var right = -1;

    for (var y = 0; y < h; y++) {
      var rowLeft = -1;
      var rowRight = -1;

      for (var x = 0; x < w; x++) {
        var i = ((y * w) + x) * 4;
        var alpha = data[i + 3];
        if (alpha < alphaThreshold) continue;
        var rpx = data[i];
        var gpx = data[i + 1];
        var bpx = data[i + 2];
        var luma = (0.2126 * rpx) + (0.7152 * gpx) + (0.0722 * bpx);
        var dr = rpx - bgR;
        var dg = gpx - bgG;
        var db = bpx - bgB;
        var distSq = (dr * dr) + (dg * dg) + (db * db);
        var isVisible = distSq > 900 || Math.abs(luma - bgL) > 18;
        if (!isVisible) continue;
        rowLeft = x;
        break;
      }

      if (rowLeft < 0) continue;

      for (var xr = w - 1; xr >= rowLeft; xr--) {
        var ir = ((y * w) + xr) * 4;
        var alphar = data[ir + 3];
        if (alphar < alphaThreshold) continue;
        var rr = data[ir];
        var gr = data[ir + 1];
        var br = data[ir + 2];
        var lumar = (0.2126 * rr) + (0.7152 * gr) + (0.0722 * br);
        var drr = rr - bgR;
        var dgr = gr - bgG;
        var dbr = br - bgB;
        var distR = (drr * drr) + (dgr * dgr) + (dbr * dbr);
        var visibleR = distR > 900 || Math.abs(lumar - bgL) > 18;
        if (!visibleR) continue;
        rowRight = xr;
        break;
      }

      if (rowRight < 0) continue;

      rows[y] = {
        left: rowLeft / w,
        right: (rowRight + 1) / w
      };
      if (y < top) top = y;
      if (y > bottom) bottom = y;
      if (rowLeft < left) left = rowLeft;
      if (rowRight > right) right = rowRight;
    }

    if (bottom < 0 || right < 0) return buildAlphaProfile(imgLike);

    return {
      width: w,
      height: h,
      rows: rows,
      top: top / h,
      bottom: (bottom + 1) / h,
      left: left / w,
      right: (right + 1) / w
    };
  }

  function buildBottomBaseVisibleProfile(imgLike) {
    if (!imgLike || !imgLike.naturalWidth || !imgLike.naturalHeight) return null;

    var maxDim = 512;
    var scale = Math.min(1, maxDim / Math.max(imgLike.naturalWidth, imgLike.naturalHeight));
    var w = Math.max(1, Math.round(imgLike.naturalWidth * scale));
    var h = Math.max(1, Math.round(imgLike.naturalHeight * scale));
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;

    var ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return null;

    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(imgLike, 0, 0, w, h);

    var data = ctx.getImageData(0, 0, w, h).data;
    var alphaThreshold = 16;
    var sampleSize = Math.max(4, Math.round(Math.min(w, h) * 0.06));
    var bg = {
      r: 0,
      g: 0,
      b: 0,
      l: 0,
      count: 0,
      rMin: 255,
      gMin: 255,
      bMin: 255,
      lMin: 255,
      rMax: 0,
      gMax: 0,
      bMax: 0,
      lMax: 0
    };

    function sampleRect(x0, y0, x1, y1) {
      for (var sy = y0; sy < y1; sy++) {
        for (var sx = x0; sx < x1; sx++) {
          var idx = ((sy * w) + sx) * 4;
          var a = data[idx + 3];
          if (a < alphaThreshold) continue;
          var r = data[idx];
          var g = data[idx + 1];
          var b = data[idx + 2];
          var l = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
          bg.r += r;
          bg.g += g;
          bg.b += b;
          bg.l += l;
          bg.count += 1;
          if (r < bg.rMin) bg.rMin = r;
          if (g < bg.gMin) bg.gMin = g;
          if (b < bg.bMin) bg.bMin = b;
          if (l < bg.lMin) bg.lMin = l;
          if (r > bg.rMax) bg.rMax = r;
          if (g > bg.gMax) bg.gMax = g;
          if (b > bg.bMax) bg.bMax = b;
          if (l > bg.lMax) bg.lMax = l;
        }
      }
    }

    sampleRect(0, 0, sampleSize, sampleSize);
    sampleRect(Math.max(0, w - sampleSize), 0, w, sampleSize);
    sampleRect(0, Math.max(0, h - sampleSize), sampleSize, h);
    sampleRect(Math.max(0, w - sampleSize), Math.max(0, h - sampleSize), w, h);

    if (!bg.count) return buildAlphaProfile(imgLike);

    var bgR = bg.r / bg.count;
    var bgG = bg.g / bg.count;
    var bgB = bg.b / bg.count;
    var bgL = bg.l / bg.count;
    var sampleSpread = Math.max(
      bg.rMax - bg.rMin,
      bg.gMax - bg.gMin,
      bg.bMax - bg.bMin,
      bg.lMax - bg.lMin
    );
    var colorToleranceSq = Math.max(576, Math.pow(sampleSpread + 10, 2) * 2.4);
    var lumaTolerance = Math.max(10, sampleSpread + 6);
    var visited = new Uint8Array(w * h);
    var queue = [];
    var head = 0;
    var rows = new Array(h);

    function isBackgroundish(pixelIndex) {
      var idx = pixelIndex * 4;
      var alpha = data[idx + 3];
      if (alpha < alphaThreshold) return true;
      var rpx = data[idx];
      var gpx = data[idx + 1];
      var bpx = data[idx + 2];
      var luma = (0.2126 * rpx) + (0.7152 * gpx) + (0.0722 * bpx);
      var dr = rpx - bgR;
      var dg = gpx - bgG;
      var db = bpx - bgB;
      var distSq = (dr * dr) + (dg * dg) + (db * db);
      return distSq <= colorToleranceSq && Math.abs(luma - bgL) <= lumaTolerance;
    }

    function pushPixel(px, py) {
      if (px < 0 || px >= w || py < 0 || py >= h) return;
      var pixelIndex = (py * w) + px;
      if (visited[pixelIndex]) return;
      if (!isBackgroundish(pixelIndex)) return;
      visited[pixelIndex] = 1;
      queue.push(pixelIndex);
    }

    for (var x = 0; x < w; x++) {
      pushPixel(x, 0);
      pushPixel(x, h - 1);
    }
    for (var y = 1; y < h - 1; y++) {
      pushPixel(0, y);
      pushPixel(w - 1, y);
    }

    while (head < queue.length) {
      var pixelIndex = queue[head++];
      var px = pixelIndex % w;
      var py = Math.floor(pixelIndex / w);
      pushPixel(px - 1, py);
      pushPixel(px + 1, py);
      pushPixel(px, py - 1);
      pushPixel(px, py + 1);
    }

    var top = h;
    var bottom = -1;
    var left = w;
    var right = -1;

    for (var rowY = 0; rowY < h; rowY++) {
      var rowLeft = -1;
      var rowRight = -1;

      for (var rowX = 0; rowX < w; rowX++) {
        var rowIndex = (rowY * w) + rowX;
        var dataIndex = rowIndex * 4;
        if (data[dataIndex + 3] < alphaThreshold || visited[rowIndex]) continue;
        rowLeft = rowX;
        break;
      }

      if (rowLeft < 0) continue;

      for (var xr = w - 1; xr >= rowLeft; xr--) {
        var rowIndexR = (rowY * w) + xr;
        var dataIndexR = rowIndexR * 4;
        if (data[dataIndexR + 3] < alphaThreshold || visited[rowIndexR]) continue;
        rowRight = xr;
        break;
      }

      if (rowRight < 0) continue;

      rows[rowY] = {
        left: rowLeft / w,
        right: (rowRight + 1) / w
      };
      if (rowY < top) top = rowY;
      if (rowY > bottom) bottom = rowY;
      if (rowLeft < left) left = rowLeft;
      if (rowRight > right) right = rowRight;
    }

    var visibleW = right >= left ? ((right + 1 - left) / w) : 0;
    var visibleH = bottom >= top ? ((bottom + 1 - top) / h) : 0;
    if (bottom < 0 || right < 0 || visibleW < 0.08 || visibleH < 0.03) {
      return buildBottomBaseVisibleProfileLegacy(imgLike);
    }

    return {
      width: w,
      height: h,
      rows: rows,
      top: top / h,
      bottom: (bottom + 1) / h,
      left: left / w,
      right: (right + 1) / w
    };
  }

  function getAlphaProfile(imgEl) {
    var src = getImageSrc(imgEl);
    if (!src) return Promise.resolve(null);
    if (alphaProfileCache[src]) return Promise.resolve(alphaProfileCache[src]);
    if (alphaProfilePending[src]) return alphaProfilePending[src];

    alphaProfilePending[src] = loadScanImage(src, imgEl)
      .then(function(scanImg) {
        if (!scanImg) return null;
        try {
          return buildAlphaProfile(scanImg);
        } catch (err) {
          if (scanImg !== imgEl && imgEl && imgEl.naturalWidth && imgEl.naturalHeight) {
            try {
              return buildAlphaProfile(imgEl);
            } catch (fallbackErr) {
              return null;
            }
          }
          return null;
        }
      })
      .then(function(profile) {
        delete alphaProfilePending[src];
        if (profile) alphaProfileCache[src] = profile;
        return profile;
      }, function() {
        delete alphaProfilePending[src];
        return null;
      })
      ;

    return alphaProfilePending[src];
  }

  function quantileValue(values, q) {
    if (!values || !values.length) return 0;
    if (values.length === 1) return values[0];
    var pos = (values.length - 1) * q;
    var low = Math.floor(pos);
    var high = Math.ceil(pos);
    if (low === high) return values[low];
    var weight = pos - low;
    return values[low] + ((values[high] - values[low]) * weight);
  }

  function getBandEdge(profile, startFrac, endFrac, side) {
    if (!profile) return side === "left" ? 0 : 1;
    var startY = limit(Math.floor(startFrac * profile.height), 0, profile.height - 1);
    var endY = limit(Math.ceil(endFrac * profile.height) - 1, startY, profile.height - 1);
    var values = [];

    for (var y = startY; y <= endY; y++) {
      var row = profile.rows[y];
      if (!row) continue;
      values.push(side === "left" ? row.left : row.right);
    }

    if (!values.length) return side === "left" ? profile.left : profile.right;

    values.sort(function(a, b) { return a - b; });
    return quantileValue(values, side === "left" ? 0.2 : 0.8);
  }

  function getBottomBaseBand(profile) {
    if (!profile || !profile.rows || !profile.height) {
      var fallbackEnd = profile && typeof profile.bottom === "number" ? profile.bottom : 1;
      return {
        start: Math.max(0, fallbackEnd - 0.12),
        end: fallbackEnd
      };
    }

    var topY = limit(Math.floor(profile.top * profile.height), 0, profile.height - 1);
    var bottomY = limit(Math.ceil(profile.bottom * profile.height) - 1, topY, profile.height - 1);
    var visibleH = Math.max(1, bottomY - topY + 1);
    var scanTop = Math.max(topY, bottomY - Math.round(visibleH * 0.45));
    var maxWidth = 0;
    var y;

    for (y = scanTop; y <= bottomY; y++) {
      if (!profile.rows[y]) continue;
      maxWidth = Math.max(maxWidth, profile.rows[y].right - profile.rows[y].left);
    }

    if (!maxWidth) {
      return {
        start: Math.max(profile.top, profile.bottom - 0.12),
        end: profile.bottom
      };
    }

    var wideThreshold = maxWidth * 0.88;
    var baseTopY = bottomY;
    var foundBase = false;
    var gapRows = 0;
    var allowedGapRows = Math.max(2, Math.round(visibleH * 0.015));

    for (y = bottomY; y >= scanTop; y--) {
      var row = profile.rows[y];
      var rowWidth = row ? row.right - row.left : 0;

      if (rowWidth >= wideThreshold) {
        baseTopY = y;
        foundBase = true;
        gapRows = 0;
      } else if (foundBase) {
        gapRows += 1;
        if (gapRows > allowedGapRows) break;
      }
    }

    if (!foundBase) baseTopY = Math.max(topY, bottomY - Math.round(visibleH * 0.14));

    var minBaseRows = Math.max(3, Math.round(visibleH * 0.05));
    var maxBaseRows = Math.max(minBaseRows, Math.round(visibleH * 0.3));
    var baseRows = bottomY - baseTopY + 1;

    if (baseRows < minBaseRows) baseTopY = Math.max(scanTop, bottomY - minBaseRows + 1);
    else if (baseRows > maxBaseRows) baseTopY = Math.max(scanTop, bottomY - maxBaseRows + 1);

    return {
      start: baseTopY / profile.height,
      end: (bottomY + 1) / profile.height
    };
  }

  function getVaseAnchorBand(profile) {
    var stoneLayout = getStoneLayoutProfile();
    if (!profile || typeof profile.top !== "number" || typeof profile.bottom !== "number") {
      return {
        start: stoneLayout.vaseAnchorStart,
        end: stoneLayout.vaseAnchorEnd
      };
    }

    var visibleTop = profile.top;
    var visibleH = Math.max(0.06, profile.bottom - profile.top);
    return {
      start: Math.max(0, Math.min(1, visibleTop + (visibleH * stoneLayout.vaseAnchorStart))),
      end: Math.max(0, Math.min(1, visibleTop + (visibleH * stoneLayout.vaseAnchorEnd)))
    };
  }

  function rectWithinAncestor(el, ancestor) {
    if (!el || !ancestor) return null;
    var left = 0;
    var top = 0;
    var node = el;

    while (node && node !== ancestor) {
      left += node.offsetLeft || 0;
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }

    if (node !== ancestor) return null;

    var width = el.offsetWidth || 0;
    var height = el.offsetHeight || 0;
    return {
      left: left,
      top: top,
      width: width,
      height: height,
      right: left + width,
      bottom: top + height
    };
  }

  function getBottomBaseSrc() {
    var cfg = window.memCustomizerConfig || {};
    if (cfg.imgBottomBase) return cfg.imgBottomBase;
    if (cfg.bottomBaseImage) return cfg.bottomBaseImage;
    if (cfg.imgFootBase) return cfg.imgFootBase;
    var bridge = document.getElementById("memMetaBridge");
    if (!bridge) return "";
    return bridge.getAttribute("data-img-bottom-base") || bridge.getAttribute("data-img-base-bottom") || bridge.getAttribute("data-img-foot-base") || "";
  }

  function shouldShowBottomBase() {
    var cfg = window.memCustomizerConfig || {};
    return cfg.showBottomBase !== false && cfg.useBottomBase !== false && isBottomBaseSelected() && hasBottomBaseOption();
  }

  function hasBottomBaseOption() {
    var cfg = window.memCustomizerConfig || {};
    var bottomBaseSrc = getBottomBaseSrc();
    var layout = getStoneLayoutProfile();
    if (layout && layout.familyKey === "flush_marker" && !bottomBaseSrc) return false;
    return !!bottomBaseSrc || cfg.allowGeneratedBottomBase === true;
  }

  function isBottomBaseSelected() {
    var modalState = getModalState();
    return !!(modalState && modalState.bottomBase);
  }

  function setBottomBaseSelected(selected) {
    var modalState = getModalState();
    modalState.bottomBase = !!selected;
    syncBottomBaseToggleUi();
    queueBottomBaseLayout();
    if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
    else if (typeof window.updatePrice === "function") window.updatePrice();
  }

  function parseStoneDimensions(text) {
    if (!text) return null;
    var m = String(text).match(/(\d+(?:\.\d+)?)\s*(?:"|in|inch|”)?\s*x\s*(\d+(?:\.\d+)?)\s*(?:"|in|inch|”)?\s*x\s*(\d+(?:\.\d+)?)\s*(?:"|in|inch|”)?/i);
    if (!m) return null;
    return {
      width: parseFloat(m[1]) || 0,
      depth: parseFloat(m[2]) || 0,
      height: parseFloat(m[3]) || 0
    };
  }

  function getProductTitleText() {
    var cfg = window.memCustomizerConfig || {};
    if (cfg.productTitle) return cfg.productTitle;
    if (cfg.productName) return cfg.productName;

    var metaTitle = document.querySelector("meta[property='og:title'],meta[name='title']");
    if (metaTitle && metaTitle.content) return metaTitle.content;

    var titleEl = document.querySelector(".product__title h1,.product__title,h1.product-title,h1");
    if (titleEl && titleEl.textContent) return titleEl.textContent;

    return document.title || "";
  }

  function getStoneDimensions() {
    var cfg = window.memCustomizerConfig || {};
    if (cfg.stoneDimensions) return cfg.stoneDimensions;

    var width = parseFloat(cfg.stoneWidth || cfg.headstoneWidth);
    var depth = parseFloat(cfg.stoneDepth || cfg.headstoneDepth || cfg.stoneThickness || cfg.headstoneThickness);
    var height = parseFloat(cfg.stoneHeight || cfg.headstoneHeight);
    if (width > 0 && height > 0) {
      return {
        width: width,
        depth: depth > 0 ? depth : 0,
        height: height
      };
    }

    var parsed = parseStoneDimensions(getProductTitleText());
    return parsed || null;
  }

  function getStoneCatalogFamily(dims, titleText) {
    var title = String(titleText || "").toLowerCase();
    var width = dims && dims.width > 0 ? dims.width : 0;
    var depth = dims && dims.depth > 0 ? dims.depth : 0;
    var height = dims && dims.height > 0 ? dims.height : 0;
    var widthToHeight = width > 0 && height > 0 ? (width / height) : 1;
    var heightToWidth = width > 0 && height > 0 ? (height / width) : 1;

    if (/flush/.test(title)) return "flush_marker";

    if (/bevel/.test(title)) {
      if (height >= 7.5 || depth >= 11) return "bevel_8";
      return "bevel_6";
    }

    if (/slant/.test(title)) {
      if (depth >= 11.5) return "slant_12";
      if (height >= 17) return "slant_10_18";
      return "slant_10_16";
    }

    if (/serp|serptop/.test(title)) return depth >= 7 ? "serptop_8" : "serptop_6";

    if (/upright|tablet|monument|flat top|oval top|broken top|cross|heart|western|estate/.test(title)) {
      return depth >= 7 ? "upright_8" : "upright_6";
    }

    if (/marker/.test(title)) return "marker_standard";

    if (heightToWidth >= 1.08) return depth >= 7 ? "upright_8" : "upright_6";
    if (widthToHeight >= 2.1) return depth >= 7 ? "wide_8" : "wide_6";
    if (widthToHeight >= 1.2) return depth >= 7 ? "wide_8" : "wide_6";
    return depth >= 7 ? "standard_8" : "standard_6";
  }

  function getStoneLayoutType(dims, titleText) {
    var family = getStoneCatalogFamily(dims, titleText);
    var width = dims && dims.width > 0 ? dims.width : 0;
    var height = dims && dims.height > 0 ? dims.height : 0;
    var widthToHeight = width > 0 && height > 0 ? (width / height) : 1;

    if (family === "slant_10_16" || family === "slant_10_18" || family === "slant_12") return "slant";
    if (family === "bevel_6" || family === "bevel_8") return "bevel";
    if (family === "flush_marker" || family === "marker_standard") return "marker";
    if (family === "serptop_6" || family === "serptop_8" || family === "upright_6" || family === "upright_8") return "upright";
    if (family === "wide_8" || family === "wide_6") return widthToHeight >= 2.1 ? "low_wide" : "wide";
    return "standard";
  }

  function getStoneLayoutProfile() {
    var cfg = window.memCustomizerConfig || {};
    var dims = getStoneDimensions() || { width: 0, depth: 0, height: 0 };
    var title = getProductTitleText();
    var widthToHeight = dims.width > 0 && dims.height > 0 ? (dims.width / dims.height) : 1;
    var heightToWidth = dims.width > 0 && dims.height > 0 ? (dims.height / dims.width) : 1;
    var familyKey = getStoneCatalogFamily(dims, title);
    var type = getStoneLayoutType(dims, title);
    var profile = {
      type: type,
      familyKey: familyKey,
      title: title,
      dims: dims,
      widthToHeight: widthToHeight,
      heightToWidth: heightToWidth,
      isUpright: type === "upright",
      baseWidthVisualScale: 1.04,
      baseWidthScaleMin: 0.88,
      baseWidthScaleMax: 1.18,
      baseWidthMinRatio: 1.02,
      baseTotalOverhang: 4,
      catalogBaseMode: "upright",
      catalogBaseDepthKey: (Number(dims.depth) || 0) >= 7 ? "8" : "6",
      catalogBaseWidthSmallThreshold: 24,
      catalogBaseOverhangXs: 8,
      catalogBaseOverhangSmall: 6,
      catalogBaseOverhangLarge: 4,
      catalogBaseHeightInches: 0,
      catalogBaseDepthInches: 0,
      baseHeightVisualScale: 0.78,
      baseHeightCapRatio: 0,
      baseHeightRatioFallback: 0.11,
      baseOverlapRatio: 0.06,
      baseBackgroundPosition: "center bottom",
      uprightBottomReserve: 58,
      uprightMinHeight: 220,
      uprightMaxHeight: 430,
      uprightMaxWidthFactor: 0.74,
      uprightMaxWidthPx: 430,
      vaseVisibleHeightRatio: 0.5,
      vaseWidthScale: 0,
      vaseHeightCapRatio: 0,
      vaseMinVisibleHeight: 42,
      vaseAnchorStart: 0.36,
      vaseAnchorEnd: 0.78,
      vaseOverlapScale: 0.02,
      vaseFaceInsetRatio: 0,
      vaseDragOuterFactor: 1.35,
      vaseDragInnerFactor: 0.95
    };

    switch (type) {
      case "upright":
        profile.vaseVisibleHeightRatio = 0.34;
        profile.vaseWidthScale = 1.08;
        profile.vaseHeightCapRatio = 0.34;
        profile.vaseAnchorStart = 0.36;
        profile.vaseAnchorEnd = 0.78;
        break;
      case "slant":
        profile.baseWidthVisualScale = 0.98;
        profile.baseWidthScaleMin = 0.94;
        profile.baseWidthScaleMax = 1.06;
        profile.baseWidthMinRatio = 1.18;
        profile.baseHeightVisualScale = 0.54;
        profile.baseHeightCapRatio = 0.18;
        profile.baseHeightRatioFallback = 0.08;
        profile.baseOverlapRatio = 0.025;
        profile.vaseVisibleHeightRatio = 0.42;
        profile.vaseMinVisibleHeight = 30;
        profile.vaseAnchorStart = 0.52;
        profile.vaseAnchorEnd = 0.92;
        profile.vaseOverlapScale = 0.12;
        profile.vaseFaceInsetRatio = 0.08;
        profile.vaseDragInnerFactor = 1.2;
        break;
      case "marker":
        profile.baseWidthVisualScale = 0.97;
        profile.baseWidthScaleMin = 0.94;
        profile.baseWidthScaleMax = 1.05;
        profile.baseWidthMinRatio = 1.15;
        profile.baseHeightVisualScale = 0.5;
        profile.baseHeightCapRatio = 0.17;
        profile.baseHeightRatioFallback = 0.075;
        profile.baseOverlapRatio = 0.02;
        profile.vaseVisibleHeightRatio = 0.38;
        profile.vaseMinVisibleHeight = 28;
        profile.vaseAnchorStart = 0.46;
        profile.vaseAnchorEnd = 0.9;
        profile.vaseOverlapScale = 0.1;
        profile.vaseFaceInsetRatio = 0.07;
        profile.vaseDragInnerFactor = 1.2;
        break;
      case "bevel":
        profile.baseWidthVisualScale = 0.98;
        profile.baseWidthScaleMin = 0.94;
        profile.baseWidthScaleMax = 1.05;
        profile.baseWidthMinRatio = 1.13;
        profile.baseHeightVisualScale = 0.52;
        profile.baseHeightCapRatio = 0.18;
        profile.baseHeightRatioFallback = 0.08;
        profile.baseOverlapRatio = 0.02;
        profile.vaseVisibleHeightRatio = 0.39;
        profile.vaseMinVisibleHeight = 30;
        profile.vaseAnchorStart = 0.48;
        profile.vaseAnchorEnd = 0.9;
        profile.vaseOverlapScale = 0.09;
        profile.vaseFaceInsetRatio = 0.06;
        profile.vaseDragInnerFactor = 1.15;
        break;
      case "low_wide":
        profile.baseWidthVisualScale = 0.99;
        profile.baseWidthScaleMin = 0.95;
        profile.baseWidthScaleMax = 1.08;
        profile.baseWidthMinRatio = 1.12;
        profile.baseHeightVisualScale = 0.56;
        profile.baseHeightCapRatio = 0.2;
        profile.baseHeightRatioFallback = 0.085;
        profile.baseOverlapRatio = 0.03;
        profile.vaseVisibleHeightRatio = 0.4;
        profile.vaseMinVisibleHeight = 30;
        profile.vaseAnchorStart = 0.5;
        profile.vaseAnchorEnd = 0.88;
        profile.vaseOverlapScale = 0.08;
        profile.vaseFaceInsetRatio = 0.05;
        profile.vaseDragInnerFactor = 1.1;
        break;
      case "wide":
        profile.baseWidthVisualScale = 1;
        profile.baseWidthScaleMin = 0.94;
        profile.baseWidthScaleMax = 1.1;
        profile.baseWidthMinRatio = 1.08;
        profile.baseHeightVisualScale = 0.62;
        profile.baseHeightCapRatio = 0.24;
        profile.baseHeightRatioFallback = 0.09;
        profile.baseOverlapRatio = 0.035;
        profile.vaseVisibleHeightRatio = 0.44;
        profile.vaseMinVisibleHeight = 30;
        profile.vaseAnchorStart = 0.44;
        profile.vaseAnchorEnd = 0.86;
        profile.vaseOverlapScale = 0.06;
        profile.vaseFaceInsetRatio = 0.04;
        profile.vaseDragInnerFactor = 1.05;
        break;
    }

    switch (familyKey) {
      case "flush_marker":
        profile.catalogBaseMode = "none";
        profile.baseWidthMinRatio = 1.04;
        profile.baseWidthScaleMax = 1.14;
        profile.baseHeightVisualScale = 0.44;
        profile.baseHeightCapRatio = 0.12;
        profile.baseHeightRatioFallback = 0.055;
        profile.vaseVisibleHeightRatio = 0.32;
        profile.vaseMinVisibleHeight = 24;
        break;
      case "bevel_6":
        profile.catalogBaseMode = "none";
        profile.baseWidthMinRatio = 1.08;
        profile.baseWidthScaleMax = 1.16;
        profile.baseHeightVisualScale = 0.44;
        profile.baseHeightCapRatio = 0.12;
        profile.baseHeightRatioFallback = 0.06;
        break;
      case "bevel_8":
        profile.catalogBaseMode = "none";
        profile.baseWidthMinRatio = 1.1;
        profile.baseWidthScaleMax = 1.2;
        profile.baseHeightVisualScale = 0.46;
        profile.baseHeightCapRatio = 0.12;
        profile.baseHeightRatioFallback = 0.065;
        break;
      case "slant_10_16":
      case "slant_10_18":
        profile.catalogBaseMode = "slant";
        profile.catalogBaseDepthInches = 12;
        profile.catalogBaseHeightInches = 6;
        profile.catalogBaseOverhangXs = 12;
        profile.catalogBaseOverhangSmall = 10;
        profile.catalogBaseOverhangLarge = 6;
        profile.baseWidthVisualScale = 1;
        profile.baseWidthScaleMin = 1.16;
        profile.baseWidthScaleMax = 1.42;
        profile.baseWidthMinRatio = familyKey === "slant_10_18" ? 1.2 : 1.18;
        profile.baseHeightVisualScale = familyKey === "slant_10_18" ? 0.44 : 0.42;
        profile.baseHeightCapRatio = 0.16;
        profile.baseHeightRatioFallback = 0.07;
        profile.baseOverlapRatio = 0.02;
        profile.vaseVisibleHeightRatio = 0.4;
        profile.vaseAnchorStart = 0.54;
        profile.vaseAnchorEnd = 0.92;
        profile.vaseOverlapScale = 0.11;
        profile.vaseFaceInsetRatio = 0.08;
        break;
      case "slant_12":
        profile.catalogBaseMode = "slant";
        profile.catalogBaseDepthInches = 14;
        profile.catalogBaseHeightInches = 6;
        profile.catalogBaseOverhangXs = 8;
        profile.catalogBaseOverhangSmall = 6;
        profile.catalogBaseOverhangLarge = 6;
        profile.baseWidthVisualScale = 1;
        profile.baseWidthScaleMin = 1.16;
        profile.baseWidthScaleMax = 1.34;
        profile.baseWidthMinRatio = 1.18;
        profile.baseHeightVisualScale = 0.4;
        profile.baseHeightCapRatio = 0.14;
        profile.baseHeightRatioFallback = 0.065;
        profile.baseOverlapRatio = 0.018;
        profile.vaseVisibleHeightRatio = 0.38;
        profile.vaseAnchorStart = 0.56;
        profile.vaseAnchorEnd = 0.92;
        profile.vaseOverlapScale = 0.1;
        profile.vaseFaceInsetRatio = 0.08;
        break;
      case "serptop_6":
      case "upright_6":
        profile.catalogBaseMode = "upright";
        profile.catalogBaseDepthKey = "6";
        profile.baseWidthVisualScale = 1;
        profile.baseWidthScaleMin = 0.98;
        profile.baseWidthScaleMax = 1.24;
        profile.baseWidthMinRatio = 1.08;
        break;
      case "serptop_8":
      case "upright_8":
        profile.catalogBaseMode = "upright";
        profile.catalogBaseDepthKey = "8";
        profile.baseWidthVisualScale = 1;
        profile.baseWidthScaleMin = 1;
        profile.baseWidthScaleMax = 1.28;
        profile.baseWidthMinRatio = 1.1;
        break;
      case "wide_8":
        profile.catalogBaseDepthKey = "8";
        break;
      case "wide_6":
      case "standard_6":
        profile.catalogBaseDepthKey = "6";
        break;
      case "standard_8":
        profile.catalogBaseDepthKey = "8";
        break;
    }

    if (cfg.bottomBaseBackgroundPosition) profile.baseBackgroundPosition = cfg.bottomBaseBackgroundPosition;
    return profile;
  }

  function parseCatalogBasePart(value) {
    var text = String(value || "").trim();
    var m = text.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
    if (m) return ((parseFloat(m[1]) || 0) * 12) + (parseFloat(m[2]) || 0);
    return parseFloat(text) || 0;
  }

  function parseCatalogBaseSize(value) {
    var parts = String(value || "").split(/\s*x\s*/i);
    if (parts.length < 3) return null;
    return {
      width: parseCatalogBasePart(parts[0]),
      depth: parseCatalogBasePart(parts[1]),
      height: parseCatalogBasePart(parts[2])
    };
  }

  function getNearestCatalogBaseRow(table, width) {
    if (!table || !table.rows) return null;
    var roundedWidth = Math.round(Number(width) || 0);
    if (roundedWidth > 0 && table.rows[String(roundedWidth)]) return table.rows[String(roundedWidth)];

    var keys = Object.keys(table.rows)
      .map(function(key) { return parseFloat(key); })
      .filter(function(value) { return value > 0; })
      .sort(function(a, b) { return a - b; });
    if (!keys.length) return null;

    var nearest = keys[0];
    for (var i = 1; i < keys.length; i++) {
      if (Math.abs(keys[i] - roundedWidth) < Math.abs(nearest - roundedWidth)) nearest = keys[i];
    }
    return table.rows[String(nearest)] || null;
  }

  function getCatalogBottomBaseDimensions(dims) {
    if (!dims || !(dims.width > 0)) return null;

    var selectedChoice = getSelectedBottomBaseChoice();
    var selectedRow = getBottomBaseChoicePriceRow(selectedChoice);
    if (selectedRow && selectedRow[0]) {
      var selectedSize = parseCatalogBaseSize(selectedRow[0]);
      if (selectedSize && selectedSize.width > 0 && selectedSize.height > 0) return selectedSize;
    }

    var stoneLayout = getStoneLayoutProfile();
    if (stoneLayout.catalogBaseMode === "slant") {
      var overhang;
      if (dims.width <= 18) overhang = stoneLayout.catalogBaseOverhangXs || 12;
      else if (dims.width <= (stoneLayout.catalogBaseWidthSmallThreshold || 24)) overhang = stoneLayout.catalogBaseOverhangSmall || 6;
      else overhang = stoneLayout.catalogBaseOverhangLarge || 4;
      return {
        width: dims.width + overhang,
        depth: stoneLayout.catalogBaseDepthInches || 12,
        height: stoneLayout.catalogBaseHeightInches || 6
      };
    }

    if (stoneLayout.catalogBaseMode === "none") return null;

    var depthKey = stoneLayout.catalogBaseDepthKey || ((Number(dims.depth) || 0) >= 7 ? "8" : "6");
    var table = BOTTOM_BASE_PRICE_TABLE[depthKey];
    var row = getNearestCatalogBaseRow(table, dims.width);
    return row && row[0] ? parseCatalogBaseSize(row[0]) : null;
  }

  function hasExplicitBottomBaseSelection() {
    var choice = getSelectedBottomBaseChoice();
    return !!(choice && choice.key);
  }

  function getBottomBaseWidthRatio() {
    var cfg = window.memCustomizerConfig || {};
    var stoneLayout = getStoneLayoutProfile();
    var minRatio = stoneLayout.baseWidthMinRatio || 0;
    var ratio = parseFloat(cfg.bottomBaseWidthRatio || cfg.bottomBaseScale || cfg.bottomBaseSize);
    if (ratio > 0) return Math.max(ratio, minRatio);

    var dims = getStoneDimensions();
    if (dims && dims.width > 0) {
      var catalogBase = getCatalogBottomBaseDimensions(dims);
      if (catalogBase && catalogBase.width > 0) {
        var visualScale = parseFloat(cfg.bottomBaseVisualScale || cfg.bottomBaseWidthVisualScale);
        if (!(visualScale > 0)) visualScale = stoneLayout.baseWidthVisualScale;
        var widthRatio = (catalogBase.width / dims.width) * visualScale;
        if (hasExplicitBottomBaseSelection()) {
          return Math.max(0.55, Math.min(3.2, widthRatio));
        }
        return Math.max(minRatio, Math.max(stoneLayout.baseWidthScaleMin, Math.min(stoneLayout.baseWidthScaleMax, widthRatio)));
      }

      var totalOverhang = parseFloat(cfg.bottomBaseTotalOverhang || cfg.bottomBaseTotalOverhangInches);
      if (!(totalOverhang >= 0)) totalOverhang = stoneLayout.baseTotalOverhang;
      return Math.max(minRatio, (dims.width + totalOverhang) / dims.width);
    }

    return Math.max(minRatio, 1.08);
  }

  function getBottomBaseHeightRatio() {
    var cfg = window.memCustomizerConfig || {};
    var stoneLayout = getStoneLayoutProfile();
    var ratio = parseFloat(cfg.bottomBaseHeightRatio);
    return ratio > 0 ? ratio : stoneLayout.baseHeightRatioFallback;
  }

  function getBottomBaseHeightFromDimensions(visibleStoneHeight) {
    var cfg = window.memCustomizerConfig || {};
    var stoneLayout = getStoneLayoutProfile();
    var dims = getStoneDimensions();
    if (!dims || !(dims.depth > 0) || !(dims.height > 0)) return 0;
    var catalogBase = getCatalogBottomBaseDimensions(dims);
    var baseHeight = catalogBase && catalogBase.height > 0 ? catalogBase.height : dims.depth;
    var visualScale = parseFloat(cfg.bottomBaseVisualHeightScale || cfg.bottomBaseHeightVisualScale);
    if (!(visualScale > 0)) visualScale = stoneLayout.baseHeightVisualScale;
    var ratio = (baseHeight / dims.height) * visualScale;
    if (stoneLayout.baseHeightCapRatio > 0) {
      var capRatio = hasExplicitBottomBaseSelection() ? Math.max(stoneLayout.baseHeightCapRatio, 0.42) : stoneLayout.baseHeightCapRatio;
      ratio = Math.min(ratio, capRatio);
    }
    if (!(ratio > 0)) return 0;
    return Math.max(12, Math.round(visibleStoneHeight * ratio));
  }

  function getBottomBaseOverlapRatio() {
    var cfg = window.memCustomizerConfig || {};
    var stoneLayout = getStoneLayoutProfile();
    var ratio = parseFloat(cfg.bottomBaseOverlapRatio || cfg.bottomBaseOverlap);
    return ratio >= 0 ? ratio : stoneLayout.baseOverlapRatio;
  }

  function getAdaptiveVaseVisibleHeight(visibleStoneHeight, visibleStoneWidth) {
    var cfg = window.memCustomizerConfig || {};
    var stoneLayout = getStoneLayoutProfile();
    var heightRatio = stoneLayout.vaseVisibleHeightRatio;
    var widthScale = stoneLayout.vaseWidthScale;
    var minVisible = stoneLayout.vaseMinVisibleHeight;
    var heightCapRatio = stoneLayout.vaseHeightCapRatio;
    if (stoneLayout.isUpright) {
      var uprightRatio = stoneLayout.heightToWidth;
      var overrideRatio = parseFloat(cfg.vaseUprightHeightRatio || cfg.vaseTallHeightRatio);
      if (overrideRatio > 0) heightRatio = overrideRatio;
      else heightRatio = Math.max(0.3, Math.min(0.44, 0.56 - (uprightRatio * 0.1)));
      var overrideWidthScale = parseFloat(cfg.vaseUprightWidthScale || cfg.vaseTallWidthScale);
      if (overrideWidthScale > 0) widthScale = overrideWidthScale;
      var overrideMin = parseFloat(cfg.vaseUprightMinVisibleHeight || cfg.vaseMinVisibleHeight);
      if (overrideMin > 0) minVisible = overrideMin;
    }

    var target = visibleStoneHeight * heightRatio;
    if (heightCapRatio > 0) target = Math.min(target, visibleStoneHeight * heightCapRatio);
    if (widthScale > 0 && visibleStoneWidth > 0) target = Math.min(target, visibleStoneWidth * widthScale);
    return Math.max(minVisible, target);
  }

  function setStyleImportant(el, prop, value) {
    if (el && el.style) el.style.setProperty(prop, value, "important");
  }

  function applyAdaptivePreviewSizing() {
    var modal = document.getElementById("memModal");
    var panel = modal ? modal.querySelector(".mem-panel") : null;
    var previewCol = modal ? modal.querySelector(".mem-preview-col") : null;
    var scene = document.getElementById("previewScene");
    var wrap = document.getElementById("hsWrap");
    var baseImg = document.getElementById("hsBaseImg");
    var dims = getStoneDimensions();
    var stoneLayout = getStoneLayoutProfile();
    if (!panel || !previewCol || !scene || !wrap || !baseImg || !dims || !(dims.width > 0) || !(dims.height > 0)) return false;

    var isUpright = stoneLayout.isUpright;
    panel.classList.toggle("mem-preview-upright", isUpright);

    if (!isUpright) {
      var nonUprightAvailableHeight = previewCol.clientHeight || (modal ? Math.round(modal.clientHeight * 0.42) : 300);
      var nonUprightReserve = shouldShowBottomBase() ? 76 : 12;
      var nonUprightMaxHeight = Math.max(150, Math.floor(nonUprightAvailableHeight - nonUprightReserve));

      if (window.innerHeight) {
        nonUprightMaxHeight = Math.min(nonUprightMaxHeight, Math.round(window.innerHeight * 0.38));
      }

      setStyleImportant(scene, "max-width", "100%");
      setStyleImportant(wrap, "width", "100%");
      setStyleImportant(wrap, "max-width", "560px");
      setStyleImportant(wrap, "min-height", "0");
      setStyleImportant(baseImg, "width", "100%");
      setStyleImportant(baseImg, "height", "auto");
      setStyleImportant(baseImg, "max-height", nonUprightMaxHeight + "px");
      setStyleImportant(baseImg, "min-height", "0");
      return false;
    }

    var availableHeight = previewCol.clientHeight || (modal ? Math.round(modal.clientHeight * 0.5) : 340);
    var availableWidth = previewCol.clientWidth || (modal ? Math.round(modal.clientWidth * 0.55) : 520);
    var bottomReserve = shouldShowBottomBase() ? stoneLayout.uprightBottomReserve : 18;
    var maxStoneHeight = Math.floor(availableHeight - bottomReserve);
    maxStoneHeight = Math.max(stoneLayout.uprightMinHeight, Math.min(maxStoneHeight, stoneLayout.uprightMaxHeight));

    var imageAspect = (baseImg.naturalWidth && baseImg.naturalHeight)
      ? (baseImg.naturalWidth / baseImg.naturalHeight)
      : (dims.width / dims.height);
    if (!(imageAspect > 0)) imageAspect = dims.width / dims.height;

    var desiredWidth = Math.round(maxStoneHeight * imageAspect);
    var maxUprightWidth = Math.max(180, Math.min(availableWidth * stoneLayout.uprightMaxWidthFactor, stoneLayout.uprightMaxWidthPx));
    desiredWidth = Math.max(120, Math.min(desiredWidth, maxUprightWidth));

    setStyleImportant(scene, "max-width", "100%");
    setStyleImportant(wrap, "width", desiredWidth + "px");
    setStyleImportant(wrap, "max-width", desiredWidth + "px");
    setStyleImportant(wrap, "min-height", "0");
    setStyleImportant(baseImg, "width", "100%");
    setStyleImportant(baseImg, "height", "auto");
    setStyleImportant(baseImg, "max-height", maxStoneHeight + "px");
    setStyleImportant(baseImg, "min-height", "0");
    return true;
  }

  function installAdaptivePreviewSizing() {
    if (window._memAdaptivePreviewSizingInstalled) return true;
    window._memAdaptivePreviewSizingInstalled = true;

    var baseImg = document.getElementById("hsBaseImg");
    if (baseImg) {
      baseImg.addEventListener("load", function() {
        setTimeout(function() {
          applyAdaptivePreviewSizing();
          queueBottomBaseLayout();
          queueVisibleVaseSnap();
        }, 0);
      });
    }

    window.addEventListener("resize", function() {
      setTimeout(function() {
        applyAdaptivePreviewSizing();
        queueBottomBaseLayout();
        queueVisibleVaseSnap();
      }, 0);
    });

    document.addEventListener("variant:changed", function() {
      setTimeout(function() {
        applyAdaptivePreviewSizing();
        queueVisibleVaseSnap();
      }, 0);
    });
    document.addEventListener("theme:variant:change", function() {
      setTimeout(function() {
        applyAdaptivePreviewSizing();
        queueVisibleVaseSnap();
      }, 0);
    });

    var modal = document.getElementById("memModal");
    if (modal && window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === "class" && modal.classList.contains("open")) {
            setTimeout(function() {
              applyAdaptivePreviewSizing();
              queueBottomBaseLayout();
              queueVisibleVaseSnap();
            }, 0);
            break;
          }
        }
      });
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    setTimeout(applyAdaptivePreviewSizing, 80);
    setTimeout(applyAdaptivePreviewSizing, 250);
    return true;
  }

  function ensureBottomBaseCss() {
    if (window._memBottomBaseCssInstalled) return;
    window._memBottomBaseCssInstalled = true;
    var style = document.createElement("style");
    style.textContent = ".hs-bottom-base{position:absolute;left:50%;top:0;display:none;pointer-events:none;transform:translateX(-50%);z-index:1;border-radius:2px;background:linear-gradient(180deg,#7c7c7c 0%,#666 14%,#525252 55%,#454545 100%);background-size:cover;background-position:center bottom;background-repeat:no-repeat;background-color:transparent;border-top:1px solid rgba(255,255,255,.26);box-shadow:0 5px 16px rgba(0,0,0,.24)}.hs-bottom-base.visible{display:block}";
    document.head.appendChild(style);
  }

  function ensureBottomBaseElement() {
    var el = document.getElementById("hsBottomBase");
    if (el) return el;
    var scene = document.getElementById("previewScene");
    if (!scene) return null;
    el = document.createElement("div");
    el.id = "hsBottomBase";
    el.className = "hs-bottom-base";
    var wrap = document.getElementById("hsWrap");
    if (wrap && wrap.parentNode === scene) scene.insertBefore(el, wrap);
    else scene.appendChild(el);
    return el;
  }

  function ensureBottomBaseToggle() {
    var existing = document.getElementById("baseToggle");
    if (existing) return existing;

    var vaseRow = document.querySelector(".vase-options");
    if (!vaseRow) return null;

    var btn = document.createElement("div");
    btn.className = "vase-opt";
    btn.id = "baseToggle";
    btn.style.flexDirection = "row";
    btn.style.gap = "10px";
    btn.style.padding = "10px 14px";
    btn.style.justifyContent = "flex-start";
    btn.innerHTML = '<span class="vase-opt-icon" style="font-size:22px;">&#9644;</span><div style="display:flex;flex-direction:column;gap:1px;"><span class="vase-opt-label" id="baseToggleLabel">Base</span><span class="vase-opt-sub" id="baseToggleSub">Optional</span></div>';
    btn.addEventListener("click", function() {
      if (!hasBottomBaseOption()) return;
      setBottomBaseSelected(!isBottomBaseSelected());
    });

    vaseRow.appendChild(btn);
    return btn;
  }

  function ensureBottomBaseSizeSelector() {
    var existing = document.getElementById("baseSizeField");
    if (existing) return existing;

    var vaseRow = document.querySelector(".vase-options");
    if (!vaseRow || !vaseRow.parentNode) return null;

    var field = document.createElement("div");
    field.className = "base-size-field";
    field.id = "baseSizeField";
    field.innerHTML = '<label class="form-lbl" for="baseSizeSelect">Base Size</label><select id="baseSizeSelect"></select>';

    var style = document.createElement("style");
    style.textContent = ".base-size-field{margin-top:8px}.base-size-field select{width:100%;background:#ece9f7;border:1px solid #a89fd4;color:#c8860a;font-family:'Cinzel',serif;font-size:10px;padding:8px 10px;outline:none}.base-size-field select:focus{border-color:#c8860a}.base-size-field[hidden]{display:none!important}";
    document.head.appendChild(style);

    var vaseColorField = document.getElementById("vaseColorField");
    if (vaseColorField && vaseColorField.parentNode === vaseRow.parentNode) {
      if (vaseColorField.nextSibling) vaseRow.parentNode.insertBefore(field, vaseColorField.nextSibling);
      else vaseRow.parentNode.appendChild(field);
    } else if (vaseRow.nextSibling) vaseRow.parentNode.insertBefore(field, vaseRow.nextSibling);
    else vaseRow.parentNode.appendChild(field);

    var select = document.getElementById("baseSizeSelect");
    if (select) {
      select.addEventListener("change", function() {
        refreshBottomBasePricingAndLayout();
      });
    }
    return field;
  }

  function ensureVaseColorSelector() {
    var existing = document.getElementById("vaseColorField");
    if (existing) return existing;

    var vaseRow = document.querySelector(".vase-options");
    if (!vaseRow || !vaseRow.parentNode) return null;

    var field = document.createElement("div");
    field.className = "vase-color-field";
    field.id = "vaseColorField";
    field.innerHTML = '<label class="form-lbl" for="vaseColorSelect">Vase Color</label><select id="vaseColorSelect"></select>';

    if (!document.getElementById("vaseColorFieldCss")) {
      var style = document.createElement("style");
      style.id = "vaseColorFieldCss";
      style.textContent = ".vase-color-field{margin-top:8px}.vase-color-field select{width:100%;background:#ece9f7;border:1px solid #a89fd4;color:#c8860a;font-family:'Cinzel',serif;font-size:10px;padding:8px 10px;outline:none}.vase-color-field select:focus{border-color:#c8860a}.vase-color-field[hidden]{display:none!important}";
      document.head.appendChild(style);
    }

    if (vaseRow.nextSibling) vaseRow.parentNode.insertBefore(field, vaseRow.nextSibling);
    else vaseRow.parentNode.appendChild(field);

    var select = document.getElementById("vaseColorSelect");
    if (select) {
      select.addEventListener("change", function() {
        var modalState = getModalState();
        modalState.vaseColor = select.value;
        if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
        else if (typeof window.updatePrice === "function") window.updatePrice();
      });
    }

    return field;
  }

  function syncVaseColorSelectorUi() {
    var field = ensureVaseColorSelector();
    var select = document.getElementById("vaseColorSelect");
    if (!field || !select) return;

    var modalState = getModalState();
    var current = select.value || modalState.vaseColor || getDefaultVaseColorName();
    var colors = getVaseColorNames();
    var html = "";

    for (var i = 0; i < colors.length; i++) {
      var price = roundPrice((Number(VASE_PRICE_INPUTS[colors[i]]) || 0) * PRICE_MULTIPLIER);
      html += '<option value="' + colors[i] + '">' + colors[i] + " - " + formatMoney(price) + '</option>';
    }

    select.innerHTML = html;
    if (colors.indexOf(current) >= 0) select.value = current;
    else select.value = getDefaultVaseColorName();
    modalState.vaseColor = select.value;
  }

  function syncBottomBaseSizeSelectorUi() {
    var field = ensureBottomBaseSizeSelector();
    var select = document.getElementById("baseSizeSelect");
    if (!field || !select) return;

    var available = hasBottomBaseOption();
    field.hidden = !available;
    if (!available) {
      getModalState().bottomBase = false;
      return;
    }

    var color = detectSelectedBottomBaseColor();
    var current = select.value;
    var defaultChoice = getDefaultBottomBaseChoice();
    var nextValue = current || (defaultChoice ? defaultChoice.key : "");
    var html = "";

    for (var i = 0; i < BOTTOM_BASE_SIZE_CHOICES.length; i++) {
      var choice = BOTTOM_BASE_SIZE_CHOICES[i];
      html += '<option value="' + choice.key + '">' + getBottomBaseChoiceLabel(choice, color) + '</option>';
    }

    select.innerHTML = html;
    if (findBottomBaseChoiceByKey(nextValue)) select.value = nextValue;
    else if (defaultChoice) select.value = defaultChoice.key;
  }

  function syncBottomBaseToggleUi() {
    var btn = ensureBottomBaseToggle();
    if (!btn) return;
    syncBottomBaseSizeSelectorUi();

    var available = hasBottomBaseOption();
    if (!available) getModalState().bottomBase = false;
    var selected = isBottomBaseSelected() && available;
    var pricing = getBottomBaseQuote();
    var priceText = pricing && pricing.displayPrice > 0 ? formatPlusMoney(pricing.displayPrice) : "";
    var label = document.getElementById("baseToggleLabel");
    var sub = document.getElementById("baseToggleSub");

    btn.style.display = available ? "" : "none";
    btn.classList.toggle("active", selected);
    if (label) label.textContent = selected ? "Base Added" : "Base";
    if (sub) {
      if (!available) sub.textContent = "Not available";
      else if (priceText) sub.textContent = (selected ? "Click to remove " : "Click to add ") + priceText;
      else sub.textContent = pricing && pricing.reason ? pricing.reason : selected ? "Click to remove" : "Click to add";
    }
  }

  function getBottomBaseRenderInfo(src) {
    if (!src) return Promise.resolve({ aspect: 0, backgroundSize: "", backgroundPosition: "" });
    if (bottomBaseRenderCache[src]) return Promise.resolve(bottomBaseRenderCache[src]);
    if (bottomBaseRenderPending[src]) return bottomBaseRenderPending[src];

    bottomBaseRenderPending[src] = loadScanImage(src, null).then(function(img) {
      delete bottomBaseRenderPending[src];
      if (!img || !img.naturalWidth || !img.naturalHeight) {
        return { aspect: 0, backgroundSize: "", backgroundPosition: "" };
      }

      var renderInfo = {
        aspect: 0,
        backgroundSize: "",
        backgroundPosition: ""
      };

      try {
        var profile = buildBottomBaseVisibleProfile(img);
        if (profile) {
          var visibleW = Math.max(0.04, profile.right - profile.left);
          var visibleH = Math.max(0.04, profile.bottom - profile.top);
          renderInfo.aspect = visibleW / visibleH;

          var sizeX = 100 / visibleW;
          var sizeY = 100 / visibleH;
          var posX = visibleW >= 0.995 ? 50 : limit((profile.left / Math.max(0.001, 1 - visibleW)) * 100, 0, 100);
          var posY = visibleH >= 0.995 ? 50 : limit((profile.top / Math.max(0.001, 1 - visibleH)) * 100, 0, 100);

          renderInfo.backgroundSize = sizeX.toFixed(3) + "% " + sizeY.toFixed(3) + "%";
          renderInfo.backgroundPosition = posX.toFixed(3) + "% " + posY.toFixed(3) + "%";
        }
      } catch (err) {}

      if (!(renderInfo.aspect > 0)) renderInfo.aspect = img.naturalWidth / img.naturalHeight;
      if (!renderInfo.backgroundPosition) renderInfo.backgroundPosition = "center bottom";
      if (!renderInfo.backgroundSize) renderInfo.backgroundSize = "cover";

      bottomBaseRenderCache[src] = renderInfo;
      return renderInfo;
    }, function() {
      delete bottomBaseRenderPending[src];
      return { aspect: 0, backgroundSize: "", backgroundPosition: "" };
    });

    return bottomBaseRenderPending[src];
  }

  function syncBottomBaseLayout() {
    var scene = document.getElementById("previewScene");
    var wrap = document.getElementById("hsWrap");
    var baseImg = document.getElementById("hsBaseImg");
    var bottomBase = ensureBottomBaseElement();
    if (!scene || !wrap || !baseImg || !bottomBase) return Promise.resolve(false);

    ensureBottomBaseCss();
    applyAdaptivePreviewSizing();
    syncBottomBaseToggleUi();

    if (!shouldShowBottomBase()) {
      bottomBase.classList.remove("visible");
      scene.style.paddingBottom = "";
      return Promise.resolve(false);
    }

    var src = getBottomBaseSrc();
    if (src) bottomBase.style.backgroundImage = "url(\"" + src.replace(/"/g, "\\\"") + "\")";
    else bottomBase.style.backgroundImage = "";
    bottomBase.style.backgroundRepeat = "no-repeat";
    bottomBase.style.backgroundPosition = getStoneLayoutProfile().baseBackgroundPosition;

    return Promise.all([waitForImageReady(baseImg), getAlphaProfile(baseImg), getBottomBaseRenderInfo(src)]).then(function(result) {
      if (!result[0]) {
        bottomBase.classList.remove("visible");
        scene.style.paddingBottom = "";
        return false;
      }

      var profile = result[1];
      var renderInfo = result[2] || {};
      var aspect = renderInfo.aspect || 0;
      var baseBox = rectWithinAncestor(baseImg, scene);
      if (!baseBox || !baseBox.width || !baseBox.height) {
        bottomBase.classList.remove("visible");
        scene.style.paddingBottom = "";
        return false;
      }

      var visibleWidthFrac = profile ? Math.max(0.18, profile.right - profile.left) : 1;
      var visibleCenterFrac = profile ? (profile.left + ((profile.right - profile.left) / 2)) : 0.5;
      var visibleWidth = baseBox.width * visibleWidthFrac;
      var visibleStoneHeight = baseBox.height * (profile ? Math.max(0.06, profile.bottom - profile.top) : 1);
      var explicitBottomBase = hasExplicitBottomBaseSelection();
      var bottomBaseWidth = Math.max(72, Math.round(visibleWidth * getBottomBaseWidthRatio()));
      var maxBottomBaseWidth = Math.max(96, Math.round((scene.clientWidth || visibleWidth) * (explicitBottomBase ? 0.96 : 0.86)));
      bottomBaseWidth = Math.min(bottomBaseWidth, maxBottomBaseWidth);
      var dimensionBaseHeight = getBottomBaseHeightFromDimensions(visibleStoneHeight);
      var aspectBaseHeight = aspect ? Math.max(18, Math.round(bottomBaseWidth / aspect)) : 0;
      var fallbackBaseHeight = Math.max(18, Math.round(visibleWidth * getBottomBaseHeightRatio()));
      var bottomBaseHeight = dimensionBaseHeight || aspectBaseHeight || fallbackBaseHeight;
      if (dimensionBaseHeight && aspectBaseHeight) {
        bottomBaseHeight = explicitBottomBase ? dimensionBaseHeight : Math.max(18, Math.min(dimensionBaseHeight, Math.round(aspectBaseHeight * 1.08)));
      }
      var overlap = Math.round(bottomBaseHeight * getBottomBaseOverlapRatio());
      var stoneBottom = baseBox.top + ((profile ? profile.bottom : 1) * baseBox.height);
      var centerX = baseBox.left + (visibleCenterFrac * baseBox.width);

      wrap.style.zIndex = "3";
      bottomBase.style.width = bottomBaseWidth + "px";
      bottomBase.style.height = bottomBaseHeight + "px";
      bottomBase.style.left = Math.round(centerX) + "px";
      bottomBase.style.top = Math.round(stoneBottom - overlap) + "px";
      bottomBase.style.backgroundSize = renderInfo.backgroundSize || "cover";
      bottomBase.style.backgroundPosition = renderInfo.backgroundPosition || getStoneLayoutProfile().baseBackgroundPosition;
      bottomBase.classList.add("visible");
      scene.style.paddingBottom = Math.max(0, bottomBaseHeight - overlap) + "px";
      if (typeof queueVisibleVaseSnap === "function") setTimeout(queueVisibleVaseSnap, 0);
      return true;
    }, function() {
      bottomBase.classList.remove("visible");
      scene.style.paddingBottom = "";
      return false;
    });
  }

  function queueBottomBaseLayout() {
    if (bottomBaseLayoutToken) cancelAnimationFrame(bottomBaseLayoutToken);
    bottomBaseLayoutToken = requestAnimationFrame(function() {
      bottomBaseLayoutToken = 0;
      syncBottomBaseLayout();
    });
  }

  function refreshBottomBasePricingAndLayout() {
    setTimeout(function() {
      syncBottomBaseToggleUi();
      queueBottomBaseLayout();
      if (typeof window._memUpdatePrice === "function") window._memUpdatePrice();
      else if (typeof window.updatePrice === "function") window.updatePrice();
    }, 0);
  }

  function applyVisibleVaseSnap(el) {
    var scene = document.getElementById("previewScene");
    var baseImg = document.getElementById("hsBaseImg");
    if (!scene || !baseImg || !el) return Promise.resolve(false);
    if (!el.classList.contains("visible") || el.style.display === "none") return Promise.resolve(false);
    if (el._memUserPositioned) return Promise.resolve(true);

    return Promise.all([waitForImageReady(baseImg), waitForImageReady(el)])
      .then(function(ready) {
        if (!ready[0] || !ready[1]) return false;

        var baseBox = rectWithinAncestor(baseImg, scene);
        if (!baseBox || !baseBox.width || !baseBox.height) return false;

        return Promise.all([getAlphaProfile(baseImg), getAlphaProfile(el)]).then(function(profiles) {
          var baseProfile = profiles[0];
          var vaseProfile = profiles[1];
          if (!baseProfile || !vaseProfile) return false;

          var baseVisibleFracH = Math.max(0.06, baseProfile.bottom - baseProfile.top);
          var baseVisibleFracW = Math.max(0.06, baseProfile.right - baseProfile.left);
          var vaseVisibleFracH = Math.max(0.06, vaseProfile.bottom - vaseProfile.top);
          var visibleStoneHeight = baseBox.height * baseVisibleFracH;
          var visibleStoneWidth = baseBox.width * baseVisibleFracW;
          var targetVisibleVaseHeight = getAdaptiveVaseVisibleHeight(visibleStoneHeight, visibleStoneWidth);
          var vaseBoxHeight = Math.max(24, Math.round(targetVisibleVaseHeight / vaseVisibleFracH));
          var vaseAspect = (el.naturalWidth && el.naturalHeight)
            ? (el.naturalWidth / el.naturalHeight)
            : ((el.offsetWidth || 1) / Math.max(1, el.offsetHeight || 1));
          var vaseBoxWidth = Math.max(12, vaseBoxHeight * vaseAspect);
          var stoneLayout = getStoneLayoutProfile();
          var overlapPx = Math.max(2, Math.round(Math.min(vaseBoxWidth, vaseBoxHeight) * stoneLayout.vaseOverlapScale));
          var bottomBaseEl = document.getElementById("hsBottomBase");
          var bottomBaseBox = bottomBaseEl && bottomBaseEl.classList.contains("visible")
            ? rectWithinAncestor(bottomBaseEl, scene)
            : null;

          var stoneVisibleBottom = baseBox.top + (baseProfile.bottom * baseBox.height);
          var vaseVisibleBottom = vaseProfile.bottom * vaseBoxHeight;
          var nextTop = stoneVisibleBottom - vaseVisibleBottom;
          if (shouldShowBottomBase() && bottomBaseBox && bottomBaseBox.width && bottomBaseBox.height) {
            var baseTopSurface = bottomBaseBox.top + Math.max(2, Math.round(bottomBaseBox.height * 0.08));
            nextTop = baseTopSurface - vaseVisibleBottom + Math.round(overlapPx * 0.35);
          }

          var stoneVaseBand = getVaseAnchorBand(baseProfile);
          var stoneBandStart = stoneVaseBand.start;
          var stoneBandEnd = stoneVaseBand.end;
          var vaseBandStart = vaseProfile.top + ((vaseProfile.bottom - vaseProfile.top) * 0.18);
          var vaseBandEnd = vaseProfile.bottom - ((vaseProfile.bottom - vaseProfile.top) * 0.10);
          if (vaseBandEnd <= vaseBandStart) {
            vaseBandStart = vaseProfile.top;
            vaseBandEnd = vaseProfile.bottom;
          }

          var stoneLeftEdge = baseBox.left + (getBandEdge(baseProfile, stoneBandStart, stoneBandEnd, "left") * baseBox.width);
          var stoneRightEdge = baseBox.left + (getBandEdge(baseProfile, stoneBandStart, stoneBandEnd, "right") * baseBox.width);
          if (stoneLayout.vaseFaceInsetRatio > 0 && visibleStoneWidth > 0) {
            var faceInset = visibleStoneWidth * stoneLayout.vaseFaceInsetRatio;
            stoneLeftEdge += faceInset;
            stoneRightEdge -= faceInset;
          }
          var vaseSourceLeftEdge = getBandEdge(vaseProfile, vaseBandStart, vaseBandEnd, "left");
          var nextLeft = 0;

          if (el.id === "vaseLeft" || el.classList.contains("flipped")) {
            var vaseVisualRightOffset = vaseBoxWidth * (1 - vaseSourceLeftEdge);
            nextLeft = stoneLeftEdge - vaseVisualRightOffset + overlapPx;
          } else {
            var vaseVisualLeftOffset = vaseBoxWidth * vaseSourceLeftEdge;
            nextLeft = stoneRightEdge - vaseVisualLeftOffset - overlapPx;
          }

          el.style.height = Math.round(vaseBoxHeight) + "px";
          el.style.width = "auto";
          el.style.bottom = "auto";
          el.style.right = "auto";
          el.style.zIndex = "12";
          el.style.pointerEvents = "auto";
          el.style.cursor = "grab";
          el.style.touchAction = "none";
          el.style.top = Math.round(nextTop) + "px";
          el.style.left = Math.round(nextLeft) + "px";
          el._anchorLeft = (el.id === "vaseLeft" || el.classList.contains("flipped"))
            ? stoneLeftEdge
            : stoneRightEdge;
          return true;
        });
      }, function() {
        return false;
      })
      ;
  }

  function installFlexibleVaseDrag() {
    ["vaseLeft", "vaseRight"].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el || el._memFlexibleVaseDragInstalled) return;
      el._memFlexibleVaseDragInstalled = true;
      el.style.zIndex = "12";
      el.style.pointerEvents = "auto";
      el.style.cursor = "grab";
      el.style.touchAction = "none";

      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var startTop = 0;

      function begin(clientX, clientY) {
        startX = clientX;
        startY = clientY;
        startLeft = parseFloat(el.style.left) || 0;
        startTop = parseFloat(el.style.top) || 0;
        el.classList.add("dragging");
      }

      function move(clientX, clientY) {
        var scene = document.getElementById("previewScene");
        var sceneW = scene ? scene.clientWidth : 0;
        var sceneH = scene ? scene.clientHeight : 0;
        var vW = el.offsetWidth || 60;
        var vH = el.offsetHeight || 60;
        var nextLeft = startLeft + (clientX - startX);
        var nextTop = startTop + (clientY - startY);

        if (sceneW > 0) nextLeft = limit(nextLeft, 0, Math.max(0, sceneW - vW));
        if (sceneH > 0) nextTop = limit(nextTop, 0, Math.max(0, sceneH - vH));

        el.style.left = Math.round(nextLeft) + "px";
        el.style.top = Math.round(nextTop) + "px";
        el.style.bottom = "auto";
        el.style.right = "auto";
        el._memUserPositioned = true;
      }

      function end() {
        el.classList.remove("dragging");
      }

      el.addEventListener("mousedown", function(e) {
        if (!el.classList.contains("visible")) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        begin(e.clientX, e.clientY);
        function onMove(ev) { move(ev.clientX, ev.clientY); }
        function onEnd() {
          end();
          document.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseup", onEnd);
        }
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
      }, true);

      el.addEventListener("touchstart", function(e) {
        if (!el.classList.contains("visible") || !e.touches || !e.touches[0]) return;
        e.stopImmediatePropagation();
        begin(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true, capture: true });

      el.addEventListener("touchmove", function(e) {
        if (!el.classList.contains("visible") || !e.touches || !e.touches[0]) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        move(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false, capture: true });

      el.addEventListener("touchend", end);
    });
  }

  function applyVisibleVaseSnapAll() {
    var modal = document.getElementById("memModal");
    var modalState = getModalState();
    if (!modal || !modal.classList.contains("open")) return;
    if (!modalState || !modalState.vase) return;

    ["vaseLeft", "vaseRight"].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el || !el.classList.contains("visible") || el.style.display === "none") return;
      applyVisibleVaseSnap(el);
    });
  }

  function queueVisibleVaseSnap() {
    if (visibleVaseSnapToken) cancelAnimationFrame(visibleVaseSnapToken);
    visibleVaseSnapToken = requestAnimationFrame(function() {
      visibleVaseSnapToken = 0;
      applyVisibleVaseSnapAll();
    });
  }

  function installVisibleVaseSnap() {
    if (window._memVisibleVaseSnapInstalled) return true;
    if (typeof window.selectVase !== "function") return false;

    window._memVisibleVaseSnapInstalled = true;

    var originalSelectVase = window.selectVase;
    window.selectVase = function() {
      var result = originalSelectVase.apply(this, arguments);
      ["vaseLeft", "vaseRight"].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el._memUserPositioned = false;
      });
      installFlexibleVaseDrag();
      queueVisibleVaseSnap();
      return result;
    };

    var originalReloadVase = window._memReloadVase;
    window._memReloadVase = function() {
      if (typeof originalReloadVase === "function") originalReloadVase.apply(this, arguments);
      else {
        var modalState = getModalState();
        if (modalState && modalState.vase > 0 && typeof window.selectVase === "function") {
          window.selectVase(modalState.vase);
        }
      }
      queueVisibleVaseSnap();
    };

    var baseImg = document.getElementById("hsBaseImg");
    if (baseImg) {
      baseImg.addEventListener("load", function() {
        setTimeout(queueVisibleVaseSnap, 0);
      });
    }

    ["vaseLeft", "vaseRight"].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener("load", function() {
        setTimeout(queueVisibleVaseSnap, 0);
      });
    });

    window.addEventListener("resize", function() {
      setTimeout(queueVisibleVaseSnap, 0);
    });

    var modal = document.getElementById("memModal");
    if (modal && window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === "class" && modal.classList.contains("open")) {
            setTimeout(queueVisibleVaseSnap, 0);
            break;
          }
        }
      });
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    setTimeout(queueVisibleVaseSnap, 250);
    return true;
  }

  function installBottomBaseLayout() {
    if (window._memBottomBaseLayoutInstalled) return true;
    var scene = document.getElementById("previewScene");
    var baseImg = document.getElementById("hsBaseImg");
    if (!scene || !baseImg) return false;

    window._memBottomBaseLayoutInstalled = true;
    ensureBottomBaseCss();
    ensureBottomBaseElement();

    baseImg.addEventListener("load", function() {
      setTimeout(queueBottomBaseLayout, 0);
    });

    window.addEventListener("resize", function() {
      setTimeout(queueBottomBaseLayout, 0);
    });

    document.addEventListener("variant:changed", refreshBottomBasePricingAndLayout);
    document.addEventListener("theme:variant:change", refreshBottomBasePricingAndLayout);
    document.addEventListener("change", function(e) {
      if (e.target && e.target.name === "id") refreshBottomBasePricingAndLayout();
    });

    window._memReloadBottomBase = function() {
      refreshBottomBasePricingAndLayout();
    };

    var modal = document.getElementById("memModal");
    if (modal && window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === "class" && modal.classList.contains("open")) {
            setTimeout(queueBottomBaseLayout, 0);
            break;
          }
        }
      });
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    setTimeout(queueBottomBaseLayout, 80);
    setTimeout(queueBottomBaseLayout, 250);
    syncBottomBaseToggleUi();
    return true;
  }

  function startWhenReady() {
    ensureLandscapeModalCss();
    installTextAutoFlow();
    var verseReady = installVerseOrSayingField();
    var structuredEngravingReady = installStructuredEngravingFields();
    var proofReady = installProofApprovalField();
    var liftgateReady = installLiftgateField();
    installAdaptivePreviewSizing();
    var browserReady = hookBrowser();
    var pricingReady = installPricingOverrides();
    var vaseSnapReady = installVisibleVaseSnap();
    var bottomBaseReady = installBottomBaseLayout();
    var externalUploadReady = installExternalUploadAutoImport();
    if (verseReady && structuredEngravingReady && proofReady && liftgateReady && browserReady && pricingReady && vaseSnapReady && bottomBaseReady && externalUploadReady) return;
    initTries += 1;
    if (initTries > maxInitTries) {
      console.warn("[art_integration] Modal art browser not found after retries.");
      return;
    }
    setTimeout(startWhenReady, 250);
  }

  startWhenReady();
})();
